var extraDataCache = {};

document.addEventListener("DOMContentLoaded", function () {
  fetch("https://geolocation-db.com/json/")
    .then((response) => response.json())
    .then((data) => {
      var countryCode = data.country_code;
      if (countryCode) {
        handleCountryCode(countryCode);
      }
    })
    .catch((error) => {
      console.log('Geolocation service unavailable');
    });

  document.addEventListener("change", function (event) {
    var target = event.target;
    if (target && target.matches(".geolocation-country-picker")) {
      var selectedCountryCode = target.value;
      handleCountryCode(selectedCountryCode);
    }
  });

  function setAnnouncementBarColor() {
    var announcement = document.getElementById("FreeShippingBanner");
    if (announcement) {
      announcement.style.backgroundColor = "#051d5e";
    }
  }

  setAnnouncementBarColor();
  setInterval(setAnnouncementBarColor, 1000);
});

document.addEventListener("DOMContentLoaded", function () {
  // Scrollbar init
  jQuery(".scrollbar-macosx").scrollbar();
  // Function to read URL parameters
  function getQueryParam(param) {
    var queryParams = new URLSearchParams(window.location.search);
    return queryParams.get(param);
  }

  // Check if the 'menu' parameter is set to 'open'
  if (getQueryParam("menu") === "open") {
    // Mobile Menu Toggle
    const burger = document.getElementById("burger-button");
    if (burger) {
      // Check if the burger button exists
      document.body.classList.toggle("nav-open");
      document.body.classList.remove("subnav-open");
      burger.classList.toggle("open");
    }

    // Desktop Submenu Open
    // Assuming you want this to apply to the first submenu as an example
    var submenu = document.querySelector(".submenu-dk");
    if (submenu) {
      // Apply styles or add classes to mimic the hover state
      submenu.style.opacity = "1";
      submenu.style.visibility = "visible";
      submenu.style.height = "auto";
      submenu.style.paddingTop = "25px";
      submenu.style.paddingBottom = "25px";
      submenu.style.zIndex = "2"; // Ensure it's above other content

      // Overlay for the submenu, if applicable
      var overlay = document.querySelector(".submenu-dk__overlay");
      if (overlay) {
        overlay.style.opacity = "1";
        overlay.style.visibility = "visible";
        overlay.style.height = "100vh";
        overlay.style.width = "100%";
        overlay.style.position = "absolute";
        overlay.style.top = "100%";
        overlay.style.left = "0";
        overlay.style.background = "rgba(255, 255, 255, 0.75)";
        overlay.style.backdropFilter = "blur(5px)";
        overlay.style.zIndex = "1";
        overlay.style.pointerEvents = "none";
      }
    }
  }
});

async function addToCart(
  addId,
  lineItemColor,
  showStatus,
  reccId,
  compareAt = null,
  cartPage = false,
  frameName = null,
  isPreOrder = false,
  vForm,
  properties = {},
  quantity = 1
) {
  // let _preOrder = lineItemPreOrder;

  const addOns = vForm?.find("input[name='add-ons-products']");
  let formData = {
    items: [
      {
        id: addId,
        quantity,
        ...(isPreOrder
          ? { properties: { "Expected ship date": isPreOrder, ...properties } }
          : { properties }),
      },
      ...(addOns?.val() ? JSON.parse(addOns.val()) : []),
    ],
  };
  try {
    const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    if (compareAt) {
      formData.items[0].comparePrice = compareAt;
      if (!extraDataCache[addId]) {
        extraDataCache[addId] = {};
      }
      extraDataCache[addId].compare = compareAt;
    }
    if (frameName) {
      if (!extraDataCache[addId]) {
        extraDataCache[addId] = {};
      }
      formData.items[0].frame = frameName;
      extraDataCache[addId].frame = frameName;
    }

    return response.json();
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
}

window.addToCart = addToCart;
/****** GET RECOMMENDED PRODUCTS ******/
function getRelated(relatedId, loader, cartPage = false) {
  // Flag recommended products are loaded into cart
  ccShopify.recStatus = 1;
  // Show ajax cart loading placeholders
  $(".trending-products .product-item").hide();
  $(".trending-products .box-placeholder").show();
  // Show main cart loading placeholders
  // Recommendation Globals
  var qualifiedProducts = [];
  var flowRecommendedIds = [];
  var flowRecommendedCache;

  function fetchRecommendations() {
    return $.getJSON(
      "/recommendations/products.json?product_id=" + relatedId + "&limit=10"
    );
  }

  function parseRecommendations(response, textStatus, jqXHR) {
    var recommendedProducts = response.products;
    if (recommendedProducts.length > 0) {
      var z = 0;
      // Filter for qualfied products
      for (z = 0; z < recommendedProducts.length; z++) {
        var avCheck = recommendedProducts[z].available;
        var typeCheck = recommendedProducts[z].type;
        var variantsCheck = recommendedProducts[z].variants;
        var notCart = true;
        var q = 0;
        for (q = 0; q < ccShopify.latestCart.items.length; q++) {
          if (
            ccShopify.latestCart.items[q].product_id ==
            recommendedProducts[z].id
          ) {
            notCart = false;
          }
        }
        if (
          avCheck &&
          typeCheck != "Gift Card" &&
          typeCheck != "Dev Testing" &&
          notCart &&
          variantsCheck.length == 1
        ) {
          qualifiedProducts.push(recommendedProducts[z]);
          flowRecommendedIds.push(recommendedProducts[z].variants[0].id);
        } else if (avCheck && typeCheck == "RX") {
          qualifiedProducts.push(recommendedProducts[z]);
          flowRecommendedIds.push(recommendedProducts[z].variants[0].id);
        } else if (avCheck && typeCheck == "Readers") {
          qualifiedProducts.push(recommendedProducts[z]);
          flowRecommendedIds.push(recommendedProducts[z].variants[0].id);
        }
      }
      // Get localized pricing of qualified products if Flow Session as promise
      if (
        flowRecommendedIds.length > 0 &&
        typeof Geolocation.isLocalizationAvailable === "function" &&
        Geolocation.isLocalizationAvailable()
      ) {
        return new Promise((resolve, reject) => {
          // Replace this with your Geolocation app's method to load variants based on localization
          Geolocation.loadVariants({
            variants: flowRecommendedIds,
            // Assuming the Geolocation app has a method to get the current country or localization context
            country: Geolocation.getCurrentCountry(),
            success: function (status, variants) {
              resolve(variants);
            },
            error: function (error) {
              reject(error);
            },
          });
        });
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  function buildRecommedations(data) {
    if (data) {
      var i;
      var flowQualified = [];
      for (i = 0; i < qualifiedProducts.length; ++i) {
        var flowStatus = data[qualifiedProducts[i].variants[0].id].status;
        if (flowStatus == "included") {
          qualifiedProducts[i].price =
            data[qualifiedProducts[i].variants[0].id].prices.item.cents;
          if (data[qualifiedProducts[i].variants[0].id].prices.compare_at) {
            qualifiedProducts[i].compare_at_price =
              data[qualifiedProducts[i].variants[0].id].prices.compare_at.cents;
          }
          flowQualified.push(qualifiedProducts[i]);
        }
      }
      qualifiedProducts = flowQualified;
    }
    if (qualifiedProducts.length >= 4 && cartPage) {
      var p = 0;
      for (p = 0; p < 4; p++) {
        var badge;
        badge = buildBadge(qualifiedProducts[p]);
        var frameName = null;
        u = 0;
        for (u = 0; u < qualifiedProducts[p].tags.length; u++) {
          if (qualifiedProducts[p].tags[u].indexOf("frame::") >= 0) {
            frameName = qualifiedProducts[p].tags[u].replace("frame::", "");
          }
        }
      }
    }
    $(".trending-products .box-placeholder").hide();
    $(".trending-products .product-item").show();
  }

  // Create recommendations using promises
  fetchRecommendations()
    .then(parseRecommendations)
    .then(buildRecommedations)
    .catch((error) => {
      console.log(error);
    });
}
/****** REMOVE ITEM FROM CART ******/
function removeFromCart(removeId, newQuantity, cartPage = false) {
  $.post(
    "/cart/change.js",
    {
      quantity: newQuantity,
      id: removeId.replace("-", ":"),
    },
    function (data) {
      var response = data;
      if (newQuantity == 0) {
        $("#ccItem-" + removeId).remove();
      }
      getCart(cartPage);
      location.reload();
    },
    "json"
  );
}

const freeGiftAutoAdd = ccShopify.freeGiftAutoAdd;
const freeProductId = ccShopify.freeGiftProductId;
const freeGiftVariantId = ccShopify.freeGiftVariantId;
const freeGiftThreshold = ccShopify.freeGiftThreshold;
const freeGiftProductHandles = ccShopify.freeGiftProductHandles;
const rebuyUpsellProductTypes = ccShopify.rebuyUpsellProductTypes.split(";");
const rebuyUpsellProductTypes2 = ccShopify.rebuyUpsellProductTypes2.split(";");
const rebuyUpsellProductIsMain = ccShopify.rebuyUpsellProductIsMain;
const rebuyUpsellProductIsMain2 = ccShopify.rebuyUpsellProductIsMain2;
const rebuyUpsellID = ccShopify.rebuyUpsellID;
const rebuyUpsellID2 = ccShopify.rebuyUpsellID2;

/****** Function to handle variant option selection *****/

function handleAdaptVision(
  element,
  selectedOption,
  productId,
  variantId,
  isAvailable
) {
  if (!isAvailable) {
    return; // Do nothing if variant is not available
  }

  var variantOptions = document.querySelectorAll(
    '.readers_box[data-product-id="' + productId + '"]'
  );
  variantOptions.forEach(function (option) {
    option.classList.remove("active");
  });

  element.classList.add("active");

  var originalInput = document.querySelector(
    "#collection_product_form_" + productId + ' input[name="id"]'
  );

  if (originalInput) {
    var parentNode = originalInput.parentNode;

    if (parentNode) {
      var newInput = document.createElement("input");
      newInput.type = "hidden";
      newInput.name = "id";
      newInput.value = variantId;

      parentNode.removeChild(originalInput);
      parentNode.appendChild(newInput);
    } else {
      console.error("Parent Node Not Found");
    }
  } else {
    console.error("Original Input Not Found");
  }
}

function handleAdaptVision_PDP(
  element,
  selectedOption,
  productId,
  variantId,
  sectionId,
  isAvailable
) {
  if (!isAvailable) {
    return; // Do nothing if the variant is not available
  }

  var variantOptions = document.querySelectorAll(
    '.readers_box_PDP[data-product-id="' + productId + '"]'
  );
  variantOptions.forEach(function (option) {
    option.classList.remove("active");
  });

  element.classList.add("active");

  var originalInput = document.querySelector(
    "#product-form-" + sectionId + ' input[name="id"]'
  );

  if (originalInput) {
    var parentNode = originalInput.parentNode;

    if (parentNode) {
      var newInput = document.createElement("input");
      newInput.type = "hidden";
      newInput.name = "id";
      newInput.value = variantId;

      parentNode.removeChild(originalInput);
      parentNode.appendChild(newInput);
    } else {
      console.error(" Parent Node Not Found");
    }
  } else {
    console.error("Original Input Not Found");
  }
}

/****** PROCESS CART OR PRODUCT JSON ******/
function processCart(data, cartPage = false) {
  ccShopify.latestCart = data;

  function addFree(freeId = freeGiftVariantId) {
    addToCart(
      freeId,
      false,
      freeProductId,
      (compareAt = null),
      (cartPage = false),
      (frameName = null)
    );
  }

  $(".real-sub .ccr-totals").html(
    "<span>" + ccConvert(data.total_price, ccShopify.priceFormat) + "</span>"
  );
  $(".cart-price-header .ccr-totals").html(
    "<span>" + ccConvert(data.total_price, ccShopify.priceFormat) + "</span>"
  );
  $(".static-header__cart-item-count").text(data.item_count + " items");
  $("[data-cart-count]").attr("data-cart-count", data.item_count);
  $(".header-icons__icon-badge")
    .animate(
      { fontSize: "23px", minWidth: "25px", minHeight: "25px" },
      "ease-in-out"
    )
    .animate(
      { fontSize: "0.875rem", minWidth: "18px", minHeight: "18px" },
      "ease-in-out"
    );
  shippingMessage(data.total_price);

  let containsRX = false;
  data.items.forEach(function (item) {
    item.product_type == "RX" ? (containsRX = true) : null;
  });

  if (data.item_count > 0 && !containsRX) {
    $("#cc-real-cart-container").removeClass("cc-empty");
    $("#cc-shipping-status").removeClass("no-bt-lg");
    $(".info-prop-wrap__desktop").removeClass("hidden");
    $(".info-prop-wrap.mobile").removeClass("hidden");
    $(".real-checkout-button a").attr("href", "/checkout").text("CHECKOUT");
  } else if (containsRX) {
    $("#cc-real-cart-container").removeClass("cc-empty");
    $(".info-prop-wrap__desktop").addClass("hidden");
    $(".info-prop-wrap.mobile").addClass("hidden");
    $(".real-checkout-button a").attr("href", "/checkout").text("NEXT STEP");
  } else {
    $("#cc-real-cart-container").addClass("cc-empty");
    var continueS = $(".cart-sub-nav-bar__continue-shopping").attr("href");
    $(".real-checkout-button a")
      .attr("href", continueS)
      .text("CONTINUE SHOPPING");
  }

  if (freeProductId !== "" && freeGiftAutoAdd == "true") {
    var needFree = true;
  }
  var stepMessage = "Add promo code at checkout";
  var stepClass = "";
  var svProp = false;
  var readerProp = false;
  var sunProp = false;
  var blProp = false;
  var snowProp = false;
  var lensProp = false;

  var rxCheckoutLink = false;

  var ccItemsArray = data.items;

  var x;
  for (x = 0; x < ccItemsArray.length; x++) {
    if (ccItemsArray[x].product_title.indexOf("RX") !== -1) {
      stepMessage = "Prescription options at checkout";
      stepClass = "triggerRX";
      svProp = true;
      rxCheckoutLink = true;
    }
    if (ccItemsArray[x].product_title.indexOf("Reader") !== -1) {
      readerProp = true;
    }
    if (ccItemsArray[x].product_type == "Sunglasses") {
      sunProp = true;
    }
    if (ccItemsArray[x].product_type == "Blue Light") {
      blProp = true;
    }
    if (ccItemsArray[x].product_type == "Snow Goggles") {
      snowProp = true;
    }
    if (ccItemsArray[x].product_type == "Snow Lenses") {
      lensProp = true;
    }

    var itemCheck = document.getElementById(
      "ccItem-" + ccItemsArray[x].key.replace(":", "-")
    );
    if (ccItemsArray[x].variant_id == freeGiftVariantId) {
      needFree = false;
    }
    if (
      document.cookie
        .split(";")
        .some((item) => item.trim().startsWith("remove_GWP="))
    ) {
      needFree = false;
    }

    if (itemCheck) {
      $(".real-quantity input", itemCheck).val(ccItemsArray[x].quantity);
      itemCheck.setAttribute("cc-quant", ccItemsArray[x].quantity);
      if (ccItemsArray[x].line_level_discount_allocations.length > 0) {
        $(".cc-discount-title", itemCheck).html(
          ccItemsArray[x].line_level_discount_allocations[0]
            .discount_application.title
        );
        $(".cc-discount-title", itemCheck).show();
        $(".real-item-total", itemCheck)
          .addClass("sale")
          .html(
            "<span>" +
              ccConvert(ccItemsArray[x].final_price, ccShopify.priceFormat) +
              "</span><span>" +
              ccConvert(ccItemsArray[x].original_price, ccShopify.priceFormat) +
              "</span>"
          );
        $(itemCheck).attr(
          "cc-diff",
          ccItemsArray[x].original_price - ccItemsArray[x].final_price
        );
      } else if (ccItemsArray[x].discounts.length > 0) {
        if (ccItemsArray[x].discounts[0].title == "Buy One Get One Free") {
          $(".cc-discount-title", itemCheck).html("FREE!");
          $(".cc-discount-title", itemCheck).show();
          $(".real-item-total", itemCheck)
            .addClass("sale")
            .html(
              "<span>" +
                ccConvert(
                  ccItemsArray[x].original_line_price +
                    ccItemsArray[x].total_discount,
                  ccShopify.priceFormat
                ) +
                "</span><span>" +
                ccConvert(
                  ccItemsArray[x].original_price,
                  ccShopify.priceFormat
                ) +
                "</span>"
            );
          $(itemCheck).attr("cc-diff", ccItemsArray[x].total_discount * -1);
        } else if (
          ccItemsArray[x].discounts[0].title == "Buy One Get One 50% Off"
        ) {
          $(".cc-discount-title", itemCheck).html("50% OFF!");
          $(".cc-discount-title", itemCheck).show();
          $(".real-item-total", itemCheck)
            .addClass("sale")
            .html(
              "<span>" +
                ccConvert(
                  ccItemsArray[x].original_line_price +
                    ccItemsArray[x].total_discount,
                  ccShopify.priceFormat
                ) +
                "</span><span>" +
                ccConvert(
                  ccItemsArray[x].original_price,
                  ccShopify.priceFormat
                ) +
                "</span>"
            );
          $(itemCheck).attr("cc-diff", ccItemsArray[x].total_discount * -1);
        }
      }
    } else {
      var hideQuant = false;
      if (ccItemsArray[x].line_level_discount_allocations.length > 0) {
        if (
          ccItemsArray[x].line_level_discount_allocations[0]
            .discount_application.title == "FREE GIFT!"
        ) {
          hideQuant = true;
        }
      }

      var newCCItem = "";
      var classString = "real-item";
      if (hideQuant) {
        classString = "real-item hideQuant";
      }
      newCCItem +=
        '<li id="ccItem-' +
        ccItemsArray[x].key.replace(":", "-") +
        '" class="normal ' +
        classString +
        '" cc-product-id="' +
        ccItemsArray[x].product_id +
        '" cc-quant="' +
        ccItemsArray[x].quantity +
        '" cc-price="' +
        ccItemsArray[x].final_price +
        '" ';
      if (ccItemsArray[x].comparePrice) {
        newCCItem += 'cc-compare="' + ccItemsArray[x].comparePrice + '" ';
        var calcDiff =
          ccItemsArray[x].comparePrice - ccItemsArray[x].final_price;
        newCCItem += 'cc-diff="' + calcDiff + '"';
      } else if (
        ccItemsArray[x].line_level_discount_allocations.length == 0 &&
        ccItemsArray[x].discounts.length > 0
      ) {
        var calcDiff = ccItemsArray[x].total_discount * -1;
        newCCItem += 'cc-diff="' + calcDiff + '"';
      } else {
        var calcDiff =
          ccItemsArray[x].original_price - ccItemsArray[x].final_price;
        newCCItem += 'cc-diff="' + calcDiff + '"';
      }
      newCCItem += ">";
      newCCItem += '<div class="real-img">';
      newCCItem += '<img src="' + ccItemsArray[x].image + '">';
      newCCItem += "</div>";
      newCCItem += '<div class="real-details">';
      newCCItem +=
        '<h4 class="title"><a href="' +
        ccItemsArray[x].url +
        '">' +
        ccItemsArray[x].product_title +
        "</a>";
      if (
        ccItemsArray[x].variant_title &&
        ccItemsArray[x].variant_title !== ccItemsArray[x].product_title
      ) {
        newCCItem +=
          "<small>" +
          ccItemsArray[x].variant_title.replace(
            ccItemsArray[x].product_title + " - ",
            ""
          ) +
          "</small>";
      } else if (ccItemsArray[x].lens_type) {
        newCCItem += "<small>" + ccItemsArray[x].lens_type + "</small>";
      } else if (ccItemsArray[x].frame) {
        newCCItem += "<small>" + ccItemsArray[x].frame + "</small>";
      }
      newCCItem += "</h4>";
      if (ccItemsArray[x].line_level_discount_allocations.length > 0) {
        newCCItem +=
          '<p class="cc-discount-title">' +
          ccItemsArray[x].line_level_discount_allocations[0]
            .discount_application.title +
          "</p>";
      } else if (ccItemsArray[x].discounts.length > 0) {
        if (ccItemsArray[x].discounts[0].title == "Buy One Get One Free") {
          newCCItem += '<p class="cc-discount-title">FREE!</p>';
        } else if (
          ccItemsArray[x].discounts[0].title == "Buy One Get One 50% Off"
        ) {
          newCCItem += '<p class="cc-discount-title">50% OFF!</p>';
        }
      } else {
        newCCItem += '<p class="cc-discount-title" style="display:none;"></p>';
      }
      newCCItem += '<div class="real-summary">';
      newCCItem += '<div class="real-quantity">';
      newCCItem +=
        '<button class="item-dec" cc-id="' +
        ccItemsArray[x].key.replace(":", "-") +
        '"><svg class="minus icon " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="16" height="2" fill="none" viewBox="0 0 16 2">      <path fill-rule="evenodd" clip-rule="evenodd" d="M15 2H1a1 1 0 1 1 0-2h14a1 1 0 1 1 0 2z" fill="currentColor"></path>    </svg></button>';
      newCCItem +=
        '<input min="0" max="100" type="number" value="' +
        ccItemsArray[x].quantity +
        '">';
      newCCItem +=
        '<button class="item-inc" cc-id="' +
        ccItemsArray[x].key.replace(":", "-") +
        '"><svg class="plus icon " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">      <path fill-rule="evenodd" clip-rule="evenodd" d="M15 7H9V1a1 1 0 1 0-2 0v6H1a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0V9h6a1 1 0 1 0 0-2z" fill="currentColor"></path>    </svg></button>';
      newCCItem += "</div>";

      if (ccItemsArray[x].title.includes("RX")) {
        newCCItem +=
          '<p class="real-item-total"><span>' +
          ccConvert(ccItemsArray[x].final_price, ccShopify.priceFormat) +
          "</span></p>";
      } else {
        if (ccItemsArray[x].line_level_discount_allocations.length > 0) {
          newCCItem +=
            '<p class="real-item-total sale"><span>' +
            ccConvert(ccItemsArray[x].final_price, ccShopify.priceFormat) +
            "</span><span>" +
            ccConvert(ccItemsArray[x].original_price, ccShopify.priceFormat) +
            "</span></p>";
        } else if (ccItemsArray[x].discounts.length > 0) {
          newCCItem +=
            '<p class="real-item-total sale"><span>' +
            ccConvert(
              ccItemsArray[x].original_line_price +
                ccItemsArray[x].total_discount,
              ccShopify.priceFormat
            ) +
            "</span><span>" +
            ccConvert(ccItemsArray[x].original_price, ccShopify.priceFormat) +
            "</span></p>";
        } else if (
          ccItemsArray[x].comparePrice &&
          ccItemsArray[x].variant_title != "Polarized"
        ) {
          newCCItem +=
            '<p class="real-item-total sale"><span>' +
            ccConvert(ccItemsArray[x].final_price, ccShopify.priceFormat) +
            "</span><span>" +
            ccConvert(ccItemsArray[x].comparePrice, ccShopify.priceFormat) +
            "</span></p>";
        } else {
          newCCItem +=
            '<p class="real-item-total"><span>' +
            ccConvert(ccItemsArray[x].final_price, ccShopify.priceFormat) +
            "</span></p>";
        }
      }
      newCCItem += "</div>";
      newCCItem +=
        '<button class="delete-item" cc-id="' +
        ccItemsArray[x].key.replace(":", "-") +
        '">';
      newCCItem +=
        '<svg class="close icon " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14">      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.414 7l5.293-5.293A.999.999 0 1 0 12.293.293L7 5.586 1.707.293A.999.999 0 1 0 .293 1.707L5.586 7 .293 12.293a.999.999 0 1 0 1.414 1.414L7 8.414l5.293 5.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L8.414 7z" fill="currentColor"></path>    </svg>';
      newCCItem += " <span>Remove</span></button>";
      newCCItem += "</button>";
      newCCItem += ' <div class="confirm-delete">';
      newCCItem += '<div class="confirm-content">';
      newCCItem += '<p class="confirm-title">Remove from cart?</p>';
      if (
        ccItemsArray[x].variant_id == freeGiftVariantId &&
        ccItemsArray[x].discounts.length > 0
      ) {
        newCCItem +=
          '<p class="confirm-buttons"><button class="confirm-yes" cc-cookie="true">Yes</button><button class="confirm-no">No</button></p>';
      } else {
        newCCItem +=
          '<p class="confirm-buttons"><button class="confirm-yes">Yes</button><button class="confirm-no">No</button></p>';
      }
      newCCItem += "</div>";
      newCCItem += "</div>";
      newCCItem += "</div></li>";
      var cartItemList = document.getElementById("cc-real-items");
      cartItemList?.insertAdjacentHTML("afterbegin", newCCItem);
      $(document.body).trigger(
        "converter-update-elements",
        document.querySelectorAll(
          "#ccItem-" + ccItemsArray[x].key.replace(":", "-") + " .money"
        )
      );
    }
  }
  if (
    typeof Geolocation.isLocalizationAvailable === "function" &&
    Geolocation.isLocalizationAvailable()
  ) {
    setTimeout(function () {
      var savings = 0;
      $(".real-item").each(function () {
        if ($(this).attr("cc-diff")) {
          var quantMultiplier = parseInt($(this).attr("cc-quant"));
          savings =
            savings + parseInt($(this).attr("cc-diff")) * quantMultiplier;
        }
      });
      if (savings > 0) {
        $(".real-sub .ccr-totals")
          .append(
            "<span>" +
              ccConvert(data.total_price + savings, ccShopify.priceFormat) +
              "</span>"
          )
          .addClass("sale");
        $(".cart-price-header .ccr-totals")
          .append(
            "<span>" +
              ccConvert(data.total_price + savings, ccShopify.priceFormat) +
              "</span>"
          )
          .addClass("sale");
      } else {
        $(".real-sub .ccr-totals").removeClass("sale");
        $(".cart-price-header .ccr-totals").removeClass("sale");
      }
    }, 500);
  } else {
    var savings = 0;
    $(".real-item").each(function () {
      if ($(this).attr("cc-diff")) {
        var quantMultiplier = parseInt($(this).attr("cc-quant"));
        savings = savings + parseInt($(this).attr("cc-diff")) * quantMultiplier;
      }
    });
    if (savings > 0) {
      $(".real-sub .ccr-totals")
        .append(
          "<span>" +
            ccConvert(data.total_price + savings, ccShopify.priceFormat) +
            "</span>"
        )
        .addClass("sale");
      $(".cart-price-header .ccr-totals")
        .append(
          "<span>" +
            ccConvert(data.total_price + savings, ccShopify.priceFormat) +
            "</span>"
        )
        .addClass("sale");
    } else {
      $(".real-sub .ccr-totals").removeClass("sale");
      $(".cart-price-header .ccr-totals").removeClass("sale");
    }
  }

  var infoProps = "";
  if (readerProp || sunProp || blProp) {
    infoProps +=
      '<p class="info"><img src="https://cdn.shopify.com/s/files/1/0148/9585/files/Group.png?v=1588841102"> Includes microfiber pouch & sticker pack</p>';
  }
  if (svProp) {
    infoProps +=
      '<p class="info"><img src="https://cdn.shopify.com/s/files/1/0148/9585/files/Group.png?v=1588841102"> Includes EVA case & lens cloth</p>';
  }
  if (snowProp) {
    infoProps +=
      '<p class="info"><img src="https://cdn.shopify.com/s/files/1/0148/9585/files/Group.png?v=1588841102"> Includes bonus lens + EVA case</p>';
  }
  if (lensProp) {
    infoProps +=
      '<p class="info"><img src="https://cdn.shopify.com/s/files/1/0148/9585/files/Group.png?v=1588841102"> Includes Microfiber Pouch</p>';
  }
  infoProps +=
    '<p class="info"><img src="https://cdn.shopify.com/s/files/1/0148/9585/files/Group.png?v=1588841102"> Free returns within 45 days</p>';
  $(".info-prop-wrap").html(infoProps);
  $(".real-next-step a span").text(stepMessage);
  if (stepClass == "") {
    $(".triggerRX").removeClass("triggerRX");
  } else {
    $(".real-next-step a").addClass("triggerRX");
    $(".real-checkout-button a").addClass("triggerRX");
  }
  if (readerProp == false && svProp == false) {
    $(".rx-upsell").remove();
  }

  if (
    typeof Geolocation.isLocalizationAvailable === "function" &&
    Geolocation.isLocalizationAvailable()
  ) {
    Geolocation.localizeCart({ cart: data })
      .then(function (result) {
        // Handle successful localization
      })
      .catch(function (err) {
        console.log(err); // Error: "It broke"
      });
  } else {
    if (data.total_price >= ccShopify.freeGiftThreshold && needFree) {
      addFree();
    }
  }

  const removeFreeGiftBtn = document.querySelector('[cc-cookie="true"]');
  if (removeFreeGiftBtn) {
    removeFreeGiftBtn.addEventListener("click", function () {
      const date = new Date();
      date.setTime(date.getTime() + 600 * 1000); // Expiration time is set in seconds
      let expires = " expires=" + date.toUTCString();
      document.cookie = "remove_GWP=true;" + expires + "; path=/;";
    });
  }
}

function shippingMessage(totals) {
  if (
    typeof Geolocation.isLocalizationAvailable === "function" &&
    Geolocation.isLocalizationAvailable()
  ) {
    var threshold = ccShopify.shippingThreshold;
    if (threshold == 0) {
      $("#cc-shipping-status .shipping-text").text(
        "Free Shipping on All Orders!"
      );
      $("#cc-shipping-status").addClass("success");
    }
    if (totals >= threshold) {
      $("#cc-shipping-status .cc-bar .cc-bar-fill").css("width", "100%");
      $("#cc-shipping-status").removeClass("progress");
      $("#cc-shipping-status").addClass("success");
    } else {
      $("#cc-shipping-status").removeClass("success");
      $("#cc-shipping-status").addClass("progress");
      var remaining = threshold - totals;
      var newWidth = (totals / threshold) * 100;
      if (newWidth > 100) {
        newWidth = "100%";
      } else {
        if (newWidth != 0) {
          newWidth = newWidth + "%";
        }
      }
      $("#cc-shipping-status .cc-bar .cc-bar-fill").css("width", newWidth);
      $(".cc-bar-m span").html(
        "<span>" + ccConvert(remaining, ccShopify.priceFormat) + "</span>"
      );
    }
  } else {
    const freeShipping = Number(ccShopify.shippingThreshold);
    const freeShipping2Day = Number(ccShopify.freeShipping2DayThreshold);
    const totalTthreshold = Number(freeShipping + freeShipping2Day);
    const cartMessage = document.querySelector(".cc-bar-m--drawer");
    const shippingStatusBar = document.querySelector("#cc-shipping-status");
    const barFill = document.querySelector(".cc-bar-fill");

    if (totals >= totalTthreshold && freeShipping2Day > 0) {
      if (cartMessage)
        cartMessage.textContent =
          "SCORE! YOU JUST UNLOCKED FREE 2-Day SHIPPING!";
      shippingStatusBar?.classList.add("success");
    } else if (totalTthreshold == 0) {
      if (cartMessage) cartMessage.textContent = "Free Shipping on All Orders!";
      shippingStatusBar?.classList.add("success");
    } else {
      shippingStatusBar?.classList.remove("success");

      if (totals > freeShipping && freeShipping2Day == 0) {
        if (cartMessage)
          cartMessage.textContent = "SCORE! YOU JUST UNLOCKED FREE SHIPPING!";
        shippingStatusBar?.classList.add("success");
      } else if (totals < freeShipping) {
        let remaining = freeShipping - totals;
        if (cartMessage)
          cartMessage.textContent =
            "YOU'RE SO CLOSE! ADD " +
            ccConvert(remaining, ccShopify.priceFormat) +
            " TO UNLOCK FREE SHIPPING!";
        shippingStatusBar?.classList.remove("free-ship-unlocked");
      } else {
        shippingStatusBar?.classList.add("free-ship-unlocked");
        let remaining = totalTthreshold - totals;
        if (cartMessage)
          cartMessage.textContent =
            "SCORE! ADD " +
            ccConvert(remaining, ccShopify.priceFormat) +
            " FOR FREE 2-DAY SHIPPING!";
      }

      let newWidth = (totals / totalTthreshold) * 100;
      if (newWidth < 100) {
        newWidth = newWidth + "%";
      } else {
        newWidth = "100%";
      }
      if (barFill) {
        barFill.style.width = newWidth;
      }
    }
  }
}

/****** GET CART JSON ******/
function getCart(cartPage = false) {
  $.get(
    "/cart.js",
    function (data) {
      if (
        typeof Geolocation.isLocalizationAvailable === "function" &&
        Geolocation.isLocalizationAvailable()
      ) {
        setTimeout(function () {
          Flow.variants.localize({ force: true });
        }, 600);
        var tester = Flow.cart.getShopifyLocalizedCart({
          cart: data,
        });
        tester.then(
          function (result) {
            var response = result.cart;
            var convertedItems = response.items;
            var xy;
            for (xy = 0; xy < convertedItems.length; xy++) {
              var variantID = convertedItems[xy].id;
              var yy;
              for (yy = 0; yy < data.items.length; yy++) {
                if (data.items[yy].id == variantID) {
                  response.items[xy].product_type = data.items[yy].product_type;
                  break;
                }
              }
            }
            $("#cc-real-items li").remove();
            $("#cc-cartItem li").remove();
            var x = 0;
            for (x = 0; x < response.items.length; x++) {
              var y = x;
              $.ajax({
                url: "/products/" + response.items[y].handle + ".js",
                async: false,
                dataType: "json",
                success: function (product) {
                  if (!extraDataCache[response.items[y].id]) {
                    extraDataCache[response.items[y].id] = {};
                  }
                  if (product.compare_at_price) {
                    response.items[y].comparePrice = product.compare_at_price;
                    extraDataCache[response.items[y].id].compare =
                      product.compare_at_price;
                  }
                  u = 0;
                  for (u = 0; u < product.tags.length; u++) {
                    if (product.tags[u].indexOf("frame::") >= 0) {
                      frameName = product.tags[u].replace("frame::", "");
                      response.items[y].frame = frameName;
                      extraDataCache[response.items[y].id].frame = frameName;
                    }
                  }
                  if (product.tags.includes("lens-type::Polarized")) {
                    let lensType = "Polarized";
                    response.items[y].lens_type = lensType;
                    extraDataCache[response.items[y].id].lens_type = lensType;
                  }
                  if (product.tags.includes("lens-type::Non-Polarized")) {
                    let lensType = "Non-Polarized";
                    response.items[y].lens_type = lensType;
                    extraDataCache[response.items[y].id].lens_type = lensType;
                  }
                },
              });
              if (extraDataCache[response.items[y].id]) {
                if (
                  extraDataCache[response.items[y].id].hasOwnProperty("compare")
                ) {
                  response.items[y].comparePrice =
                    extraDataCache[response.items[y].id].compare;
                }
                if (
                  extraDataCache[response.items[y].id].hasOwnProperty("frame")
                ) {
                  response.items[y].frame =
                    extraDataCache[response.items[y].id].frame;
                }
              }
            }
            processCart(response, cartPage);
          },
          function (err) {
            console.log(err); // Error: "It broke"
          }
        );
      } else {
        var response = data;
        $("#cc-real-items li").remove();
        $("#cc-cartItem li").remove();
        var x = 0;
        for (x = 0; x < response.items.length; x++) {
          var y = x;
          $.ajax({
            url: "/products/" + response.items[y].handle + ".js",
            async: false,
            dataType: "json",
            success: function (product) {
              if (!extraDataCache[response.items[y].id]) {
                extraDataCache[response.items[y].id] = {};
              }
              if (product.compare_at_price) {
                response.items[y].comparePrice = product.compare_at_price;
                extraDataCache[response.items[y].id].compare =
                  product.compare_at_price;
              }
              u = 0;
              for (u = 0; u < product.tags.length; u++) {
                if (product.tags[u].indexOf("frame::") >= 0) {
                  frameName = product.tags[u].replace("frame::", "");
                  response.items[y].frame = frameName;
                  extraDataCache[response.items[y].id].frame = frameName;
                }
              }
              if (product.tags.includes("lens-type::Polarized")) {
                let lensType = "Polarized";
                response.items[y].lens_type = lensType;
                extraDataCache[response.items[y].id].lens_type = lensType;
              }
              if (product.tags.includes("lens-type::Non-Polarized")) {
                let lensType = "Non-Polarized";
                response.items[y].lens_type = lensType;
                extraDataCache[response.items[y].id].lens_type = lensType;
              }
              /*if (product.tags.includes("frame-type::DX")) {
							let lensType = 'DX Polarized';
							response.items[y].lens_type = lensType;
							extraDataCache[response.items[y].id].lens_type = lensType;
						} */
            },
          });
        }
        processCart(response, cartPage);
      }
    },
    "json"
  );
}

function getFullCart(cartPage = false) {
  var response = ccShopify.latestCart;
  if ($("#cc-real-items").length) {
    $("#cc-real-items li").remove();
    cartPage = true;
  }
  $("#cc-cartItem li").remove();
  var x = 0;
  for (x = 0; x < response.items.length; x++) {
    var y = x;
    $.ajax({
      url: "/products/" + response.items[y].handle + ".js",
      async: false,
      dataType: "json",
      success: function (product) {
        if (!extraDataCache[response.items[y].id]) {
          extraDataCache[response.items[y].id] = {};
        }
        if (product.compare_at_price) {
          response.items[y].comparePrice = product.compare_at_price;
          extraDataCache[response.items[y].id].compare =
            product.compare_at_price;
        }
        u = 0;
        for (u = 0; u < product.tags.length; u++) {
          if (product.tags[u].indexOf("frame::") >= 0) {
            frameName = product.tags[u].replace("frame::", "");
            response.items[y].frame = frameName;
            extraDataCache[response.items[y].id].frame = frameName;
          }
          if (product.tags.includes("lens-type::Polarized")) {
            let lensType = "Polarized";
            response.items[y].lens_type = lensType;
            extraDataCache[response.items[y].id].lens_type = lensType;
          }
          if (product.tags.includes("lens-type::Non-Polarized")) {
            let lensType = "Non-Polarized";
            response.items[y].lens_type = lensType;
            extraDataCache[response.items[y].id].lens_type = lensType;
          }
        }
      },
    });
  }
  processCart(response, cartPage);
}

function getFullGeolocationCart(cartPage = false) {
  var fullCartIds = [];
  var i;
  for (i = 0; i < ccShopify.latestCart.items.length; i++) {
    fullCartIds.push(ccShopify.latestCart.items[i].variant_id);
    $.ajax({
      url: "/products/" + ccShopify.latestCart.items[i].handle + ".js",
      async: false,
      dataType: "json",
      success: function (product) {
        if (!extraDataCache[ccShopify.latestCart.items[i].id]) {
          extraDataCache[ccShopify.latestCart.items[i].id] = {};
        }
        if (product.compare_at_price) {
          ccShopify.latestCart.items[i].comparePrice = product.compare_at_price;
          extraDataCache[ccShopify.latestCart.items[i].id].compare =
            product.compare_at_price;
        }

        if (product.tags.includes("lens-type::Polarized")) {
          let lensType = "Polarized";
          ccShopify.latestCart.items[i].lens_type = lensType;
          extraDataCache[ccShopify.latestCart.items[i].id].lens_type = lensType;
        }
        if (product.tags.includes("lens-type::Non-Polarized")) {
          let lensType = "Non-Polarized";
          ccShopify.latestCart.items[i].lens_type = lensType;
          extraDataCache[ccShopify.latestCart.items[i].id].lens_type = lensType;
        }
      },
    });
  }

  // Simulate the localization and currency conversion process
  // For demonstration purposes, we assume a function getLocalizedCartData is implemented
  getLocalizedCartData(fullCartIds)
    .then((data) => {
      data = simulateLocalizedVariants(fullCartIds); // Replace this with actual implementation
      for (var d = 0; d < data.length; d++) {
        if (!extraDataCache[data[d].id]) {
          extraDataCache[data[d].id] = {};
        }
        if (data[d].prices.compare_at) {
          extraDataCache[data[d].id].compare = data[d].prices.compare_at.cents;
        }
      }
    })
    .catch((error) => {
      console.log(error);
    });

  // Example function to simulate localized data retrieval
  function getLocalizedCartData(cartIds) {
    return new Promise((resolve, reject) => {
      // Simulate API call for localized data
      setTimeout(() => {
        // Simulated data
        resolve({
          shopify: {
            cart: {
              items: cartIds.map((id) => ({
                id: id,
                comparePrice: 1000, // Example price
                frame: "example_frame",
                lens_type: "Polarized",
              })),
            },
          },
          flow: {
            order: {
              promotions: {
                available: [],
                applied: [],
              },
            },
          },
        });
      }, 1000);
    });
  }

  function simulateLocalizedVariants(cartIds) {
    return cartIds.map((id) => ({
      id: id,
      prices: {
        compare_at: {
          cents: 1000, // Example price
        },
      },
    }));
  }

  // Update shipping threshold logic
  var newThreshold = 5000; // Example value, adjust based on your logic

  ccShopify.shippingThreshold = newThreshold;
  if (newThreshold == null) {
    $("#cc-ajax-cart").addClass("no-shipping");
    $("#cc-real-info").addClass("no-shipping");
  } else {
    $("#cc-ajax-cart").removeClass("no-shipping");
    $("#cc-real-info").removeClass("no-shipping");
    $("#cc-real-info #cc-shipping-status").show();
  }
  if ($("#cc-real-items").length) {
    $("#cc-real-items li").remove();
    cartPage = true;
  }
  $("#cc-cartItem li").remove();

  // Process localized cart items
  processCart(
    {
      items: fullCartIds.map((id) => ({
        id: id,
        comparePrice: extraDataCache[id] ? extraDataCache[id].compare : 1000, // Example price
        frame: "example_frame",
        lens_type: extraDataCache[id]
          ? extraDataCache[id].lens_type
          : "Polarized",
      })),
    },
    cartPage
  );
}

/**
 * Converts a currency amount to a formatted string based on the specified format.
 *
 * @param {number|string} money - The currency amount to convert.
 * @param {string} format - The format to use for conversion.
 * @returns {string} The formatted currency amount.
 */
function ccConvert(money, format) {
  if (Geolocation.isLocalizationAvailable && Geolocation.getExperience()) {
    format = "{{geolocation_amount}}";
  }
  /**
   * Formats a currency amount with the specified number of decimals, thousands separator, and decimal separator.
   *
   * @param {number} amount - The currency amount to format.
   * @param {number} decimals - The number of decimal places to include in the formatted currency.
   * @param {string} thousandsSeparator - The character used as the thousands separator in the formatted currency.
   * @param {string} decimalSeparator - The character used as the decimal separator in the formatted currency.
   * @returns {string} The formatted currency amount.
   */
  function formatCurrency(
    amount,
    decimals = 2,
    thousandsSeparator = ",",
    decimalSeparator = "."
  ) {
    if (isNaN(amount) || null == amount) return 0;
    amount = (amount / 100).toFixed(decimals);
    var parts = amount.split(".");
    if (parts.length === 1) {
      return amount.replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousandsSeparator
      );
    } else {
      const decimal = parseFloat(`.${parts[1]}`).toString().slice(2);
      return `${parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousandsSeparator
      )}${decimal ? decimalSeparator + decimal : ""}`;
    }
  }

  function formatCurrencyWithDecimals(cents, decimals) {
    if (decimals > 0) {
      cents = String(cents);
      return parseFloat(
        cents.substring(0, cents.length - decimals) +
          "." +
          cents.substring(cents.length - decimals)
      );
    } else {
      return cents;
    }
  }
  "string" == typeof money && (money = money.replace(".", ""));
  var formattedAmount = "",
    o = /\{\{\s*(\w+)\s*\}\}/;
  switch (format.match(o)[1]) {
    case "geolocation_amount":
      formattedAmount = formatCurrencyWithDecimals(
        money,
        Flow.session.getSession().geo.currency.number_decimals
      );
      break;
    case "amount":
      formattedAmount = formatCurrency(money, 3);
      break;
    case "amount_one_decimals":
      if (money >= 100 && money % 100 === 0) {
        formattedAmount = formatCurrency(money, 0);
      } else {
        formattedAmount = formatCurrency(money, 1);
      }
      break;
    case "amount_no_decimals":
      formattedAmount = formatCurrency(money, 0);
      break;
    case "amount_with_comma_separator":
      formattedAmount = formatCurrency(money, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      formattedAmount = formatCurrency(money, 0, ".", ",");
      break;
    case "amount_with_space_separator":
      formattedAmount = formatCurrency(money, 2, ".", " ");
      break;
    case "amount_no_decimals_with_space_separator":
      formattedAmount = formatCurrency(money, 0, ".", " ");
      break;
  }
  if (Geolocation.isLocalizationAvailable && Geolocation.getExperience()) {
    var preFlow = Geolocation.formatCurrency(
      format.replace(o, formattedAmount)
    ).replace(".00", "");
    return preFlow;
  } else {
    return format.replace(o, formattedAmount);
  }
}

/****** RECOMMENDATIONS BADGE GENERATOR ******/
function buildBadge(productBadge) {
  var tagList = productBadge.tags;
  var PRODUCT_IS_SALE = false;
  var PRODUCT_IS_LOW_STOCK = false;
  var PRODUCT_IS_NEW = false;
  if (productBadge.compare_at_price > productBadge.price) {
    PRODUCT_IS_SALE = true;
  }
  var item_badge_comingsoon = false;
  var item_badge_finalsale = false;
  var item_badge_hot = false;
  var item_badge_limited = false;
  var item_badge_lowstock = false;
  var item_badge_new = false;
  var item_badge_sale = false;
  var item_badge_soldout = false;
  var item_badge_kab_ribbon = false;
  var item_badge_regular_fit = false;
  var item_badge_oversized_fit = false;
  var item_badge_20_off = false;
  var item_badge_30_off = false;
  var item_badge_35_off = false;
  var item_badge_40_off = false;
  var item_badge_50_off = false;
  var item_badge_bluelight = false;
  var item_badge_rx = false;
  var item_badge_readers = false;
  var item_badge_bonuslens = false;
  var item_badge_reversible = false;
  var item_badge_bogo = false;
  var item_badge_bogo_50 = false;
  var item_badge_limited_heart = false;
  var item_badge_limited_clover = false;
  var item_badge_be_kind = false;

  var b = 0;
  for (b = 0; b < tagList.length; b++) {
    var tag = tagList[b];
    if (tag == "badge::coming-soon") {
      item_badge_comingsoon = true;
    }
    if (tag == "badge::save-20") {
      item_badge_20_off = true;
    }
    if (tag == "badge::30-off") {
      item_badge_30_off = true;
    }
    if (tag == "badge::35-off") {
      item_badge_35_off = true;
    }
    if (tag == "badge::40-off") {
      item_badge_40_off = true;
    }
    if (tag == "badge::50-off") {
      item_badge_50_off = true;
    }
    if (tag == "badge::final-sale") {
      item_badge_finalsale = true;
    }
    if (tag == "badge::hot") {
      item_badge_hot = true;
    }
    if (tag == "badge::limited") {
      item_badge_limited = true;
    }
    if (tag == "badge::low-stock") {
      item_badge_lowstock = true;
    }
    if (tag == "badge::new") {
      item_badge_new = true;
    }
    if (tag == "badge::sale") {
      item_badge_sale = true;
    }
    if (tag == "badge::kab-ribbon") {
      item_badge_kab_ribbon = true;
    }
    if (tag == "badge::regular-fit") {
      item_badge_regular_fit = true;
    }
    if (tag == "badge::oversized-fit") {
      item_badge_oversized_fit = true;
    }
    if (tag == "badge::bluelight") {
      item_badge_bluelight = true;
    }
    if (tag == "badge::rx") {
      item_badge_rx = true;
    }
    if (tag == "badge::readers") {
      item_badge_readers = true;
    }
    if (tag == "badge::reversible") {
      item_badge_reversible = true;
    }
    if (tag == "badge::bogo") {
      item_badge_bogo = true;
    }
    if (tag == "badge::bogo-50") {
      item_badge_bogo_50 = true;
    }
    if (tag == "badge::limited-heart") {
      item_badge_limited_heart = true;
    }
    if (tag == "badge::limited-clover") {
      item_badge_limited_clover = true;
    }
    if (tag == "badge::be-kind") {
      item_badge_be_kind = true;
    }
  }
  var icon_id = "";
  if (item_badge_kab_ribbon) {
    icon_id = "badge-kab-ribbon";
  } else if (item_badge_comingsoon) {
    icon_id = "badge-coming-soon";
  } else if (item_badge_20_off) {
    icon_id = "badge-20-off";
  } else if (item_badge_30_off) {
    icon_id = "badge-30-off";
  } else if (item_badge_35_off) {
    icon_id = "badge-35-off";
  } else if (item_badge_40_off) {
    icon_id = "badge-40-off";
  } else if (item_badge_50_off) {
    icon_id = "badge-50-off";
  } else if (item_badge_bluelight) {
    icon_id = "badge-bluelight";
  } else if (item_badge_rx) {
    icon_id = "badge-rx";
  } else if (item_badge_readers) {
    icon_id = "badge-readers";
  } else if (item_badge_regular_fit) {
    icon_id = "badge-regular-fit";
  } else if (item_badge_oversized_fit) {
    icon_id = "badge-oversized-fit";
  } else if (item_badge_reversible) {
    icon_id = "badge-reversible";
  } else if (item_badge_soldout) {
    icon_id = "badge-sold-out";
  } else if (item_badge_finalsale) {
    icon_id = "badge-final-sale";
  } else if (item_badge_hot) {
    icon_id = "badge-hot";
  } else if (item_badge_sale || PRODUCT_IS_SALE) {
    icon_id = "badge-sale";
  } else if (item_badge_lowstock) {
    icon_id = "badge-low-stock";
  } else if (item_badge_limited) {
    icon_id = "badge-limited";
  } else if (item_badge_new) {
    icon_id = "badge-new";
  } else if (item_badge_bogo) {
    icon_id = "badge-bogo";
  } else if (item_badge_bogo_50) {
    icon_id = "badge-bogo-50";
  } else if (item_badge_limited_heart) {
    icon_id = "badge-limited-heart";
  } else if (item_badge_limited_clover) {
    icon_id = "badge-limited-clover";
  } else if (item_badge_be_kind) {
    icon_id = "badge-be-kind";
  }
  var returnBadge = "";

  if (icon_id == "badge-hot") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="28" height="24" fill="none" viewBox="0 0 28 24">' +
      '      <path d="M3.096 21.332a3.05 3.05 0 0 1-.076-1.12c.037-.401.137-.624.3-.668.721-.195 3.107-.426 7.157-.691 4.054-.267 7.644-.436 10.769-.507.181-.012.304.102.368.34.075.276.079.648.012 1.115-.066.471-.223.74-.469.807a1.973 1.973 0 0 1-.503.05 7.612 7.612 0 0 1-.672-.023 7.43 7.43 0 0 0-.473-.02c-1.703-.011-4.407.126-8.111.41-3.703.29-6.229.553-7.576.79-.101.028-.18.045-.235.05a.379.379 0 0 1-.178-.03.357.357 0 0 1-.179-.164 1.298 1.298 0 0 1-.134-.339zM10.831 6.127c.223 0 .492.212.807.636.319.424.478.765.478 1.025 0 .132-.05.207-.15.226a51.03 51.03 0 0 0-3.555.656 71.316 71.316 0 0 0-.998 6.193.607.607 0 0 1 .144.363c0 .104-.08.291-.24.56-.063.091-.2.137-.41.137-.355 0-.752-.114-1.19-.342-.437-.228-.642-.449-.614-.663.268-1.95.576-3.85.922-5.701-1.157.31-1.827.492-2.01.547a90.144 90.144 0 0 0-.8 4.928c-.017.15-.19.226-.519.226-.373 0-.745-.082-1.114-.246-.37-.164-.554-.321-.554-.472 0-.437.23-1.809.69-4.115a2.807 2.807 0 0 1-.512-.69c-.155-.288-.232-.51-.232-.67 0-.073.036-.123.109-.15.497-.16.834-.263 1.012-.308.56-2.671 1.032-4.464 1.415-5.38.036-.091.148-.137.335-.137.31 0 .663.112 1.06.335.396.223.594.437.594.643 0 .027-.01.066-.027.116-.32.925-.657 2.18-1.012 3.766l.991-.246c.451-.11.784-.191.998-.246.42-1.996.839-3.55 1.258-4.662.036-.091.125-.137.267-.137.31 0 .7.121 1.169.363.474.241.71.469.71.683a.376.376 0 0 1-.034.157c-.3.684-.617 1.7-.95 3.05a93.492 93.492 0 0 1 1.71-.363.43.43 0 0 1 .252-.082zm3.507-2.803a3.37 3.37 0 0 1 2.386.95c.674.634 1.011 1.452 1.011 2.455 0 .81-.12 1.695-.362 2.652-.242.957-.56 1.852-.957 2.686-.396.834-.889 1.532-1.476 2.092-.588.56-1.195.841-1.819.841-.56 0-1.112-.19-1.654-.567-.543-.379-.898-.83-1.067-1.354-.14-.42-.21-.973-.205-1.661 0-1.062.148-2.23.445-3.507.3-1.276.567-2.087.8-2.433.054-.092.17-.137.348-.137.114 0 .264.023.451.068a3.79 3.79 0 0 1 .848-1.463c.387-.414.804-.622 1.25-.622zm.615 5.995c.347-1.194.52-2.324.52-3.39 0-.456-.04-.82-.117-1.094-.355.232-.656.588-.902 1.066-.246.474-.369.916-.369 1.327 0 .054.004.12.014.198.009.073.013.12.013.143 0 .105-.089.155-.266.15-.169 0-.392-.045-.67-.136-.515 1.782-.773 3.26-.773 4.437 0 .651.066 1.137.199 1.456.989-.725 1.772-2.11 2.351-4.157zM25.96 2.401c.196 0 .444.24.745.718.305.474.458.823.458 1.046 0 .242-.127.362-.383.362a.456.456 0 0 1-.239-.082c-.082-.054-.141-.082-.178-.082a9.65 9.65 0 0 0-.464.041c-.27.028-.682.085-1.238.171a30.76 30.76 0 0 0-1.64.287 53.549 53.549 0 0 0-1.586 6.03c-.42 2.087-.63 3.42-.63 3.999 0 .054.021.125.062.211a.662.662 0 0 1 .062.274c0 .287-.2.433-.602.438-.383 0-.802-.11-1.258-.329-.455-.218-.683-.442-.683-.67 0-.464.216-1.695.65-3.691.432-2 .897-3.858 1.394-5.571a12.81 12.81 0 0 0-1.531.588 3.27 3.27 0 0 0-.15.082c-.065.036-.122.063-.172.082a.442.442 0 0 1-.164.027c-.196 0-.488-.21-.875-.629-.387-.42-.58-.709-.58-.868 0-.105.063-.19.19-.253.661-.328 2.227-.772 4.697-1.333 2.474-.565 3.846-.848 4.115-.848z" fill="currentColor"/>' +
      "    </svg>";
  }

  if (icon_id == "badge-new") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="29" height="24" fill="none" viewBox="0 0 29 24">' +
      '      <path d="M5.096 21.332a3.05 3.05 0 0 1-.076-1.12c.037-.401.137-.624.3-.668.721-.195 3.107-.426 7.157-.691 4.054-.267 7.644-.436 10.769-.507.181-.012.304.102.368.34.075.276.079.648.012 1.115-.066.471-.223.74-.469.807a1.973 1.973 0 0 1-.503.05 7.612 7.612 0 0 1-.672-.023 7.43 7.43 0 0 0-.473-.02c-1.703-.011-4.407.126-8.111.41-3.703.29-6.229.553-7.576.79-.101.028-.18.045-.235.05a.379.379 0 0 1-.178-.03.357.357 0 0 1-.179-.164 1.298 1.298 0 0 1-.134-.339zM2.297 15.321c-.356 0-.732-.095-1.128-.287-.397-.191-.595-.39-.595-.595 0-.88.27-2.556.807-5.03.538-2.48 1.048-4.522 1.531-6.126.037-.114.173-.17.41-.17.31 0 .654.084 1.032.252.383.169.588.342.616.52.346 2.36.752 4.311 1.217 5.851.3-1.64.612-3.17.936-4.587.328-1.421.554-2.274.677-2.556.054-.132.184-.196.39-.192.328 0 .724.126 1.189.376.47.251.704.474.704.67 0 .037-.01.075-.027.116a.467.467 0 0 1-.09.117.382.382 0 0 0-.068.095c-.364.643-.838 2.274-1.421 4.895-.584 2.616-.935 4.53-1.053 5.742-.01.132-.164.198-.465.198-.31 0-.647-.07-1.012-.212-.36-.14-.579-.31-.656-.505-.123-.301-.365-1.165-.725-2.591a83.768 83.768 0 0 1-.758-3.247c-.196.756-.415 1.825-.657 3.206-.241 1.38-.362 2.436-.362 3.165 0 .15.01.287.027.41.019.118.028.187.028.205 0 .073-.05.137-.15.191a.751.751 0 0 1-.397.09zM20.31 3.38c.241.374.362.668.362.882 0 .177-.13.266-.39.266-.588 0-1.476.094-2.666.28a28.82 28.82 0 0 0-3.61.814c-.259.693-.537 1.654-.833 2.885.524-.169.832-.253.923-.253.196 0 .46.187.793.56.337.374.506.668.506.882 0 .105-.041.16-.123.164-.857.15-1.72.408-2.591.773-.214 1.085-.344 1.877-.39 2.379a21.118 21.118 0 0 1 1.634-.67.477.477 0 0 1 .225-.198 1.79 1.79 0 0 1 .602-.11c.26 0 .535.198.827.595.296.396.444.72.444.97 0 .115-.04.18-.123.199-1.65.42-2.976.96-3.978 1.62a.366.366 0 0 1-.178.075c-.223 0-.503-.132-.84-.396-.338-.26-.595-.524-.773-.793-.073-.123-.11-.34-.11-.65 0-.738.162-1.864.486-3.377a57.703 57.703 0 0 1 1.08-4.252 2.573 2.573 0 0 1-.595-.601c-.173-.242-.26-.447-.26-.615 0-.133.053-.217.158-.253 1.016-.401 2.492-.816 4.43-1.244 1.936-.429 3.265-.643 3.985-.643.123 0 .22.01.294.027.073.019.17.082.294.192.127.105.266.269.417.492zm4.286 12.195c-.374 0-.78-.084-1.217-.253-.438-.168-.656-.364-.656-.588 0-.15.018-.373.054-.67-.187-1.317-.335-2.866-.444-4.648-.365.66-.788 1.51-1.271 2.55-.479 1.034-.77 1.784-.876 2.249 0 .141-.006.241-.02.3a.251.251 0 0 1-.11.144c-.059.041-.154.062-.287.062-.25 0-.565-.066-.943-.199-.378-.136-.638-.28-.78-.43-.122-.132-.184-.328-.184-.588 0-.105.012-.267.035-.485.027-.22.04-.374.04-.465 0-1.436.123-3.117.37-5.045.246-1.932.524-3.286.834-4.06.045-.124.143-.183.294-.178.319 0 .701.13 1.148.39.447.259.634.498.56.717-.241.702-.448 1.55-.622 2.543-.173.989-.289 1.891-.348 2.707.898-1.85 1.584-3.13 2.058-3.842.054-.082.157-.123.307-.123.26 0 .567.091.923.274.355.182.533.362.533.54 0 1.914.03 3.187.089 3.82.232-.856.643-2.084 1.23-3.684.588-1.604 1.06-2.77 1.416-3.5a.31.31 0 0 1 .307-.177c.3 0 .684.123 1.149.369.464.246.697.537.697.875 0 .223-.094.367-.28.43-.793 1.55-1.536 3.339-2.229 5.367-.688 2.023-1.121 3.828-1.299 5.414-.009.123-.168.184-.478.184z" fill="currentColor"/>' +
      "    </svg>";
  }

  if (icon_id == "badge-sale") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="34" height="24" fill="none" viewBox="0 0 34 24">' +
      '      <path d="M7.096 21.332a3.05 3.05 0 0 1-.076-1.12c.037-.401.137-.624.3-.668.721-.195 3.107-.426 7.157-.691 4.054-.267 7.644-.436 10.769-.507.181-.012.304.102.368.34.075.276.079.648.012 1.115-.066.471-.223.74-.469.807a1.973 1.973 0 0 1-.503.05 7.612 7.612 0 0 1-.672-.023 7.43 7.43 0 0 0-.473-.02c-1.703-.011-4.407.126-8.111.41-3.703.29-6.229.553-7.576.79-.101.028-.18.045-.235.05a.379.379 0 0 1-.178-.03.357.357 0 0 1-.179-.164 1.298 1.298 0 0 1-.134-.339zM4.864 15.28c-1.112 0-2.05-.421-2.816-1.264-.761-.848-1.142-1.878-1.142-3.09 0-.25.023-.531.069-.841.027-.205.232-.308.615-.308.374 0 .759.091 1.155.274.397.182.595.38.595.595l-.007.15c-.005.087-.007.17-.007.253 0 .606.132 1.173.397 1.702.269.529.608.873 1.018 1.032.242-.214.363-.535.363-.964 0-.474-.208-1.24-.623-2.296-.414-1.058-.827-2.108-1.237-3.152-.41-1.048-.615-1.8-.615-2.256 0-.72.228-1.29.683-1.709.456-.419 1.049-.629 1.778-.629.524 0 1.016.096 1.476.287.46.192.841.431 1.142.718.3.283.56.593.78.93.218.333.375.64.471.923.1.278.15.51.15.697 0 .196-.18.378-.54.547-.36.169-.713.253-1.06.253-.364 0-.573-.107-.628-.321-.365-1.477-.91-2.332-1.634-2.564-.187.187-.28.444-.28.773 0 .31.132.813.396 1.51.265.693.554 1.388.868 2.085.315.693.604 1.429.869 2.208.264.78.396 1.393.396 1.84 0 .756-.24 1.382-.718 1.879-.474.492-1.112.738-1.914.738zm13.2-7.936c.224 0 .481.214.773.642.296.429.444.76.444.992 0 .205-.054.307-.164.307-.278 0-.576.03-.895.089-.42.073-1.12.244-2.099.513a162.388 162.388 0 0 0 .232 4.375c.032.387.048.588.048.601 0 .278-.216.417-.65.417-.336 0-.7-.075-1.093-.225-.387-.15-.606-.294-.656-.431a1.482 1.482 0 0 1-.082-.451c0-.046.023-.126.068-.24-.018-.952-.027-2.084-.027-3.397-1.035.328-1.832.609-2.393.841-.328 1.326-.528 2.39-.601 3.192-.01.114-.107.169-.294.164-.32 0-.702-.102-1.149-.307-.446-.205-.67-.401-.67-.588 0-1.053.472-2.942 1.415-5.667.948-2.725 1.707-4.514 2.277-5.366.054-.082.152-.123.294-.123.328 0 .697.134 1.107.403v-.267c0-.26.24-.39.718-.39.31 0 .608.06.896.178.287.114.43.256.43.424 0 1.345.018 2.97.055 4.874 1.23-.373 1.903-.56 2.017-.56zm-5.892 1.832l.95-.322c.42-.14.695-.234.827-.28V4.637c-.588 1.066-1.18 2.58-1.777 4.539zm7.17 6.316c-.3 0-.662-.15-1.086-.451-.424-.296-.636-.533-.636-.71 0-.028.02-.074.062-.138a.559.559 0 0 0 .075-.232A49.275 49.275 0 0 1 20.36 3.2c.046-.123.14-.184.28-.184.32 0 .714.111 1.183.335.474.223.711.428.711.615a.75.75 0 0 1-.061.212c-1.14 3.044-1.933 6.01-2.38 8.9.712-.3 1.557-.606 2.537-.916.98-.31 1.55-.465 1.709-.465.241 0 .522.221.84.663.324.442.486.775.486.998 0 .064-.018.103-.055.117-.392.15-.65.234-.772.252-.064.01-.132-.01-.205-.061-.615.132-1.433.376-2.454.731-1.017.356-1.819.682-2.407.978a.913.913 0 0 1-.43.116zm13.365-5.031c.223 0 .488.221.793.663.31.438.465.786.465 1.046 0 .114-.041.17-.123.17-.383 0-1.477.36-3.281 1.08-1.8.716-3.12 1.354-3.959 1.915a.357.357 0 0 1-.211.068c-.242 0-.59-.148-1.046-.444-.451-.3-.677-.55-.677-.745 0-.392.184-1.47.554-3.234.369-1.763.8-3.479 1.292-5.147a3.015 3.015 0 0 1-.725-.677c-.232-.296-.349-.528-.349-.697 0-.073.028-.125.082-.157.497-.26 1.41-.586 2.742-.978 1.335-.392 2.158-.588 2.467-.588.26 0 .534.203.82.609.292.405.438.729.438.97a.99.99 0 0 1-.007.123.357.357 0 0 1-.02.083.125.125 0 0 1-.041.054.4.4 0 0 0-.041.034c-.01.01-.032.016-.069.02a.585.585 0 0 1-.061.008h-.15c-.588 0-1.504.196-2.748.588-.16.542-.374 1.337-.643 2.385.633-.241.984-.364 1.053-.369.16 0 .403.187.731.56.333.374.5.664.5.869 0 .091-.05.148-.151.17-.757.17-1.636.454-2.639.855a39.779 39.779 0 0 0-.588 2.953 50.965 50.965 0 0 1 2.632-1.141c.898-.36 1.6-.624 2.105-.793.506-.169.791-.253.855-.253z" fill="currentColor"/>' +
      "    </svg>";
  }

  if (icon_id == "badge-limited") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="50" height="24" fill="none" viewBox="0 0 50 24">' +
      '      <path d="M15.096 21.332a3.049 3.049 0 0 1-.076-1.12c.037-.401.137-.624.3-.668.721-.195 3.107-.426 7.157-.691 4.054-.267 7.644-.436 10.769-.507.181-.012.304.102.368.34.075.276.079.648.012 1.115-.066.471-.223.74-.469.807a1.973 1.973 0 0 1-.503.05 7.612 7.612 0 0 1-.672-.023 7.43 7.43 0 0 0-.473-.02c-1.703-.011-4.407.126-8.111.41-3.703.29-6.229.553-7.576.79-.101.028-.18.045-.235.05a.378.378 0 0 1-.178-.03.357.357 0 0 1-.179-.164 1.299 1.299 0 0 1-.134-.339zM2.05 15.492c-.3 0-.662-.15-1.086-.451-.424-.296-.636-.533-.636-.71 0-.028.02-.074.062-.138a.56.56 0 0 0 .075-.232A49.27 49.27 0 0 1 3.069 3.2c.046-.123.14-.184.28-.184.32 0 .714.111 1.183.335.474.223.711.428.711.615 0 .036-.02.107-.061.212-1.14 3.044-1.933 6.01-2.38 8.9.712-.3 1.557-.606 2.537-.916.98-.31 1.55-.465 1.709-.465.241 0 .522.221.84.663.324.442.486.775.486.998 0 .064-.018.103-.055.117-.392.15-.65.234-.772.252-.064.01-.132-.01-.205-.061-.615.132-1.433.376-2.454.731-1.017.356-1.819.682-2.407.978a.913.913 0 0 1-.43.116zM9.168 15c-.365 0-.75-.087-1.155-.26-.406-.173-.609-.362-.609-.567 0-.661.194-2.156.581-4.485.388-2.328.862-4.4 1.422-6.213.037-.142.185-.21.445-.205.328 0 .692.088 1.093.266.401.178.602.36.602.547 0 .018-.01.055-.027.11-.329 1.043-.677 2.506-1.046 4.388a62.234 62.234 0 0 0-.807 5.12.23.23 0 0 1 .075.137c0 .524-.036.85-.11.977-.068.123-.222.185-.464.185zm10.705.786c-.364 0-.71-.06-1.039-.178-.324-.118-.485-.275-.485-.471 0-.597.07-1.64.212-3.131.14-1.495.3-2.79.478-3.883a34.028 34.028 0 0 0-2.133 4.19c-.073.17-.264.253-.574.253-.305 0-.597-.043-.875-.13-.273-.09-.41-.211-.41-.362v-4.73a32.705 32.705 0 0 0-1.217 4.163c-.346 1.527-.52 2.547-.52 3.062 0 .169-.168.251-.505.246-.356 0-.723-.063-1.1-.191-.38-.132-.568-.324-.568-.574 0-.775.394-2.427 1.182-4.956.793-2.53 1.595-4.603 2.407-6.22.072-.16.246-.238.52-.233.355 0 .708.068 1.059.205.355.132.533.287.533.465l-.02.266A37.703 37.703 0 0 0 16.72 5.3c-.014.392-.018.877-.014 1.456.005.579.02 1.176.048 1.79a40.571 40.571 0 0 1 1.777-2.993c.688-1.067 1.197-1.8 1.525-2.201a.442.442 0 0 1 .376-.185c.319 0 .66.073 1.025.219.365.146.547.298.547.458 0 .018-.01.064-.027.136-.383 1.54-.72 3.441-1.012 5.702-.287 2.255-.43 4.188-.43 5.796-.005.206-.226.308-.664.308zm4.17-.786c-.365 0-.75-.087-1.155-.26-.406-.173-.609-.362-.609-.567 0-.661.194-2.156.581-4.485.388-2.328.862-4.4 1.422-6.213.037-.142.185-.21.445-.205.328 0 .692.088 1.093.266.401.178.602.36.602.547 0 .018-.01.055-.027.11-.329 1.043-.677 2.506-1.046 4.388a62.226 62.226 0 0 0-.807 5.12.23.23 0 0 1 .075.137c0 .524-.036.85-.11.977-.067.123-.223.185-.464.185zM34.644 2.401c.197 0 .445.24.746.718.305.474.458.823.458 1.046 0 .242-.128.362-.383.362a.456.456 0 0 1-.24-.082c-.081-.054-.14-.082-.177-.082-.037 0-.192.014-.465.041-.269.028-.681.085-1.237.171a30.74 30.74 0 0 0-1.64.287 53.549 53.549 0 0 0-1.587 6.03c-.42 2.087-.629 3.42-.629 3.999 0 .054.02.125.062.211a.662.662 0 0 1 .061.274c0 .287-.2.433-.601.438-.383 0-.802-.11-1.258-.329-.456-.218-.684-.442-.684-.67 0-.464.217-1.695.65-3.691.433-2 .898-3.858 1.394-5.571-.56.177-1.07.373-1.531.588a3.27 3.27 0 0 0-.15.082c-.064.036-.121.063-.171.082a.441.441 0 0 1-.164.027c-.196 0-.488-.21-.875-.629-.388-.42-.581-.709-.581-.868 0-.105.063-.19.191-.253.66-.328 2.226-.772 4.696-1.333 2.475-.565 3.847-.848 4.116-.848zm6.61 8.06c.224 0 .489.221.794.663.31.438.465.786.465 1.046 0 .114-.041.17-.123.17-.383 0-1.477.36-3.282 1.08-1.8.716-3.12 1.354-3.958 1.915a.357.357 0 0 1-.212.068c-.241 0-.59-.148-1.045-.444-.452-.3-.677-.55-.677-.745 0-.392.184-1.47.553-3.234.37-1.763.8-3.479 1.293-5.147a3.016 3.016 0 0 1-.725-.677c-.233-.296-.349-.528-.349-.697 0-.073.028-.125.082-.157.497-.26 1.41-.586 2.742-.978 1.335-.392 2.157-.588 2.467-.588.26 0 .533.203.82.609.292.405.438.729.438.97 0 .046-.002.087-.007.123a.362.362 0 0 1-.02.083.125.125 0 0 1-.041.054.392.392 0 0 0-.041.034c-.01.01-.032.016-.069.02a.585.585 0 0 1-.061.008h-.15c-.588 0-1.504.196-2.749.588-.16.542-.373 1.337-.642 2.385.633-.241.984-.364 1.053-.369.16 0 .403.187.731.56.333.374.499.664.499.869 0 .091-.05.148-.15.17-.757.17-1.636.454-2.639.855a39.727 39.727 0 0 0-.588 2.953 50.962 50.962 0 0 1 2.632-1.141c.898-.36 1.6-.624 2.105-.793.506-.169.791-.253.855-.253zm6.974-6.323c.624.633.936 1.355.936 2.167 0 .98-.33 2.176-.991 3.589-.656 1.408-1.415 2.625-2.276 3.65-.857 1.025-1.56 1.538-2.106 1.538-.597 0-1.242-.17-1.935-.513-.287-.14-.499-.321-.635-.54-.137-.219-.205-.535-.205-.95 0-1.417.494-3.746 1.483-6.986a3.18 3.18 0 0 1-.759-.636c-.241-.273-.362-.49-.362-.65 0-.081.043-.152.13-.211 1.513-1.007 2.944-1.511 4.293-1.511.916 0 1.725.35 2.426 1.053zm-4.97 8.989c.4-.365.825-.866 1.271-1.504.447-.643.868-1.344 1.265-2.105.396-.761.709-1.566.937-2.414.232-.847.31-1.604.232-2.269-.802-.046-1.689.169-2.66.643.365.214.548.44.548.676 0 .082-.046.31-.137.684-.01.045-.135.49-.376 1.333-.237.838-.401 1.429-.492 1.77-.087.338-.196.832-.328 1.484a17.67 17.67 0 0 0-.26 1.702z" fill="currentColor"/>' +
      "    </svg>";
  }

  if (icon_id == "badge-low-stock") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="70" height="24" fill="none" viewBox="0 0 70 24">' +
      '      <path d="M25.096 21.332a3.049 3.049 0 0 1-.076-1.12c.037-.401.137-.624.3-.668.721-.195 3.107-.426 7.157-.691 4.054-.267 7.644-.436 10.769-.507.181-.012.304.102.368.34.075.276.079.648.012 1.115-.066.471-.223.74-.469.807a1.973 1.973 0 0 1-.503.05 7.612 7.612 0 0 1-.672-.023 7.43 7.43 0 0 0-.473-.02c-1.703-.011-4.407.126-8.111.41-3.703.29-6.229.553-7.576.79-.101.028-.18.045-.235.05a.378.378 0 0 1-.178-.03.357.357 0 0 1-.179-.164 1.299 1.299 0 0 1-.134-.339zM2.336 15.492c-.3 0-.663-.15-1.087-.451-.424-.296-.636-.533-.636-.71 0-.028.02-.074.062-.138a.56.56 0 0 0 .075-.232A49.27 49.27 0 0 1 3.354 3.2c.046-.123.14-.184.28-.184.32 0 .714.111 1.183.335.474.223.711.428.711.615 0 .036-.02.107-.061.212-1.14 3.044-1.932 6.01-2.38 8.9.712-.3 1.557-.606 2.537-.916.98-.31 1.55-.465 1.709-.465.242 0 .522.221.84.663.324.442.486.775.486.998 0 .064-.018.103-.055.117-.391.15-.649.234-.772.252-.064.01-.132-.01-.205-.061-.615.132-1.433.376-2.454.731-1.016.356-1.819.682-2.406.978a.913.913 0 0 1-.431.116zm8.928-12.168a3.37 3.37 0 0 1 2.385.95c.675.634 1.012 1.452 1.012 2.455 0 .81-.12 1.695-.362 2.652-.242.957-.56 1.852-.957 2.686-.397.834-.889 1.532-1.477 2.092-.588.56-1.194.841-1.818.841-.56 0-1.112-.19-1.654-.567-.543-.379-.898-.83-1.067-1.354-.141-.42-.21-.973-.205-1.661 0-1.062.148-2.23.444-3.507.301-1.276.568-2.087.8-2.433.055-.092.171-.137.349-.137.114 0 .264.023.451.068.178-.56.46-1.048.848-1.463.387-.414.804-.622 1.25-.622zm.615 5.995c.346-1.194.52-2.324.52-3.39 0-.456-.04-.82-.117-1.094-.355.232-.656.588-.902 1.066-.246.474-.37.916-.37 1.327 0 .054.005.12.014.198.01.073.014.12.014.143 0 .105-.089.155-.267.15-.168 0-.391-.045-.67-.136-.514 1.782-.772 3.26-.772 4.437 0 .651.066 1.137.198 1.456.99-.725 1.773-2.11 2.352-4.157zm10.363 6.255c-.373 0-.78-.084-1.217-.253-.437-.168-.656-.364-.656-.588 0-.15.018-.373.055-.67-.187-1.317-.335-2.866-.444-4.648-.365.66-.789 1.51-1.272 2.55-.478 1.034-.77 1.784-.875 2.249 0 .141-.007.241-.02.3a.251.251 0 0 1-.11.144c-.06.041-.155.062-.287.062-.25 0-.565-.066-.943-.199-.379-.136-.638-.28-.78-.43-.123-.132-.184-.328-.184-.588 0-.105.011-.267.034-.485.027-.22.041-.374.041-.465 0-1.436.123-3.117.37-5.045.245-1.932.523-3.286.833-4.06.046-.124.144-.183.294-.178.32 0 .702.13 1.149.39.446.259.633.498.56.717-.241.702-.449 1.55-.622 2.543-.173.989-.29 1.891-.349 2.707.898-1.85 1.584-3.13 2.058-3.842.055-.082.157-.123.308-.123.26 0 .567.091.922.274.356.182.534.362.534.54 0 1.914.03 3.187.089 3.82.232-.856.642-2.084 1.23-3.684.588-1.604 1.06-2.77 1.415-3.5a.31.31 0 0 1 .308-.177c.3 0 .683.123 1.148.369.465.246.697.537.697.875 0 .223-.093.367-.28.43-.793 1.55-1.536 3.339-2.229 5.367-.688 2.023-1.12 3.828-1.298 5.414-.01.123-.169.184-.479.184zm10.828-.294c-1.112 0-2.05-.421-2.816-1.264-.761-.848-1.142-1.878-1.142-3.09 0-.25.023-.531.069-.841.027-.205.232-.308.615-.308.374 0 .759.091 1.155.274.397.182.595.38.595.595l-.007.15a4.77 4.77 0 0 0-.007.253c0 .606.132 1.173.397 1.702.269.529.608.873 1.018 1.032.242-.214.363-.535.363-.964 0-.474-.208-1.24-.623-2.296-.414-1.058-.827-2.108-1.237-3.152-.41-1.048-.615-1.8-.615-2.256 0-.72.228-1.29.684-1.709.455-.419 1.048-.629 1.777-.629.524 0 1.016.096 1.477.287.46.192.84.431 1.141.718.3.283.56.593.78.93.218.333.375.64.471.923.1.278.15.51.15.697 0 .196-.18.378-.54.547-.36.169-.713.253-1.06.253-.364 0-.573-.107-.628-.321-.365-1.477-.91-2.332-1.634-2.564-.187.187-.28.444-.28.773 0 .31.132.813.396 1.51.265.693.554 1.388.868 2.085.315.693.604 1.429.869 2.208.264.78.396 1.393.396 1.84 0 .756-.24 1.382-.718 1.879-.474.492-1.112.738-1.914.738zM45.074 2.401c.196 0 .445.24.745.718.306.474.458.823.458 1.046 0 .242-.127.362-.383.362a.456.456 0 0 1-.239-.082c-.082-.054-.141-.082-.178-.082-.036 0-.19.014-.464.041-.27.028-.682.085-1.238.171a30.74 30.74 0 0 0-1.64.287 53.549 53.549 0 0 0-1.586 6.03c-.42 2.087-.63 3.42-.63 3.999 0 .054.021.125.062.211a.66.66 0 0 1 .062.274c0 .287-.2.433-.602.438-.382 0-.802-.11-1.257-.329-.456-.218-.684-.442-.684-.67 0-.464.217-1.695.65-3.691.432-2 .897-3.858 1.394-5.571-.56.177-1.071.373-1.531.588a3.27 3.27 0 0 0-.15.082c-.065.036-.121.063-.172.082a.442.442 0 0 1-.164.027c-.196 0-.487-.21-.875-.629-.387-.42-.58-.709-.58-.868 0-.105.063-.19.19-.253.661-.328 2.227-.772 4.697-1.333 2.475-.565 3.846-.848 4.115-.848zm5.455 1.58c.401.346.602 1.107.602 2.283 0 .866-.114 1.813-.342 2.843-.228 1.026-.54 2.001-.937 2.926-.396.925-.904 1.698-1.524 2.318-.615.62-1.262.93-1.941.93-.438 0-.889-.108-1.354-.322-.46-.214-.806-.504-1.039-.868-.328-.524-.492-1.342-.492-2.454 0-1.044.134-2.201.403-3.473.274-1.276.597-2.347.971-3.213.374-.87.7-1.305.977-1.305.233 0 .531.102.896.307.483-.642.996-.964 1.538-.964.328 0 .704.1 1.128.301.424.2.795.43 1.114.69zm-4.717 9.761c.88-.633 1.628-1.795 2.243-3.486.615-1.69.922-3.227.922-4.608 0-.419-.034-.774-.102-1.066-.447.365-.827 1.08-1.142 2.147-.027.082-.093.123-.198.123-.196 0-.43-.085-.704-.253-.766 2.032-1.146 3.942-1.142 5.728 0 .533.041 1.005.123 1.415zm8.908 1.019c-.31 0-.618-.06-.923-.178a3.201 3.201 0 0 1-.889-.567c-.287-.26-.52-.625-.697-1.094-.178-.474-.267-1.023-.267-1.648 0-.624.1-1.392.301-2.303.2-.916.47-1.825.807-2.728.337-.902.765-1.67 1.285-2.304.524-.633 1.066-.95 1.627-.95.319 0 .647.064.984.192.342.123.677.307 1.005.553.328.242.597.575.807.998.21.424.314.903.314 1.436 0 .524-.12 1.112-.362 1.764-.046.132-.205.196-.479.191-.328 0-.676-.084-1.045-.253-.37-.173-.554-.349-.554-.526 0-.01.025-.105.075-.287a6.53 6.53 0 0 0 .157-.684c.055-.278.082-.542.082-.793 0-.346-.052-.684-.157-1.012-.542.401-1.105 1.388-1.688 2.96-.584 1.573-.876 2.967-.876 4.184 0 .542.058.993.171 1.353.447-.177 1.41-.679 2.892-1.503 1.486-.825 2.468-1.397 2.946-1.716a.294.294 0 0 1 .164-.055c.233 0 .493.175.78.526.287.351.43.661.43.93 0 .132-.098.258-.294.376-1.586.97-2.855 1.7-3.807 2.188-.953.483-1.575.763-1.866.84a3.74 3.74 0 0 1-.923.11zm14.314-2.83c.105 0 .198.057.28.17.083.114.124.274.124.48 0 .354-.087.737-.26 1.148-.169.41-.337.615-.506.615-.169 0-1.096-.274-2.782-.82-1.686-.547-2.963-1.008-3.828-1.381-.215 1.148-.322 1.936-.322 2.365 0 .045.01.132.028.26.018.127.027.218.027.273 0 .169-.173.253-.52.253-.278 0-.574-.057-.888-.171-.31-.11-.54-.257-.69-.444-.124-.15-.185-.379-.185-.684 0-.775.326-2.623.977-5.544.657-2.921 1.114-4.705 1.374-5.352.046-.123.173-.183.383-.178.337 0 .711.1 1.121.3.41.201.615.418.615.65a.122.122 0 0 1-.02.062 1.369 1.369 0 0 0-.055.164c-.373 1.299-.838 3.229-1.394 5.79.774-1.062 1.96-2.978 3.554-5.75.046-.081.153-.125.322-.13.3 0 .642.117 1.025.35.387.227.581.453.581.676 0 .046-.009.091-.027.137-.278.71-1.454 2.588-3.528 5.633 1.586.524 3.052.92 4.396 1.19a.443.443 0 0 1 .198-.062z" fill="currentColor"/>' +
      "    </svg>";
  }

  if (icon_id == "badge-sold-out") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="65" height="24" fill="none" viewBox="0 0 65 24">' +
      '      <path d="M21.096 21.332a3.049 3.049 0 0 1-.076-1.12c.037-.401.137-.624.3-.668.721-.195 3.107-.426 7.157-.691 4.054-.267 7.644-.436 10.769-.507.181-.012.304.102.368.34.075.276.079.648.012 1.115-.066.471-.223.74-.469.807a1.973 1.973 0 0 1-.503.05 7.612 7.612 0 0 1-.672-.023 7.43 7.43 0 0 0-.473-.02c-1.703-.011-4.407.126-8.111.41-3.703.29-6.229.553-7.576.79-.101.028-.18.045-.235.05a.378.378 0 0 1-.178-.03.357.357 0 0 1-.179-.164 1.299 1.299 0 0 1-.134-.339zM4.94 15.28c-1.112 0-2.05-.421-2.816-1.264-.761-.848-1.142-1.878-1.142-3.09 0-.25.023-.531.069-.841.027-.205.232-.308.615-.308.374 0 .759.091 1.155.274.397.182.595.38.595.595l-.007.15c-.004.087-.007.17-.007.253 0 .606.133 1.173.397 1.702.269.529.608.873 1.018 1.032.242-.214.363-.535.363-.964 0-.474-.208-1.24-.622-2.296L3.32 7.37c-.41-1.048-.615-1.8-.615-2.256 0-.72.228-1.29.684-1.709.455-.419 1.048-.629 1.777-.629.524 0 1.016.096 1.477.287.46.192.84.431 1.141.718.301.283.56.593.78.93.218.333.375.64.471.923.1.278.15.51.15.697 0 .196-.18.378-.54.547-.36.169-.713.253-1.06.253-.364 0-.573-.107-.628-.321-.365-1.477-.91-2.332-1.634-2.564-.187.187-.28.444-.28.773 0 .31.132.813.396 1.51.265.693.554 1.388.869 2.085.314.693.603 1.429.868 2.208.264.78.396 1.393.396 1.84 0 .756-.239 1.382-.718 1.879-.473.492-1.111.738-1.914.738zM13.5 3.324a3.37 3.37 0 0 1 2.386.95c.674.634 1.011 1.452 1.011 2.455 0 .81-.12 1.695-.362 2.652-.241.957-.56 1.852-.957 2.686-.396.834-.889 1.532-1.476 2.092-.588.56-1.194.841-1.819.841-.56 0-1.112-.19-1.654-.567-.542-.379-.898-.83-1.066-1.354-.142-.42-.21-.973-.206-1.661 0-1.062.149-2.23.445-3.507.3-1.276.567-2.087.8-2.433.054-.092.17-.137.348-.137.114 0 .264.023.451.068.178-.56.46-1.048.848-1.463.387-.414.804-.622 1.251-.622zm.615 5.995c.347-1.194.52-2.324.52-3.39 0-.456-.039-.82-.116-1.094-.356.232-.657.588-.903 1.066-.246.474-.369.916-.369 1.327 0 .054.005.12.014.198.009.073.013.12.013.143 0 .105-.088.155-.266.15-.169 0-.392-.045-.67-.136-.515 1.782-.772 3.26-.772 4.437 0 .651.066 1.137.198 1.456.989-.725 1.773-2.11 2.351-4.157zm4.717 6.173c-.3 0-.663-.15-1.087-.451-.424-.296-.636-.533-.636-.71 0-.028.02-.074.062-.138a.56.56 0 0 0 .075-.232A49.27 49.27 0 0 1 19.85 3.2c.045-.123.139-.184.28-.184.319 0 .713.111 1.183.335.474.223.71.428.71.615 0 .036-.02.107-.061.212-1.14 3.044-1.932 6.01-2.379 8.9.71-.3 1.556-.606 2.536-.916.98-.31 1.55-.465 1.71-.465.24 0 .52.221.84.663.323.442.485.775.485.998 0 .064-.018.103-.054.117-.392.15-.65.234-.773.252-.064.01-.132-.01-.205-.061-.615.132-1.433.376-2.454.731-1.016.356-1.818.682-2.406.978a.913.913 0 0 1-.43.116zM31.648 4.138c.625.633.937 1.355.937 2.167 0 .98-.33 2.176-.991 3.589-.657 1.408-1.415 2.625-2.277 3.65-.856 1.025-1.558 1.538-2.105 1.538-.597 0-1.242-.17-1.935-.513-.287-.14-.499-.321-.635-.54-.137-.219-.206-.535-.206-.95 0-1.417.495-3.746 1.484-6.986a3.18 3.18 0 0 1-.759-.636c-.241-.273-.362-.49-.362-.65 0-.081.043-.152.13-.211 1.513-1.007 2.944-1.511 4.293-1.511.916 0 1.725.35 2.426 1.053zm-4.97 8.989c.402-.365.826-.866 1.272-1.504.447-.643.868-1.344 1.265-2.105.396-.761.709-1.566.936-2.414.233-.847.31-1.604.233-2.269-.802-.046-1.689.169-2.66.643.365.214.547.44.547.676 0 .082-.045.31-.136.684-.01.045-.135.49-.376 1.333-.237.838-.401 1.429-.492 1.77-.087.338-.196.832-.328 1.484a17.67 17.67 0 0 0-.26 1.702zM41.54 3.324a3.37 3.37 0 0 1 2.386.95c.674.634 1.011 1.452 1.011 2.455 0 .81-.12 1.695-.362 2.652-.241.957-.56 1.852-.957 2.686-.396.834-.889 1.532-1.476 2.092-.588.56-1.194.841-1.819.841-.56 0-1.112-.19-1.654-.567-.542-.379-.898-.83-1.066-1.354-.142-.42-.21-.973-.206-1.661 0-1.062.149-2.23.445-3.507.3-1.276.567-2.087.8-2.433.054-.092.17-.137.348-.137.114 0 .265.023.451.068a3.79 3.79 0 0 1 .848-1.463c.387-.414.804-.622 1.251-.622zm.615 5.995c.347-1.194.52-2.324.52-3.39 0-.456-.039-.82-.116-1.094-.356.232-.657.588-.903 1.066-.246.474-.369.916-.369 1.327 0 .054.005.12.014.198.009.073.014.12.014.143 0 .105-.09.155-.267.15-.169 0-.392-.045-.67-.136-.515 1.782-.773 3.26-.773 4.437 0 .651.067 1.137.199 1.456.989-.725 1.773-2.11 2.351-4.157zm10.384 5.75c-.328 0-.704-.092-1.128-.274-.424-.182-.636-.346-.636-.492 0-.739.071-1.86.212-3.364-.83 1.454-1.438 2.425-1.825 2.913-.383.487-.74.731-1.073.731a2.85 2.85 0 0 1-.752-.103 3.48 3.48 0 0 1-.766-.341c-.26-.155-.47-.392-.629-.711-.155-.324-.232-.709-.232-1.155 0-1.149.257-2.721.772-4.717.52-2.001.967-3.496 1.34-4.485.037-.105.14-.155.308-.15.3 0 .67.116 1.107.349.438.232.657.442.657.628a.45.45 0 0 1-.028.11c-1.13 3.418-1.798 6.163-2.003 8.237 1.29-1.905 2.746-4.603 4.368-8.094l.028-.068c.054-.105.175-.157.362-.157.31 0 .656.1 1.04.3.382.201.573.4.573.595a.5.5 0 0 1-.027.13c-.839 2.52-1.26 5.647-1.265 9.38.037.104.057.22.062.348 0 .26-.155.39-.465.39zM62.827 2.4c.196 0 .445.24.745.718.306.474.458.823.458 1.046 0 .242-.127.362-.383.362a.456.456 0 0 1-.239-.082c-.082-.054-.141-.082-.178-.082a9.66 9.66 0 0 0-.464.041c-.27.028-.682.085-1.238.171-.556.082-1.102.178-1.64.287a53.527 53.527 0 0 0-1.586 6.03c-.42 2.087-.63 3.42-.63 3.999 0 .054.021.125.062.211a.662.662 0 0 1 .062.274c0 .287-.2.433-.602.438-.383 0-.802-.11-1.258-.329-.455-.218-.683-.442-.683-.67 0-.464.216-1.695.65-3.691.432-2 .897-3.858 1.394-5.571-.56.177-1.071.373-1.531.588a3.324 3.324 0 0 0-.15.082c-.065.036-.121.063-.172.082a.44.44 0 0 1-.164.027c-.196 0-.487-.21-.875-.629-.387-.42-.58-.709-.58-.868 0-.105.063-.19.19-.253.661-.328 2.227-.772 4.697-1.333 2.474-.565 3.846-.848 4.115-.848z" fill="currentColor"/>' +
      "    </svg>";
  }

  if (icon_id == "badge-coming-soon") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="88" height="24" fill="none" viewBox="0 0 88 24">' +
      '      <path d="M34.096 21.332a3.049 3.049 0 0 1-.076-1.12c.037-.401.137-.624.3-.668.721-.195 3.107-.426 7.157-.691 4.054-.267 7.644-.436 10.769-.507.181-.012.304.102.368.34.075.276.079.648.012 1.115-.066.471-.223.74-.469.807a1.973 1.973 0 0 1-.503.05 7.612 7.612 0 0 1-.672-.023 7.43 7.43 0 0 0-.473-.02c-1.703-.011-4.407.126-8.111.41-3.703.29-6.229.553-7.576.79-.102.028-.18.045-.235.05a.378.378 0 0 1-.178-.03.357.357 0 0 1-.179-.164 1.299 1.299 0 0 1-.134-.339zM3.592 14.76c-.31 0-.618-.059-.923-.177a3.2 3.2 0 0 1-.889-.567c-.287-.26-.52-.625-.697-1.094-.178-.474-.267-1.023-.267-1.648 0-.624.1-1.392.301-2.303.2-.916.47-1.825.807-2.728.337-.902.765-1.67 1.285-2.304.524-.633 1.066-.95 1.627-.95.319 0 .647.064.984.192.342.123.677.307 1.005.553.328.242.597.575.807.998.21.424.314.903.314 1.436 0 .524-.12 1.112-.362 1.764-.046.132-.205.196-.479.191-.328 0-.676-.084-1.045-.253-.37-.173-.554-.349-.554-.526 0-.01.025-.105.075-.287a6.54 6.54 0 0 0 .157-.684c.055-.278.082-.542.082-.793 0-.346-.052-.684-.157-1.012-.542.401-1.105 1.388-1.688 2.96-.584 1.573-.875 2.967-.875 4.184 0 .542.057.993.17 1.353.447-.177 1.411-.679 2.892-1.503 1.486-.825 2.468-1.397 2.946-1.716a.294.294 0 0 1 .164-.055c.233 0 .493.175.78.526.287.351.43.661.43.93 0 .132-.098.258-.293.376-1.586.97-2.856 1.7-3.808 2.188-.953.483-1.575.763-1.866.84a3.74 3.74 0 0 1-.923.11zm9.194-11.436a3.37 3.37 0 0 1 2.386.95c.674.634 1.012 1.452 1.012 2.455 0 .81-.121 1.695-.363 2.652-.241.957-.56 1.852-.957 2.686-.396.834-.888 1.532-1.476 2.092S12.194 15 11.569 15c-.56 0-1.112-.19-1.654-.567-.542-.379-.898-.83-1.066-1.354-.142-.42-.21-.973-.205-1.661 0-1.062.148-2.23.444-3.507.3-1.276.567-2.087.8-2.433.054-.092.17-.137.348-.137.114 0 .265.023.451.068a3.79 3.79 0 0 1 .848-1.463c.387-.414.804-.622 1.251-.622zm.615 5.995c.347-1.194.52-2.324.52-3.39 0-.456-.039-.82-.116-1.094-.356.232-.657.588-.903 1.066-.246.474-.369.916-.369 1.327 0 .054.005.12.014.198.009.073.013.12.013.143 0 .105-.088.155-.266.15-.169 0-.392-.045-.67-.136-.515 1.782-.772 3.26-.772 4.437 0 .651.066 1.137.198 1.456.989-.725 1.773-2.11 2.351-4.157zm11.533 6.467c-.365 0-.711-.06-1.04-.178-.323-.118-.485-.275-.485-.471 0-.597.07-1.64.212-3.131.141-1.495.3-2.79.479-3.883a34.028 34.028 0 0 0-2.133 4.19c-.073.17-.264.253-.574.253-.306 0-.597-.043-.875-.13-.274-.09-.41-.211-.41-.362v-4.73a32.705 32.705 0 0 0-1.217 4.163c-.347 1.527-.52 2.547-.52 3.062 0 .169-.168.251-.506.246-.355 0-.722-.063-1.1-.191-.379-.132-.568-.324-.568-.574 0-.775.395-2.427 1.183-4.956.793-2.53 1.595-4.603 2.406-6.22.073-.16.246-.238.52-.233.355 0 .708.068 1.06.205.355.132.532.287.532.465a38.612 38.612 0 0 0-.116 1.99c-.013.39-.018.876-.013 1.455.004.579.02 1.176.047 1.79a40.574 40.574 0 0 1 1.778-2.993c.688-1.067 1.196-1.8 1.524-2.201a.442.442 0 0 1 .376-.185c.32 0 .66.073 1.026.219.364.146.546.298.546.458 0 .018-.009.064-.027.136-.383 1.54-.72 3.441-1.012 5.702-.287 2.255-.43 4.188-.43 5.796-.005.206-.226.308-.663.308zm4.17-.786c-.365 0-.75-.087-1.156-.26-.405-.173-.608-.362-.608-.567 0-.661.194-2.156.58-4.485.388-2.328.862-4.4 1.423-6.213.036-.142.184-.21.444-.205.328 0 .693.088 1.094.266.4.178.601.36.601.547 0 .018-.009.055-.027.11-.328 1.043-.677 2.506-1.046 4.388a62.27 62.27 0 0 0-.806 5.12.23.23 0 0 1 .075.137c0 .524-.037.85-.11.977-.068.123-.223.185-.465.185zm4.012.321c-.355 0-.731-.095-1.128-.287-.396-.191-.594-.39-.594-.595 0-.88.268-2.556.806-5.03.538-2.48 1.048-4.522 1.531-6.126.037-.114.174-.17.41-.17.31 0 .655.084 1.033.252.383.169.588.342.615.52.346 2.36.752 4.311 1.217 5.851.3-1.64.613-3.17.936-4.587.328-1.421.554-2.274.677-2.556.055-.132.185-.196.39-.192.328 0 .724.126 1.19.376.469.251.703.474.703.67 0 .037-.009.075-.027.116a.465.465 0 0 1-.089.117.383.383 0 0 0-.068.095c-.365.643-.839 2.274-1.422 4.895-.583 2.616-.934 4.53-1.053 5.742-.009.132-.164.198-.465.198-.31 0-.647-.07-1.011-.212-.36-.14-.58-.31-.657-.505-.123-.301-.364-1.165-.724-2.591a83.693 83.693 0 0 1-.759-3.247c-.196.756-.415 1.825-.656 3.206-.242 1.38-.363 2.436-.363 3.165 0 .15.01.287.028.41.018.118.027.187.027.205 0 .073-.05.137-.15.191a.751.751 0 0 1-.397.09zm15.832-6.87c0 .037-.009.091-.027.164-.42 1.887-.727 3.963-.923 6.228a.95.95 0 0 0 .007.102.738.738 0 0 1 .007.082c0 .27-.039.445-.117.527-.072.086-.184.13-.335.13-.31 0-.663-.087-1.059-.26-.392-.169-.588-.38-.588-.636 0-.56.125-1.554.376-2.98-.71 1.148-1.249 1.95-1.613 2.406-.196.232-.46.35-.793.355-.429 0-.975-.198-1.64-.594-1.017-.607-1.525-1.823-1.525-3.65 0-1.122.196-2.245.588-3.37.392-1.131.964-2.088 1.716-2.872.751-.784 1.574-1.176 2.467-1.176.31 0 .6.06.868.178.347.15.611.28.793.39.183.104.38.26.595.464.214.206.365.458.451.76.091.295.137.653.137 1.072 0 .329-.027.547-.082.657-.05.105-.178.157-.383.157-.337 0-.713-.096-1.128-.287-.415-.192-.622-.394-.622-.609a17.523 17.523 0 0 1 .027-.39c.014-.113.021-.22.021-.32a3.36 3.36 0 0 0-.075-.8c-.652.337-1.23.913-1.736 1.73a10.135 10.135 0 0 0-1.149 2.706c2.297-.67 3.65-1.005 4.06-1.005.301 0 .657.091 1.067.274.41.182.615.371.615.567zm-5.783 4.13c.25-.224.61-.641 1.08-1.252.474-.615.923-1.24 1.347-1.873-.97.337-1.55.506-1.736.506-.251 0-.54-.089-.869-.267-.064.401-.098.82-.102 1.258 0 .684.093 1.226.28 1.627zm14.492 2.7c-1.112 0-2.05-.422-2.816-1.265-.761-.848-1.142-1.878-1.142-3.09 0-.25.023-.531.069-.841.027-.205.232-.308.615-.308.373 0 .759.091 1.155.274.397.182.595.38.595.595l-.007.15a4.77 4.77 0 0 0-.007.253c0 .606.132 1.173.397 1.702.269.529.608.873 1.018 1.032.242-.214.363-.535.363-.964 0-.474-.208-1.24-.623-2.296-.414-1.058-.827-2.108-1.237-3.152-.41-1.048-.615-1.8-.615-2.256 0-.72.228-1.29.684-1.709.455-.419 1.048-.629 1.777-.629.524 0 1.016.096 1.476.287.46.192.841.431 1.142.718.3.283.56.593.78.93.218.333.375.64.471.923.1.278.15.51.15.697 0 .196-.18.378-.54.547-.36.169-.713.253-1.06.253-.364 0-.574-.107-.628-.321-.365-1.477-.91-2.332-1.634-2.564-.187.187-.28.444-.28.773 0 .31.132.813.396 1.51.265.693.554 1.388.868 2.085.315.693.604 1.429.869 2.208.264.78.396 1.393.396 1.84 0 .756-.24 1.382-.718 1.879-.474.492-1.112.738-1.914.738zM77.543 4.472c.278.41.417 1.043.417 1.9 0 1.258-.276 2.703-.827 4.334-.552 1.631-1.256 2.89-2.112 3.773-.552.561-1.188.841-1.908.841-.346 0-.76-.104-1.244-.314-.483-.21-.847-.497-1.094-.861-.319-.497-.476-1.375-.471-2.632 0-1.755.321-3.55.964-5.387-.616.169-1.292.321-2.03.458.017.169.027.298.027.39 0 1.148-.249 2.451-.746 3.91-.492 1.454-.988 2.452-1.49 2.994-.533.579-1.075.868-1.627.868-.943 0-1.727-.321-2.351-.964-.625-.642-.937-1.581-.937-2.816 0-.934.128-1.912.383-2.933.255-1.02.583-1.9.984-2.638.634-1.185 1.395-1.778 2.284-1.778.474 0 1.061.237 1.763.711.31.205.554.383.732.533 1.371-.16 2.711-.56 4.02-1.203a.461.461 0 0 1 .204-.055c.251 0 .575.108.971.322.428-.588.923-.882 1.484-.882.41 0 .888.15 1.435.451.547.296.937.622 1.169.978zm-4.888 9.256c.67-.634 1.274-1.54 1.812-2.721a15.421 15.421 0 0 0 1.135-3.52c.218-1.163.239-2.083.061-2.762-.506.41-.893 1.137-1.162 2.18-.027.091-.112.14-.253.144-.169 0-.383-.085-.642-.253-.712 1.987-1.067 3.84-1.067 5.558.005.542.043 1 .116 1.373zm-7.95-.602c.506-.401 1.003-1.267 1.49-2.598.488-1.33.75-2.575.786-3.732-.464-.064-.813-.367-1.045-.91-.506.607-.912 1.395-1.217 2.366-.301.97-.451 1.91-.451 2.816.004.916.15 1.602.437 2.058zm15.401 2.194c-.355 0-.731-.095-1.127-.287-.397-.191-.595-.39-.595-.595 0-.88.269-2.556.806-5.03.538-2.48 1.049-4.522 1.532-6.126.036-.114.173-.17.41-.17.31 0 .654.084 1.032.252.383.169.588.342.615.52.347 2.36.752 4.311 1.217 5.851.3-1.64.613-3.17.937-4.587.328-1.421.553-2.274.676-2.556.055-.132.185-.196.39-.192.328 0 .725.126 1.19.376.469.251.704.474.704.67 0 .037-.01.075-.028.116a.464.464 0 0 1-.089.117.382.382 0 0 0-.068.095c-.365.643-.838 2.274-1.422 4.895-.583 2.616-.934 4.53-1.053 5.742-.009.132-.164.198-.464.198-.31 0-.648-.07-1.012-.212-.36-.14-.579-.31-.656-.505-.123-.301-.365-1.165-.725-2.591a83.734 83.734 0 0 1-.759-3.247c-.196.756-.415 1.825-.656 3.206-.242 1.38-.362 2.436-.362 3.165 0 .15.009.287.027.41.018.118.027.187.027.205 0 .073-.05.137-.15.191a.751.751 0 0 1-.397.09z" fill="currentColor"/>' +
      "    </svg>";
  }

  if (icon_id == "badge-final-sale") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="75" height="24" fill="none" viewBox="0 0 75 24">' +
      '      <path d="M27.096 21.332a3.049 3.049 0 0 1-.076-1.12c.037-.401.137-.624.3-.668.721-.195 3.107-.426 7.157-.691 4.054-.267 7.644-.436 10.769-.507.181-.012.304.102.368.34.075.276.079.648.012 1.115-.066.471-.223.74-.469.807a1.973 1.973 0 0 1-.503.05 7.612 7.612 0 0 1-.672-.023 7.43 7.43 0 0 0-.473-.02c-1.703-.011-4.407.126-8.111.41-3.703.29-6.229.553-7.576.79-.101.028-.18.045-.235.05a.378.378 0 0 1-.178-.03.357.357 0 0 1-.179-.164 1.299 1.299 0 0 1-.134-.339zM9.75 2.593c.269 0 .542.205.82.615.278.406.417.716.417.93 0 .132-.07.207-.212.225-1.522.16-3.431.54-5.728 1.142a34.4 34.4 0 0 0-.533 1.99c.729-.242 1.155-.363 1.278-.363.214 0 .483.182.807.547.328.364.492.663.492.895 0 .114-.069.19-.205.226-.971.241-1.919.53-2.844.868-.428 2.12-.638 3.723-.629 4.813a.57.57 0 0 1 .041.225c0 .114-.032.196-.096.246-.059.05-.191.075-.396.075-.383 0-.777-.095-1.183-.287-.405-.191-.608-.403-.608-.636 0-.81.2-2.187.601-4.128-.4-.438-.601-.784-.601-1.04 0-.063.032-.113.096-.15.15-.082.44-.219.868-.41a74.38 74.38 0 0 1 .533-2.071c-.223-.028-.492-.226-.807-.595-.31-.37-.465-.665-.465-.889 0-.105.037-.175.11-.212.374-.177 1.666-.558 3.876-1.141 2.21-.584 3.666-.875 4.368-.875zM9.572 15c-.364 0-.75-.087-1.155-.26-.406-.173-.608-.362-.608-.567 0-.661.193-2.156.58-4.485.388-2.328.862-4.4 1.423-6.213.036-.142.184-.21.444-.205.328 0 .693.088 1.094.266.4.178.601.36.601.547 0 .018-.009.055-.027.11-.328 1.043-.677 2.506-1.046 4.388a62.266 62.266 0 0 0-.807 5.12.23.23 0 0 1 .075.137c0 .524-.036.85-.109.977-.068.123-.223.185-.465.185zm4.013.321c-.356 0-.732-.095-1.128-.287-.397-.191-.595-.39-.595-.595 0-.88.27-2.556.807-5.03.538-2.48 1.048-4.522 1.531-6.126.037-.114.173-.17.41-.17.31 0 .654.084 1.033.252.382.169.587.342.615.52.346 2.36.752 4.311 1.217 5.851.3-1.64.613-3.17.936-4.587.328-1.421.554-2.274.677-2.556.055-.132.184-.196.39-.192.328 0 .724.126 1.189.376.47.251.704.474.704.67 0 .037-.009.075-.027.116a.467.467 0 0 1-.09.117.382.382 0 0 0-.068.095c-.364.643-.838 2.274-1.421 4.895-.584 2.616-.935 4.53-1.053 5.742-.01.132-.164.198-.465.198-.31 0-.647-.07-1.012-.212-.36-.14-.578-.31-.656-.505-.123-.301-.364-1.165-.725-2.591a83.734 83.734 0 0 1-.758-3.247c-.196.756-.415 1.825-.656 3.206-.242 1.38-.363 2.436-.363 3.165 0 .15.01.287.027.41.019.118.028.187.028.205 0 .073-.05.137-.15.191a.75.75 0 0 1-.397.09zm16.18-7.977c.224 0 .481.214.773.642.296.429.444.76.444.992 0 .205-.054.307-.164.307-.278 0-.576.03-.895.089-.42.073-1.119.244-2.099.513a162.388 162.388 0 0 0 .233 4.375c.032.387.048.588.048.601 0 .278-.217.417-.65.417-.337 0-.702-.075-1.094-.225-.387-.15-.606-.294-.656-.431a1.483 1.483 0 0 1-.082-.451c0-.046.023-.126.068-.24-.018-.952-.027-2.084-.027-3.397-1.034.328-1.832.609-2.393.841-.328 1.326-.528 2.39-.601 3.192-.01.114-.107.169-.294.164-.319 0-.702-.102-1.149-.307-.446-.205-.67-.401-.67-.588 0-1.053.472-2.942 1.416-5.667.948-2.725 1.706-4.514 2.276-5.366.055-.082.153-.123.294-.123.328 0 .697.134 1.107.403v-.267c0-.26.24-.39.718-.39.31 0 .609.06.896.178.287.114.43.256.43.424 0 1.345.019 2.97.055 4.874 1.23-.373 1.903-.56 2.017-.56zm-5.892 1.832l.95-.322c.42-.14.695-.234.827-.28V4.637c-.587 1.066-1.18 2.58-1.777 4.539zm7.17 6.316c-.3 0-.662-.15-1.086-.451-.424-.296-.636-.533-.636-.71 0-.028.02-.074.062-.138a.56.56 0 0 0 .075-.232A49.27 49.27 0 0 1 32.063 3.2c.045-.123.139-.184.28-.184.319 0 .713.111 1.182.335.474.223.711.428.711.615 0 .036-.02.107-.061.212-1.14 3.044-1.932 6.01-2.38 8.9.712-.3 1.557-.606 2.537-.916.98-.31 1.55-.465 1.709-.465.242 0 .522.221.84.663.324.442.486.775.486.998 0 .064-.018.103-.054.117-.392.15-.65.234-.773.252-.064.01-.132-.01-.205-.061-.615.132-1.433.376-2.454.731-1.016.356-1.819.682-2.406.978a.913.913 0 0 1-.431.116zm13.946-.212c-1.112 0-2.05-.421-2.816-1.264-.761-.848-1.142-1.878-1.142-3.09 0-.25.023-.531.069-.841.027-.205.232-.308.615-.308.373 0 .759.091 1.155.274.397.182.595.38.595.595l-.007.15c-.005.087-.007.17-.007.253 0 .606.132 1.173.397 1.702.269.529.608.873 1.018 1.032.242-.214.362-.535.362-.964 0-.474-.207-1.24-.622-2.296-.414-1.058-.827-2.108-1.237-3.152-.41-1.048-.615-1.8-.615-2.256 0-.72.228-1.29.684-1.709.455-.419 1.048-.629 1.777-.629.524 0 1.016.096 1.476.287.46.192.841.431 1.142.718.3.283.56.593.78.93.218.333.375.64.471.923.1.278.15.51.15.697 0 .196-.18.378-.54.547-.36.169-.713.253-1.06.253-.364 0-.574-.107-.628-.321-.365-1.477-.91-2.332-1.634-2.564-.187.187-.28.444-.28.773 0 .31.132.813.396 1.51.265.693.554 1.388.868 2.085.315.693.604 1.429.869 2.208.264.78.396 1.393.396 1.84 0 .756-.24 1.382-.718 1.879-.474.492-1.112.738-1.914.738zm13.2-7.936c.224 0 .481.214.773.642.296.429.444.76.444.992 0 .205-.054.307-.164.307-.278 0-.576.03-.895.089-.42.073-1.12.244-2.099.513a162.388 162.388 0 0 0 .233 4.375c.031.387.047.588.047.601 0 .278-.216.417-.65.417-.336 0-.7-.075-1.093-.225-.387-.15-.606-.294-.656-.431a1.482 1.482 0 0 1-.082-.451c0-.046.023-.126.068-.24-.018-.952-.027-2.084-.027-3.397-1.035.328-1.832.609-2.393.841-.328 1.326-.528 2.39-.601 3.192-.01.114-.107.169-.294.164-.32 0-.702-.102-1.149-.307-.446-.205-.67-.401-.67-.588 0-1.053.472-2.942 1.416-5.667.947-2.725 1.706-4.514 2.276-5.366.054-.082.152-.123.294-.123.328 0 .697.134 1.107.403v-.267c0-.26.24-.39.718-.39.31 0 .608.06.895.178.288.114.431.256.431.424 0 1.345.018 2.97.055 4.874 1.23-.373 1.902-.56 2.017-.56zm-5.892 1.832l.95-.322c.42-.14.695-.234.827-.28V4.637c-.588 1.066-1.18 2.58-1.777 4.539zm7.17 6.316c-.3 0-.662-.15-1.086-.451-.424-.296-.636-.533-.636-.71 0-.028.02-.074.062-.138a.559.559 0 0 0 .075-.232A49.275 49.275 0 0 1 60.486 3.2c.046-.123.14-.184.28-.184.32 0 .714.111 1.183.335.474.223.711.428.711.615a.75.75 0 0 1-.061.212c-1.14 3.044-1.933 6.01-2.38 8.9.712-.3 1.557-.606 2.537-.916.98-.31 1.55-.465 1.709-.465.241 0 .522.221.84.663.324.442.486.775.486.998 0 .064-.018.103-.055.117-.392.15-.65.234-.772.252-.064.01-.132-.01-.205-.061-.615.132-1.434.376-2.454.731-1.017.356-1.819.682-2.407.978a.913.913 0 0 1-.43.116zm13.365-5.031c.223 0 .488.221.793.663.31.438.465.786.465 1.046 0 .114-.041.17-.123.17-.383 0-1.477.36-3.281 1.08-1.8.716-3.12 1.354-3.959 1.915a.357.357 0 0 1-.211.068c-.242 0-.59-.148-1.046-.444-.451-.3-.677-.55-.677-.745 0-.392.184-1.47.554-3.234.369-1.763.8-3.479 1.292-5.147a3.015 3.015 0 0 1-.725-.677c-.232-.296-.349-.528-.349-.697 0-.073.028-.125.082-.157.497-.26 1.41-.586 2.742-.978 1.335-.392 2.157-.588 2.467-.588.26 0 .534.203.82.609.292.405.438.729.438.97a.99.99 0 0 1-.007.123.357.357 0 0 1-.02.083.125.125 0 0 1-.041.054.4.4 0 0 0-.041.034c-.01.01-.032.016-.069.02a.585.585 0 0 1-.061.008h-.15c-.588 0-1.504.196-2.748.588-.16.542-.374 1.337-.643 2.385.633-.241.984-.364 1.053-.369.16 0 .403.187.731.56.333.374.5.664.5.869 0 .091-.05.148-.151.17-.757.17-1.636.454-2.639.855a39.779 39.779 0 0 0-.588 2.953 50.965 50.965 0 0 1 2.632-1.141c.898-.36 1.6-.624 2.106-.793.505-.169.79-.253.854-.253z" fill="currentColor"/>' +
      "    </svg>";
  }

  if (icon_id == "badge-bogo") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="79" height="22" fill="none" viewBox="0 0 79 22">' +
      '      <path d="M30.096 21.3324C30.0031 20.9893 29.9776 20.6161 30.0196 20.2129C30.0571 19.8108 30.1573 19.5878 30.32 19.5437C31.0414 19.3485 33.4271 19.1182 37.477 18.8529C41.5313 18.5864 45.1209 18.4173 48.2459 18.3457C48.427 18.3345 48.5497 18.4476 48.614 18.6852C48.689 18.9623 48.6929 19.3342 48.6257 19.801C48.5596 20.2721 48.4034 20.541 48.1571 20.6077C48.0295 20.6422 47.8618 20.6593 47.654 20.6589C47.4517 20.6617 47.2277 20.6539 46.9819 20.6354C46.7417 20.6202 46.584 20.6133 46.5089 20.6147C44.8062 20.6035 42.1025 20.7405 38.398 21.0256C34.6946 21.3151 32.1692 21.5785 30.8217 21.8158C30.7205 21.8432 30.6424 21.8596 30.5872 21.8651C30.532 21.8706 30.4727 21.8607 30.4092 21.8354C30.3413 21.8113 30.2816 21.7566 30.2302 21.6714C30.18 21.5906 30.1353 21.4776 30.096 21.3324Z" fill="#002970"/>' +
      '      <path d="M7.15137 8.43066C7.6071 8.63574 7.98535 8.91146 8.28613 9.25781C8.59147 9.60417 8.74414 9.95964 8.74414 10.3242C8.74414 10.8301 8.58008 11.3519 8.25195 11.8896C7.92839 12.4229 7.52507 12.8991 7.04199 13.3184C6.56348 13.7376 6.06445 14.1204 5.54492 14.4668C5.02995 14.8132 4.56055 15.0798 4.13672 15.2666C3.71745 15.4535 3.42122 15.5469 3.24805 15.5469C2.94727 15.5469 2.5485 15.376 2.05176 15.0342C1.55957 14.6924 1.31348 14.4007 1.31348 14.1592C1.31348 12.9014 1.49577 11.4089 1.86035 9.68164C2.22493 7.95443 2.63053 6.36621 3.07715 4.91699C2.69434 4.49772 2.49382 4.13542 2.47559 3.83008C2.47559 3.73893 2.5166 3.66829 2.59863 3.61816C3.18652 3.34928 3.87012 3.13965 4.64941 2.98926C5.42871 2.83887 6.1123 2.7819 6.7002 2.81836C7.56608 2.86393 8.37044 3.30371 9.11328 4.1377C9.46875 4.56608 9.5804 5.04915 9.44824 5.58691C9.31608 6.12012 9.04036 6.64193 8.62109 7.15234C8.20182 7.6582 7.71191 8.08431 7.15137 8.43066ZM7.68457 4.56836C7.05111 4.49544 6.28092 4.58887 5.37402 4.84863C5.11426 5.60514 4.83398 6.58952 4.5332 7.80176C6.40169 6.7946 7.45215 5.7168 7.68457 4.56836ZM3.55566 13.1953C4.34863 12.7396 5.06185 12.1995 5.69531 11.5752C6.32878 10.9463 6.66374 10.3561 6.7002 9.80469C5.85254 9.69076 4.94792 9.85482 3.98633 10.2969C3.79036 11.3724 3.64681 12.3385 3.55566 13.1953ZM16.9199 15.2393C16.6009 15.2393 16.2158 15.1549 15.7646 14.9863C15.3135 14.8177 15.0879 14.5944 15.0879 14.3164C15.0879 13.9518 15.1449 13.348 15.2588 12.5049C15.3773 11.6572 15.4775 11.0101 15.5596 10.5635C15.2223 11.1787 14.7848 11.8851 14.2471 12.6826C13.7139 13.4801 13.3174 13.9906 13.0576 14.2139C12.9665 14.305 12.8343 14.3529 12.6611 14.3574C12.374 14.3574 12.0915 14.3141 11.8135 14.2275C11.54 14.1364 11.2689 13.9928 11 13.7969C10.7357 13.6009 10.5215 13.3138 10.3574 12.9355C10.1979 12.5573 10.1182 12.1107 10.1182 11.5957C10.1182 9.91406 10.7288 7.25033 11.9502 3.60449C11.9775 3.51335 12.0573 3.46549 12.1895 3.46094C12.5085 3.46094 12.9095 3.59082 13.3926 3.85059C13.8757 4.10579 14.1172 4.34505 14.1172 4.56836C14.1172 4.60482 14.1035 4.66634 14.0762 4.75293C13.0007 7.96582 12.431 10.2604 12.3672 11.6367C12.9368 10.944 13.6683 9.75228 14.5615 8.06152C15.4548 6.37077 16.2363 4.73926 16.9062 3.16699C16.9518 3.05306 17.0361 2.99837 17.1592 3.00293C17.4372 3.00293 17.7926 3.12142 18.2256 3.3584C18.6631 3.59538 18.8818 3.80729 18.8818 3.99414C18.8818 4.04883 18.8727 4.11491 18.8545 4.19238C18.4808 5.68717 18.1276 7.46908 17.7949 9.53809C17.4622 11.6025 17.2959 13.1566 17.2959 14.2002C17.2959 14.305 17.3027 14.4326 17.3164 14.583C17.3301 14.7288 17.3369 14.8268 17.3369 14.877C17.3369 15.0091 17.3096 15.1025 17.2549 15.1572C17.2002 15.2119 17.0885 15.2393 16.9199 15.2393ZM23.5166 15.5879C23.1976 15.5879 22.7829 15.4694 22.2725 15.2324C21.7666 14.9954 21.5137 14.7129 21.5137 14.3848C21.5137 14.2526 21.5319 14.1637 21.5684 14.1182C21.6048 14.0726 21.6709 14.0498 21.7666 14.0498C22.8285 11.9489 23.6351 10.151 24.1865 8.65625C23.8493 9.08464 23.4437 9.51986 22.9697 9.96191C22.4958 10.3994 22.1745 10.6182 22.0059 10.6182C21.7279 10.6182 21.3861 10.4997 20.9805 10.2627C20.5794 10.0257 20.3242 9.74772 20.2148 9.42871C20.1602 9.26009 20.1305 9.0459 20.126 8.78613C20.126 8.00228 20.2855 6.8903 20.6045 5.4502C20.9235 4.00553 21.1719 3.03939 21.3496 2.55176C21.3861 2.44694 21.4932 2.39681 21.6709 2.40137C21.9717 2.40137 22.3408 2.50846 22.7783 2.72266C23.2158 2.93685 23.4346 3.13737 23.4346 3.32422C23.4346 3.34245 23.4209 3.38802 23.3936 3.46094C23.2523 3.79818 23.0358 4.48861 22.7441 5.53223C22.457 6.57129 22.2747 7.45085 22.1973 8.1709C23.6738 6.62142 24.9202 5.0332 25.9365 3.40625C26.0094 3.2832 26.1211 3.22396 26.2715 3.22852C26.5723 3.22852 26.9346 3.33333 27.3584 3.54297C27.7822 3.7526 27.9941 3.94629 27.9941 4.12402C27.9941 4.16048 27.9759 4.2334 27.9395 4.34277C27.5384 5.5459 26.848 7.47363 25.8682 10.126C24.8883 12.7783 24.2025 14.5579 23.8105 15.4648C23.7741 15.5469 23.6761 15.5879 23.5166 15.5879ZM35.5752 15.2666C35.1924 15.2666 34.7982 15.1846 34.3926 15.0205C33.9915 14.8564 33.791 14.6582 33.791 14.4258C33.791 13.9792 33.8844 13.5508 34.0713 13.1406C34.3311 11.6003 34.625 10.1283 34.9531 8.72461C35.2812 7.31641 35.5205 6.41178 35.6709 6.01074C35.4202 6.15202 35.0762 6.39355 34.6387 6.73535C34.2057 7.07259 33.9574 7.28451 33.8936 7.37109C33.848 7.42578 33.7956 7.45312 33.7363 7.45312C33.513 7.45312 33.2191 7.29362 32.8545 6.97461C32.4899 6.65104 32.3076 6.37305 32.3076 6.14062C32.3076 6.05859 32.3737 5.9515 32.5059 5.81934C32.8887 5.43652 33.6771 4.87142 34.8711 4.12402C36.0651 3.37663 36.7464 3.00293 36.915 3.00293C37.111 3.00293 37.4209 3.17611 37.8447 3.52246C38.2731 3.86426 38.4873 4.14909 38.4873 4.37695C38.4873 4.42253 38.4486 4.51595 38.3711 4.65723C37.9518 5.41374 37.5303 6.76042 37.1064 8.69727C36.6826 10.6296 36.334 12.7533 36.0605 15.0684C36.0469 15.2005 35.8851 15.2666 35.5752 15.2666ZM50.1768 7.34375C50.4183 7.34375 50.7305 7.51921 51.1133 7.87012C51.4961 8.21647 51.6875 8.50814 51.6875 8.74512C51.6875 8.80892 51.6465 8.96615 51.5645 9.2168C51.0039 10.8802 50.5687 13.1543 50.2588 16.0391C50.2497 16.2077 50.1152 16.2897 49.8555 16.2852C49.5 16.2852 49.1331 16.2031 48.7549 16.0391C48.3766 15.8796 48.1875 15.6836 48.1875 15.4512C48.1875 15.1504 48.4222 13.9541 48.8916 11.8623C48.3857 12.4137 47.9255 12.9515 47.5107 13.4756C47.096 13.9951 46.8158 14.346 46.6699 14.5283C46.5241 14.7106 46.3669 14.8587 46.1982 14.9727C46.0342 15.082 45.8291 15.1367 45.583 15.1367C45.1911 15.1367 44.7695 15.0365 44.3184 14.8359C43.8672 14.6354 43.5391 14.4098 43.334 14.1592C42.9876 13.7308 42.8145 13.054 42.8145 12.1289C42.8145 11.2721 42.9671 10.3014 43.2725 9.2168C43.5824 8.1276 43.9766 7.11133 44.4551 6.16797C44.9382 5.22461 45.501 4.43164 46.1436 3.78906C46.7907 3.14193 47.4219 2.81836 48.0371 2.81836C48.8483 2.81836 49.6025 3.09408 50.2998 3.64551C51.0016 4.19694 51.3525 4.88737 51.3525 5.7168C51.3525 5.94922 51.3298 6.10189 51.2842 6.1748C51.2386 6.24316 51.127 6.27734 50.9492 6.27734C50.612 6.27734 50.2314 6.17936 49.8076 5.9834C49.3838 5.78743 49.1719 5.56413 49.1719 5.31348C49.1719 4.92155 49.0739 4.57064 48.8779 4.26074C47.9619 4.8304 47.1006 6.00846 46.2939 7.79492C45.4873 9.58138 45.084 11.3382 45.084 13.0654C46.1185 11.8076 47.2692 10.5293 48.5361 9.23047C48.2946 9.07096 48.0736 8.88184 47.873 8.66309C47.6725 8.44434 47.5723 8.27572 47.5723 8.15723C47.5723 8.09342 47.611 8.04557 47.6885 8.01367C47.8753 7.94076 48.2992 7.81087 48.96 7.62402C49.6208 7.43717 50.0264 7.34375 50.1768 7.34375ZM58.8789 2.80469C59.2344 2.80469 59.5397 3.03483 59.7949 3.49512C60.0547 3.95085 60.1846 4.31771 60.1846 4.5957C60.1846 4.71875 60.1276 4.78483 60.0137 4.79395C59.0339 4.90788 57.9469 5.13118 56.7529 5.46387C56.5296 6.03353 56.2676 6.82194 55.9668 7.8291C56.7051 7.56934 57.1494 7.43945 57.2998 7.43945C57.4867 7.43945 57.7487 7.64225 58.0859 8.04785C58.4277 8.45345 58.5986 8.75879 58.5986 8.96387C58.5986 9.0778 58.5531 9.13932 58.4619 9.14844C58.0062 9.21224 57.4707 9.35807 56.8555 9.58594C56.2448 9.80924 55.7298 10.028 55.3105 10.2422C55.0417 11.2949 54.8594 12.1995 54.7637 12.9561C55.2285 12.6188 55.7822 12.277 56.4248 11.9307C57.0719 11.5798 57.4411 11.4043 57.5322 11.4043C57.7646 11.4043 58.0495 11.6117 58.3867 12.0264C58.724 12.4411 58.8926 12.7692 58.8926 13.0107C58.8926 13.1156 58.8652 13.1771 58.8105 13.1953C57.6439 13.6602 56.2425 14.4759 54.6064 15.6426C54.5153 15.7064 54.4219 15.7406 54.3262 15.7451C54.0482 15.7451 53.6699 15.5492 53.1914 15.1572C52.7174 14.7653 52.4805 14.4554 52.4805 14.2275C52.4805 13.4072 52.6673 12.195 53.041 10.5908C53.4147 8.98665 53.8431 7.43717 54.3262 5.94238C54.0664 5.78288 53.8226 5.58008 53.5947 5.33398C53.3669 5.08789 53.2529 4.88509 53.2529 4.72559C53.2529 4.64355 53.2894 4.58203 53.3623 4.54102C53.7269 4.34505 54.5426 4.05339 55.8096 3.66602C57.0811 3.27865 58.0381 3.03939 58.6807 2.94824C58.7217 2.85254 58.7878 2.80469 58.8789 2.80469ZM66.8701 2.61328C67.1299 2.61328 67.4079 2.80924 67.7041 3.20117C68.0003 3.5931 68.1484 3.93262 68.1484 4.21973C68.1484 4.45215 67.9753 4.56836 67.6289 4.56836C67.123 4.56836 66.1296 4.72786 64.6484 5.04688C64.7624 5.17904 64.8171 5.28613 64.8125 5.36816V5.40918C64.4206 6.986 64.0423 8.74512 63.6777 10.6865C63.3314 12.4775 63.1605 13.986 63.165 15.2119C63.165 15.3805 63.0146 15.4648 62.7139 15.4648C62.404 15.4648 62.0508 15.3874 61.6543 15.2324C61.2578 15.0775 61.0003 14.9066 60.8818 14.7197C60.8363 14.6468 60.8135 14.5078 60.8135 14.3027C60.8135 14.0339 60.8682 13.8743 60.9775 13.8242C61.1006 12.0879 61.6247 9.32617 62.5498 5.53906C61.9346 5.69857 61.4766 5.82389 61.1758 5.91504C61.0072 5.96973 60.9183 5.99707 60.9092 5.99707C60.695 5.99707 60.4193 5.80339 60.082 5.41602C59.7448 5.02865 59.5762 4.72331 59.5762 4.5C59.5762 4.39518 59.6377 4.31999 59.7607 4.27441C60.3395 4.06022 61.5312 3.72982 63.3359 3.2832C65.1406 2.83659 66.3187 2.61328 66.8701 2.61328ZM75.1826 15.2666C74.7998 15.2666 74.4056 15.1846 74 15.0205C73.599 14.8564 73.3984 14.6582 73.3984 14.4258C73.3984 13.9792 73.4919 13.5508 73.6787 13.1406C73.9385 11.6003 74.2324 10.1283 74.5605 8.72461C74.8887 7.31641 75.1279 6.41178 75.2783 6.01074C75.0277 6.15202 74.6836 6.39355 74.2461 6.73535C73.8132 7.07259 73.5648 7.28451 73.501 7.37109C73.4554 7.42578 73.403 7.45312 73.3438 7.45312C73.1204 7.45312 72.8265 7.29362 72.4619 6.97461C72.0973 6.65104 71.915 6.37305 71.915 6.14062C71.915 6.05859 71.9811 5.9515 72.1133 5.81934C72.4961 5.43652 73.2845 4.87142 74.4785 4.12402C75.6725 3.37663 76.3538 3.00293 76.5225 3.00293C76.7184 3.00293 77.0283 3.17611 77.4521 3.52246C77.8805 3.86426 78.0947 4.14909 78.0947 4.37695C78.0947 4.42253 78.056 4.51595 77.9785 4.65723C77.5592 5.41374 77.1377 6.76042 76.7139 8.69727C76.29 10.6296 75.9414 12.7533 75.668 15.0684C75.6543 15.2005 75.4925 15.2666 75.1826 15.2666Z" fill="#002970"/>' +
      "    </svg>";
  }

  if (icon_id == "badge-kab-ribbon") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="25" height="35" fill="none" viewBox="0 0 51 70" >' +
      '      <path fill-rule="evenodd" clip-rule="evenodd" d="M25.1187 11.4512C22.455 11.4512 20.686 12.3747 20.1319 12.9288C19.8241 12.3131 19.0237 10.4169 18.285 7.75726C17.5462 5.09763 18.5928 2.83201 19.2084 2.03166C19.9472 1.35444 22.2005 0 25.3034 0C28.4063 0 30.5365 1.47757 31.2137 2.21636C31.2728 2.36416 31.3448 2.51196 31.4219 2.67037C31.8267 3.50168 32.3736 4.62497 31.9525 7.57256C31.657 9.64116 30.5981 12.0053 30.1055 12.9288C29.5515 12.4978 27.8892 11.4512 25.1187 11.4512ZM0 58.7335L9.97361 70C16.9921 59.4723 32.876 35.0924 37.6781 24.7493C42.4802 14.4063 36.7546 6.83377 32.3219 3.13984C33.6148 4.43272 34.2797 9.30871 30.2902 16.2533C23.9241 27.3351 9.05013 47.0976 0 58.7335ZM33.4301 36.2005L26.2269 48.3905C26.8098 49.3231 27.6107 50.6641 28.4963 52.147L28.4966 52.1475L28.4966 52.1476C29.4817 53.7971 30.5717 55.6221 31.5831 57.2559C33.1301 59.755 36.5381 64.7779 38.7387 68.0213L38.7404 68.0237C39.2714 68.8064 39.7321 69.4853 40.0792 70L50.2375 58.7335C48.9446 57.1328 45.5092 52.8232 42.1108 48.3905C38.7124 43.9578 34.9076 38.4169 33.4301 36.2005ZM17.9156 3.13984C15.6992 4.80211 11.983 10.1985 10.8971 14.4063C9.57593 19.5258 11.9464 23.907 15.6318 30.7187L15.632 30.719C16.0682 31.5253 16.5229 32.3657 16.9921 33.2454L24.1953 22.7177C22.5945 20.686 19.2084 15.1451 17.9156 11.6359C16.44 7.63088 16.6227 4.80211 17.9156 3.13984ZM40.0792 62.4736C42.2468 62.4736 44.004 60.7164 44.004 58.5488C44.004 56.3812 42.2468 54.624 40.0792 54.624C37.9115 54.624 36.1544 56.3812 36.1544 58.5488C36.1544 60.7164 37.9115 62.4736 40.0792 62.4736ZM40.0792 63.1662C42.6293 63.1662 44.6966 61.0989 44.6966 58.5488C44.6966 55.9987 42.6293 53.9314 40.0792 53.9314C37.529 53.9314 35.4617 55.9987 35.4617 58.5488C35.4617 61.0989 37.529 63.1662 40.0792 63.1662ZM39.3256 56.6081C39.3627 56.5247 39.4453 56.471 39.5366 56.471H40.7718L38.9857 60.4895C38.9487 60.5729 38.866 60.6267 38.7748 60.6267H37.5396L39.3256 56.6081ZM41.3835 56.471C41.2923 56.471 41.2096 56.5247 41.1726 56.6081L39.3865 60.6267H40.6217C40.713 60.6267 40.7957 60.5729 40.8327 60.4895L42.6187 56.471H41.3835Z" fill="#EB058C"/>' +
      "    </svg>";
  }

  if (icon_id == "badge-regular-fit") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="85" height="22" fill="none" viewBox="0 0 85 22">' +
      '      <path d="M31.096 21.332a3.049 3.049 0 01-.076-1.12c.037-.401.137-.624.3-.668.721-.195 3.107-.426 7.157-.691 4.054-.267 7.644-.436 10.769-.507.181-.012.304.102.368.34.075.276.079.648.012 1.115-.066.471-.223.74-.469.807a1.973 1.973 0 01-.503.05 7.612 7.612 0 01-.672-.023 7.43 7.43 0 00-.473-.02c-1.703-.011-4.407.126-8.111.41-3.703.29-6.229.553-7.576.79-.101.028-.18.045-.235.05a.378.378 0 01-.178-.03.357.357 0 01-.179-.164 1.299 1.299 0 01-.134-.339zM10.36 12.197c.082-.036.185-.022.308.041.123.06.184.183.184.37 0 .223-.164.542-.492.957-.328.414-.608.622-.84.622-.242 0-1.094-.237-2.557-.711-1.458-.479-2.7-.942-3.726-1.388-.196 1.044-.298 1.81-.307 2.297 0 .027.004.077.013.15.01.069.014.126.014.171a.432.432 0 01-.048.219c-.027.05-.105.098-.232.143a1.556 1.556 0 01-.52.069c-.392 0-.734-.07-1.025-.212a.73.73 0 01-.43-.698c0-.063.027-.22.081-.471.25-1.941.848-4.564 1.791-7.868a3.687 3.687 0 01-.58-.739c-.183-.3-.274-.535-.274-.704 0-.105.052-.184.157-.239.579-.319 1.278-.608 2.099-.868.82-.26 1.554-.39 2.2-.39.757 0 1.404.299 1.942.896.542.597.814 1.203.814 1.818 0 .652-.363 1.454-1.087 2.406a18.625 18.625 0 01-2.495 2.687c2.091.71 3.762 1.192 5.01 1.442zm-3.165-7.43c-.606-.114-1.342-.003-2.208.335a147.123 147.123 0 00-1.08 3.992c.82-.72 1.55-1.481 2.188-2.283.642-.803 1.01-1.484 1.1-2.044zm10.282 5.694c.223 0 .487.221.793.663.31.438.464.786.464 1.046 0 .114-.04.17-.123.17-.383 0-1.476.36-3.28 1.08-1.801.716-3.12 1.354-3.959 1.915a.357.357 0 01-.212.068c-.241 0-.59-.148-1.046-.444-.45-.3-.677-.55-.677-.745 0-.392.185-1.47.554-3.234.37-1.763.8-3.479 1.292-5.147a3.016 3.016 0 01-.724-.677c-.233-.296-.349-.528-.349-.697 0-.073.027-.125.082-.157.497-.26 1.41-.586 2.741-.978 1.335-.392 2.158-.588 2.468-.588.26 0 .533.203.82.609.292.405.438.729.438.97 0 .046-.003.087-.007.123a.357.357 0 01-.02.083.124.124 0 01-.042.054.4.4 0 00-.04.034c-.01.01-.032.016-.069.02a.586.586 0 01-.061.008h-.151c-.588 0-1.504.196-2.748.588-.16.542-.374 1.337-.643 2.385.634-.241.985-.364 1.053-.369.16 0 .404.187.732.56.332.374.499.664.499.869 0 .091-.05.148-.15.17-.757.17-1.637.454-2.64.855a39.727 39.727 0 00-.587 2.953 50.924 50.924 0 012.632-1.141c.897-.36 1.6-.624 2.105-.793.506-.169.79-.253.855-.253zm7.649-2.01c0 .037-.01.091-.027.164-.42 1.887-.727 3.963-.923 6.228 0 .027.002.061.007.102a.72.72 0 01.006.082c0 .27-.038.445-.116.527-.073.086-.184.13-.335.13-.31 0-.663-.087-1.06-.26-.391-.169-.587-.38-.587-.636 0-.56.125-1.554.376-2.98-.711 1.148-1.249 1.95-1.613 2.406-.196.232-.46.35-.793.355-.429 0-.976-.198-1.641-.594-1.016-.607-1.525-1.823-1.525-3.65 0-1.122.197-2.245.588-3.37.392-1.131.964-2.088 1.716-2.872.752-.784 1.575-1.176 2.468-1.176.31 0 .6.06.868.178.346.15.61.28.793.39.182.104.38.26.595.464.214.206.364.458.451.76.091.295.137.653.137 1.072 0 .329-.028.547-.082.657-.05.105-.178.157-.383.157-.337 0-.713-.096-1.128-.287-.415-.192-.622-.394-.622-.609a17.523 17.523 0 01.027-.39c.014-.113.02-.22.02-.32 0-.338-.024-.604-.074-.8-.652.337-1.23.913-1.737 1.73a10.135 10.135 0 00-1.148 2.706c2.297-.67 3.65-1.005 4.06-1.005.301 0 .657.091 1.067.274.41.182.615.371.615.567zm-5.783 4.13c.25-.224.61-.641 1.08-1.252.474-.615.923-1.24 1.347-1.873-.971.337-1.55.506-1.737.506-.25 0-.54-.089-.868-.267-.064.401-.098.82-.102 1.258 0 .684.093 1.226.28 1.627zm13.706 2.487c-.328 0-.704-.09-1.128-.273-.424-.182-.636-.346-.636-.492 0-.739.07-1.86.212-3.364-.83 1.454-1.438 2.425-1.825 2.913-.383.487-.74.731-1.073.731-.251 0-.502-.034-.752-.103a3.48 3.48 0 01-.766-.341c-.26-.155-.47-.392-.629-.711-.155-.324-.232-.709-.232-1.155 0-1.149.257-2.721.772-4.717.52-2.001.966-3.496 1.34-4.485.037-.105.139-.155.308-.15.3 0 .67.116 1.107.349.438.232.656.442.656.628 0 .019-.009.055-.027.11-1.13 3.418-1.798 6.163-2.003 8.237 1.29-1.905 2.746-4.603 4.368-8.094l.028-.068c.054-.105.175-.157.362-.157.31 0 .656.1 1.039.3.383.201.574.4.574.595 0 .028-.009.07-.027.13-.839 2.52-1.26 5.647-1.265 9.38.037.104.057.22.062.348 0 .26-.155.39-.465.39zm3.575.424c-.3 0-.663-.15-1.087-.451-.424-.296-.636-.533-.636-.71 0-.028.02-.074.062-.138a.56.56 0 00.075-.232A49.27 49.27 0 0137.643 3.2c.045-.123.139-.184.28-.184.319 0 .713.111 1.182.335.474.223.711.428.711.615 0 .036-.02.107-.061.212-1.14 3.044-1.932 6.01-2.379 8.9.71-.3 1.556-.606 2.536-.916.98-.31 1.55-.465 1.71-.465.24 0 .52.221.84.663.323.442.485.775.485.998 0 .064-.018.103-.054.117-.392.15-.65.234-.773.252-.064.01-.132-.01-.205-.061-.615.132-1.433.376-2.454.731-1.016.356-1.818.682-2.406.978a.913.913 0 01-.431.116zm13.993-8.148c.224 0 .481.214.773.642.296.429.444.76.444.992 0 .205-.055.307-.164.307-.278 0-.577.03-.896.089-.419.073-1.118.244-2.098.513a162.43 162.43 0 00.232 4.375c.032.387.048.588.048.601 0 .278-.216.417-.65.417-.337 0-.701-.075-1.093-.225-.388-.15-.606-.294-.656-.431a1.485 1.485 0 01-.082-.451c0-.046.022-.126.068-.24-.018-.952-.027-2.084-.027-3.397-1.035.328-1.832.609-2.393.841-.328 1.326-.529 2.39-.601 3.192-.01.114-.108.169-.294.164-.32 0-.702-.102-1.149-.307-.447-.205-.67-.401-.67-.588 0-1.053.472-2.942 1.415-5.667.948-2.725 1.707-4.514 2.277-5.366.054-.082.152-.123.294-.123.328 0 .697.134 1.107.403v-.267c0-.26.24-.39.718-.39.31 0 .608.06.895.178.287.114.43.256.43.424 0 1.345.02 2.97.056 4.874 1.23-.373 1.902-.56 2.016-.56zm-5.892 1.832l.95-.322c.42-.14.695-.234.827-.28V4.637c-.588 1.066-1.18 2.58-1.777 4.539zm15.196 3.021c.082-.036.184-.022.307.041.124.06.185.183.185.37 0 .223-.164.542-.492.957-.328.414-.608.622-.84.622-.242 0-1.095-.237-2.558-.711-1.458-.479-2.7-.942-3.725-1.388-.196 1.044-.299 1.81-.308 2.297 0 .027.005.077.014.15.009.069.014.126.014.171a.432.432 0 01-.048.219c-.028.05-.105.098-.233.143a1.556 1.556 0 01-.52.069c-.391 0-.733-.07-1.025-.212a.73.73 0 01-.43-.698c0-.063.027-.22.082-.471.25-1.941.847-4.564 1.79-7.868a3.687 3.687 0 01-.58-.739c-.183-.3-.274-.535-.274-.704 0-.105.053-.184.157-.239.58-.319 1.279-.608 2.1-.868.82-.26 1.553-.39 2.2-.39.757 0 1.404.299 1.942.896.542.597.813 1.203.813 1.818 0 .652-.362 1.454-1.087 2.406a18.63 18.63 0 01-2.495 2.687c2.092.71 3.762 1.192 5.01 1.442zm-3.165-7.43c-.606-.114-1.342-.003-2.208.335a146.872 146.872 0 00-1.08 3.992c.82-.72 1.55-1.481 2.187-2.283.643-.803 1.01-1.484 1.1-2.044zm16.01-2.174c.268 0 .542.205.82.615.278.406.417.716.417.93 0 .132-.07.207-.212.225-1.522.16-3.432.54-5.728 1.142-.15.483-.329 1.146-.534 1.99.73-.242 1.156-.363 1.279-.363.214 0 .483.182.806.547.328.364.492.663.492.895 0 .114-.068.19-.205.226-.97.241-1.918.53-2.843.868-.429 2.12-.638 3.723-.63 4.813a.569.569 0 01.042.225c0 .114-.032.196-.096.246-.06.05-.191.075-.396.075-.383 0-.777-.095-1.183-.287-.406-.191-.609-.403-.609-.636 0-.81.201-2.187.602-4.128-.401-.438-.602-.784-.602-1.04 0-.063.032-.113.096-.15.15-.082.44-.219.868-.41.196-.802.374-1.493.534-2.071-.224-.028-.493-.226-.807-.595-.31-.37-.465-.665-.465-.889 0-.105.037-.175.11-.212.373-.177 1.665-.558 3.875-1.141 2.21-.584 3.667-.875 4.369-.875zM72.588 15c-.365 0-.75-.087-1.155-.26-.406-.173-.609-.362-.609-.567 0-.661.194-2.156.581-4.485.388-2.328.862-4.4 1.422-6.213.037-.142.185-.21.445-.205.328 0 .692.088 1.093.266.401.178.602.36.602.547 0 .018-.01.055-.028.11-.328 1.043-.676 2.506-1.045 4.388a62.226 62.226 0 00-.807 5.12.23.23 0 01.075.137c0 .524-.036.85-.11.977-.068.123-.223.185-.464.185zM83.19 2.401c.196 0 .445.24.746.718.305.474.458.823.458 1.046 0 .242-.128.362-.383.362a.456.456 0 01-.24-.082c-.082-.054-.14-.082-.177-.082-.037 0-.192.014-.465.041-.269.028-.681.085-1.237.171a30.74 30.74 0 00-1.641.287 53.549 53.549 0 00-1.586 6.03c-.42 2.087-.629 3.42-.629 3.999 0 .054.02.125.062.211a.662.662 0 01.061.274c0 .287-.2.433-.601.438-.383 0-.803-.11-1.258-.329-.456-.218-.684-.442-.684-.67 0-.464.217-1.695.65-3.691.433-2 .897-3.858 1.394-5.571-.56.177-1.07.373-1.531.588a3.27 3.27 0 00-.15.082c-.064.036-.121.063-.171.082a.441.441 0 01-.164.027c-.196 0-.488-.21-.875-.629-.388-.42-.582-.709-.582-.868 0-.105.064-.19.192-.253.66-.328 2.226-.772 4.696-1.333 2.475-.565 3.846-.848 4.115-.848z" fill="currentColor"/>' +
      "    </svg>";
  }

  if (icon_id == "badge-oversized-fit") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="96" height="22" fill="none" viewBox="0 0 96 22">' +
      '      <path d="M37.096 21.332a3.049 3.049 0 01-.076-1.12c.037-.401.137-.624.3-.668.721-.195 3.107-.426 7.157-.691 4.054-.267 7.644-.436 10.769-.507.181-.011.304.102.368.34.075.276.079.648.012 1.115-.066.471-.223.74-.469.807a1.973 1.973 0 01-.503.05 7.612 7.612 0 01-.672-.023 7.43 7.43 0 00-.473-.02c-1.703-.011-4.407.126-8.111.41-3.703.29-6.229.554-7.576.79-.102.028-.18.045-.235.05s-.114-.004-.178-.03a.357.357 0 01-.179-.164 1.299 1.299 0 01-.134-.339zM4.916 3.324a3.37 3.37 0 012.386.95c.674.634 1.011 1.452 1.011 2.455 0 .81-.12 1.695-.362 2.652-.241.957-.56 1.852-.957 2.686S6.105 13.6 5.518 14.16c-.588.56-1.194.841-1.819.841-.56 0-1.112-.19-1.654-.567-.542-.379-.898-.83-1.066-1.354-.142-.42-.21-.973-.206-1.661 0-1.062.149-2.23.445-3.507.3-1.276.567-2.087.8-2.433.054-.092.17-.137.348-.137.114 0 .265.023.451.068.178-.56.46-1.048.848-1.463s.804-.622 1.251-.622zm.615 5.995c.347-1.194.52-2.324.52-3.39 0-.456-.039-.82-.116-1.094-.356.232-.657.588-.903 1.066-.246.474-.369.916-.369 1.327 0 .054.005.12.014.198.009.073.013.12.013.143 0 .105-.088.155-.266.15-.169 0-.392-.045-.67-.136-.515 1.782-.773 3.26-.773 4.437 0 .651.067 1.137.199 1.456.989-.725 1.772-2.11 2.351-4.157zm6.659 5.572c-.684 0-1.2-.158-1.546-.472-.341-.315-.601-.934-.779-1.86-.178-.93-.266-2.305-.266-4.128 0-1.737.098-3.389.294-4.956.027-.215.298-.322.813-.322.346 0 .672.05.978.15.31.096.464.215.464.356 0 .01-.011.062-.034.157-.132.652-.255 1.826-.369 3.52-.114 1.692-.134 3.102-.061 4.232.337-1.112.843-2.436 1.517-3.971.68-1.54 1.242-2.712 1.689-3.514.16-.278.319-.42.478-.424.242 0 .6.132 1.073.397.479.26.718.496.718.71 0 .092-.08.27-.24.534a.718.718 0 01-.307.28c-.597.998-1.31 2.431-2.14 4.3-.824 1.864-1.424 3.454-1.797 4.771-.046.16-.208.24-.486.24zm11.887-4.43c.223 0 .488.221.793.663.31.437.465.786.465 1.046 0 .114-.041.17-.123.17-.383 0-1.477.36-3.281 1.08-1.8.716-3.12 1.354-3.958 1.915a.357.357 0 01-.212.068c-.242 0-.59-.148-1.046-.444-.451-.3-.677-.55-.677-.745 0-.392.185-1.47.554-3.234.369-1.763.8-3.479 1.292-5.147a3.015 3.015 0 01-.725-.677c-.232-.296-.348-.528-.348-.697 0-.073.027-.125.082-.157.496-.26 1.41-.586 2.74-.978 1.336-.392 2.159-.588 2.469-.588.26 0 .533.203.82.609.292.405.437.729.437.97a.99.99 0 01-.006.123.357.357 0 01-.021.083.125.125 0 01-.041.054.4.4 0 00-.041.034c-.01.01-.032.016-.068.02-.032.005-.053.008-.062.008h-.15c-.588 0-1.504.196-2.748.588-.16.542-.374 1.337-.643 2.385.634-.241.985-.364 1.053-.369.16 0 .403.187.731.56.333.374.5.664.5.869 0 .091-.05.148-.151.17-.757.17-1.636.454-2.639.855a39.772 39.772 0 00-.588 2.953 50.924 50.924 0 012.632-1.141c.898-.36 1.6-.625 2.106-.793.506-.169.79-.253.854-.253zm9.112 1.736c.083-.036.185-.023.308.041.123.06.185.183.185.37 0 .223-.164.542-.492.956-.329.415-.609.622-.841.622-.242 0-1.094-.237-2.557-.71-1.458-.479-2.7-.942-3.726-1.388-.196 1.043-.298 1.81-.307 2.297 0 .027.004.077.014.15.009.068.013.125.013.171a.432.432 0 01-.048.219c-.027.05-.104.098-.232.143a1.557 1.557 0 01-.52.069c-.392 0-.733-.07-1.025-.212a.73.73 0 01-.43-.698c0-.063.027-.22.081-.471.251-1.942.848-4.564 1.791-7.868a3.687 3.687 0 01-.58-.739c-.183-.3-.274-.535-.274-.704 0-.105.052-.184.157-.239.579-.319 1.278-.608 2.099-.868s1.554-.39 2.2-.39c.757 0 1.405.299 1.942.896.543.597.814 1.203.814 1.818 0 .652-.363 1.454-1.087 2.406a18.619 18.619 0 01-2.495 2.687c2.092.71 3.762 1.192 5.01 1.442zm-3.165-7.43c-.606-.114-1.342-.003-2.208.335a147.239 147.239 0 00-1.08 3.992c.82-.72 1.55-1.481 2.188-2.283.642-.803 1.01-1.484 1.1-2.044zm6.091 10.513c-1.112 0-2.05-.421-2.816-1.264-.761-.848-1.142-1.878-1.142-3.09 0-.25.023-.531.069-.841.027-.205.232-.308.615-.308.374 0 .759.091 1.155.274.397.182.595.38.595.594l-.007.15a4.77 4.77 0 00-.007.254c0 .606.132 1.173.397 1.702.269.529.608.873 1.018 1.032.242-.214.363-.535.363-.964 0-.474-.208-1.24-.623-2.297-.414-1.057-.827-2.107-1.237-3.15-.41-1.05-.615-1.801-.615-2.257 0-.72.228-1.29.683-1.709.456-.419 1.049-.629 1.778-.629.524 0 1.016.096 1.476.287.46.192.841.431 1.142.718.3.283.56.593.78.93.218.333.375.64.471.923.1.278.15.51.15.697 0 .196-.18.378-.54.547s-.713.253-1.06.253c-.364 0-.574-.107-.628-.321-.365-1.477-.91-2.332-1.634-2.564-.187.187-.28.444-.28.773 0 .31.132.813.396 1.51.265.693.554 1.388.868 2.085.315.693.604 1.429.869 2.208s.396 1.392.396 1.84c0 .756-.24 1.382-.718 1.879-.474.492-1.112.738-1.914.738zm6.05-.28c-.364 0-.75-.087-1.155-.26-.406-.173-.609-.362-.609-.567 0-.661.194-2.156.581-4.485.388-2.328.862-4.4 1.422-6.213.037-.142.185-.21.445-.205.328 0 .692.088 1.093.266.401.178.602.36.602.547 0 .018-.01.055-.027.11-.328 1.043-.677 2.506-1.046 4.388a62.266 62.266 0 00-.807 5.12c.046.046.07.091.075.137 0 .524-.036.85-.11.977-.067.123-.222.185-.464.185zm3.568.28c-.241 0-.551-.205-.93-.615-.377-.41-.567-.743-.567-.998 0-.15.657-1.21 1.97-3.179a114.734 114.734 0 013.615-5.134c-1.043.32-1.893.623-2.55.91a.671.671 0 01-.225.068c-.223 0-.522-.198-.896-.595-.373-.396-.56-.706-.56-.93 0-.113.066-.193.198-.239.97-.346 1.942-.651 2.912-.916.97-.264 1.686-.44 2.147-.526.465-.091.729-.137.793-.137.232 0 .542.187.93.56.387.374.58.678.58.91 0 .073-.036.153-.109.24-.643.747-1.476 1.829-2.502 3.246a84.83 84.83 0 00-2.707 3.972 38.887 38.887 0 012.461-.855 47.91 47.91 0 012.222-.656c.574-.15.904-.225.99-.225.17 0 .409.234.719.704.314.465.471.83.471 1.093 0 .092-.047.155-.143.192-.091.036-.21.06-.356.068l-.232.007a39.8 39.8 0 00-4.355 1.251c-1.513.52-2.76 1.1-3.739 1.743a.222.222 0 01-.137.041zm16.024-4.82c.223 0 .488.222.793.664.31.437.465.786.465 1.046 0 .114-.041.17-.123.17-.383 0-1.477.36-3.282 1.08-1.8.716-3.12 1.354-3.958 1.915a.357.357 0 01-.212.068c-.241 0-.59-.148-1.046-.444-.45-.3-.676-.55-.676-.745 0-.392.184-1.47.553-3.234.37-1.763.8-3.479 1.292-5.147a3.015 3.015 0 01-.724-.677c-.233-.296-.349-.528-.349-.697 0-.073.028-.125.082-.157.497-.26 1.41-.586 2.741-.978 1.336-.392 2.158-.588 2.468-.588.26 0 .533.203.82.609.292.405.438.729.438.97a.99.99 0 01-.007.123.357.357 0 01-.02.083.125.125 0 01-.041.054.4.4 0 00-.041.034c-.01.01-.032.016-.069.02-.032.005-.052.008-.061.008h-.151c-.588 0-1.504.196-2.748.588-.16.542-.373 1.337-.642 2.385.633-.241.984-.364 1.052-.369.16 0 .404.187.732.56.333.374.499.664.499.869 0 .091-.05.148-.15.17-.757.17-1.637.454-2.64.855a39.779 39.779 0 00-.587 2.953 50.965 50.965 0 012.632-1.141c.898-.36 1.6-.625 2.105-.793.506-.169.791-.253.855-.253zm6.973-6.322c.624.633.936 1.355.936 2.167 0 .98-.33 2.176-.991 3.589-.656 1.408-1.415 2.625-2.277 3.65-.856 1.025-1.558 1.538-2.105 1.538-.597 0-1.242-.17-1.935-.513-.287-.14-.499-.321-.635-.54-.137-.219-.205-.535-.205-.95 0-1.417.494-3.746 1.483-6.986a3.179 3.179 0 01-.759-.636c-.241-.273-.362-.49-.362-.65 0-.081.043-.152.13-.211 1.513-1.007 2.944-1.511 4.293-1.511.916 0 1.725.35 2.426 1.053zm-4.97 8.989c.4-.365.825-.866 1.271-1.504.447-.642.868-1.344 1.265-2.105.396-.761.709-1.566.936-2.414.233-.847.31-1.604.233-2.269-.802-.046-1.689.169-2.66.643.365.214.547.44.547.676 0 .082-.045.31-.136.684-.01.045-.135.49-.376 1.333-.237.838-.401 1.429-.492 1.77-.087.338-.196.832-.328 1.484-.128.651-.215 1.219-.26 1.702zM83.878 2.593c.269 0 .542.205.82.615.278.406.417.715.417.93 0 .132-.07.207-.212.225-1.522.16-3.431.54-5.728 1.142-.15.483-.328 1.146-.533 1.99.729-.242 1.155-.363 1.278-.363.214 0 .483.182.807.547.328.364.492.663.492.895 0 .114-.069.19-.205.226-.971.241-1.919.53-2.844.868-.428 2.12-.638 3.723-.629 4.812a.569.569 0 01.041.226c0 .114-.032.196-.096.246-.059.05-.191.075-.396.075-.383 0-.777-.095-1.183-.287s-.608-.403-.608-.636c0-.81.2-2.187.601-4.128-.4-.438-.601-.784-.601-1.04 0-.063.032-.113.096-.15.15-.082.44-.219.868-.41.196-.802.373-1.493.533-2.071-.223-.028-.492-.226-.807-.595-.31-.37-.465-.665-.465-.889 0-.105.037-.175.11-.212.373-.177 1.665-.558 3.876-1.141 2.21-.584 3.666-.875 4.368-.875zM83.7 15c-.364 0-.75-.087-1.155-.26-.406-.173-.609-.362-.609-.567 0-.661.194-2.156.582-4.485.387-2.328.86-4.4 1.422-6.213.036-.142.184-.21.444-.205.328 0 .692.088 1.093.266.402.178.602.36.602.547 0 .018-.009.055-.027.11-.328 1.043-.677 2.506-1.046 4.388a62.226 62.226 0 00-.807 5.12.23.23 0 01.075.137c0 .524-.036.85-.109.977-.068.123-.223.185-.465.185zM94.303 2.401c.196 0 .444.24.745.718.305.474.458.823.458 1.046 0 .242-.128.362-.383.362a.456.456 0 01-.24-.082c-.081-.054-.14-.082-.177-.082-.036 0-.191.014-.465.041-.269.028-.681.085-1.237.171a30.74 30.74 0 00-1.64.287 53.549 53.549 0 00-1.587 6.03c-.419 2.087-.629 3.42-.629 3.999 0 .054.02.125.062.211a.662.662 0 01.061.274c0 .287-.2.433-.601.437-.383 0-.802-.109-1.258-.328-.456-.218-.684-.442-.684-.67 0-.464.217-1.695.65-3.691.433-2 .898-3.858 1.394-5.571-.56.177-1.07.373-1.53.588a3.324 3.324 0 00-.151.082c-.064.036-.12.063-.171.082a.441.441 0 01-.164.027c-.196 0-.488-.21-.875-.629-.388-.42-.581-.709-.581-.868 0-.105.064-.19.191-.253.661-.328 2.226-.772 4.696-1.333 2.475-.565 3.847-.848 4.116-.848z" fill="currentColor" />' +
      "    </svg>";
  }

  if (icon_id == "badge-20-off") {
    returnBadge =
      '<svg viewBox="0 0 1792.9 541.31" xmlns="http://www.w3.org/2000/svg"><path d="M1067.51,509.97c-42.2,2.9-83.75,6.12-125.62,9.02-32.53,2.58-65.39,4.51-97.92,7.73-38.98,2.9-77.95,6.44-116.6,9.99-18.68,1.61-38.01,2.9-56.69,4.51-14.17,.97-20.94-5.48-21.9-20.94-.64-7.73-.64-15.78,0-23.19,.64-12.24,7.73-20.94,18.68-24.48,14.82-4.51,29.96-8.05,45.1-9.02,48.32-3.54,96.31-6.12,144.63-8.7,29.96-1.61,59.91-3.54,89.87-5.48,40.59-2.58,81.49-5.48,122.08-8.05,15.78-.97,30.92-1.93,46.71-1.93,25.45,.64,42.52,21.9,28.99,47.67-9.02,16.75-19.65,26.41-39.94,24.48-12.24-1.61-24.48,0-36.4,0-.97-1.29-.97-1.61-.97-1.61Z" fill="#e62817"/><g fill="#e62817"><path d="m117.02 354.04c-30.77 0-56.71-11.69-77.83-35.09-21.12-23.39-31.68-51.85-31.68-85.4 0-6.93 0.63-14.69 1.89-23.26 0.76-5.67 6.43-8.51 17.02-8.51s20.99 2.52 31.97 7.57c10.97 5.04 16.46 10.53 16.46 16.46 0 0.25-0.07 1.61-0.19 4.07-0.13 2.46-0.19 4.82-0.19 7.09 0 16.77 3.69 32.47 11.06 47.1 7.38 14.63 16.74 24.15 28.09 28.56 6.68-5.93 10.02-14.82 10.02-26.67 0-13.11-5.74-34.3-17.21-63.55-11.48-29.25-22.89-58.35-34.23-87.29-11.35-28.94-17.02-49.71-17.02-62.32 0-19.92 6.3-35.68 18.91-47.29 12.61-11.6 29-17.4 49.18-17.4 14.5 0 28.12 2.65 40.85 7.94 12.73 5.3 23.26 11.89 31.59 19.77 8.32 7.88 15.51 16.45 21.56 25.72s10.43 17.78 13.15 25.53c2.71 7.76 4.07 14.22 4.07 19.39 0 5.42-4.98 10.47-14.94 15.13-9.96 4.67-19.74 7-29.32 7-10.09 0-15.89-2.96-17.4-8.89-10.09-40.85-25.16-64.5-45.21-70.93-5.17 5.17-7.75 12.29-7.75 21.37 0 8.58 3.66 22.48 10.97 41.71s15.32 38.46 24.02 57.69 16.71 39.63 24.02 61.19 10.97 38.52 10.97 50.88c0 20.93-6.59 38.24-19.77 51.92s-30.86 20.52-53.05 20.52z"/><path d="m482.25 134.45c6.18 0 13.33 5.93 21.47 17.78 8.13 11.85 12.2 20.99 12.2 27.43 0 5.67-1.51 8.51-4.54 8.51-7.69 0-15.95 0.82-24.78 2.46-11.6 2.02-30.96 6.75-58.07 14.19 1.01 25.09 2.14 48.86 3.4 71.31s2.3 39.03 3.12 49.74c0.82 10.72 1.23 16.27 1.23 16.64 0 7.69-5.99 11.54-17.97 11.54-9.33 0-19.39-2.08-30.17-6.24s-16.87-8.13-18.25-11.92c-1.51-4.66-2.27-8.82-2.27-12.48 0-1.26 0.63-3.47 1.89-6.62-0.51-26.35-0.76-57.69-0.76-94-28.63 9.08-50.69 16.83-66.2 23.26-9.08 36.69-14.63 66.14-16.64 88.33-0.25 3.15-2.96 4.67-8.13 4.54-8.83 0-19.42-2.84-31.78-8.51s-18.54-11.09-18.54-16.27c0-29.13 13.08-81.39 39.25-156.8 26.16-75.4 47.13-124.9 62.89-148.48 1.51-2.27 4.22-3.4 8.13-3.4 9.08 0 19.29 3.72 30.64 11.16v-7.38c0-7.19 6.62-10.78 19.86-10.78 8.57 0 16.83 1.61 24.78 4.82 7.94 3.21 11.92 7.16 11.92 11.82 0 37.2 0.5 82.15 1.51 134.86 34.05-10.34 52.64-15.51 55.8-15.51zm-163.04 50.69c5.93-2.02 14.69-4.98 26.29-8.89s19.23-6.49 22.89-7.75v-108.95c-16.27 29.51-32.66 71.37-49.18 125.59z"/><path d="m555.64 343.26c-18.91 0-33.13-4.35-42.65-13.05s-16.74-25.88-21.66-51.54-7.38-63.71-7.38-114.15 2.71-93.75 8.13-137.13c0.76-5.93 8.26-8.89 22.51-8.89 9.58 0 18.63 1.36 27.14 4.07s12.77 6.02 12.77 9.93c0 0.25-0.32 1.7-0.95 4.35-3.66 18.03-7.06 50.47-10.21 97.31s-3.72 85.9-1.7 117.17c9.33-30.77 23.36-67.43 42.08-109.99 18.73-42.56 34.26-74.93 46.62-97.13 4.41-7.69 8.82-11.6 13.24-11.73 6.68 0 16.61 3.63 29.79 10.88 13.17 7.25 19.77 13.84 19.77 19.77 0 2.52-2.21 7.44-6.62 14.75-1.51 2.9-4.35 5.49-8.51 7.75-16.52 27.61-36.22 67.24-59.11 118.88s-39.5 95.68-49.84 132.12c-1.26 4.42-5.74 6.62-13.43 6.62z"/><path d="m884.56 220.7c6.18 0 13.52 6.08 22.04 18.25 8.51 12.17 12.77 21.85 12.77 29.03 0 3.15-1.13 4.73-3.4 4.73-10.59 0-40.83 9.93-90.69 29.79-49.87 19.86-86.41 37.54-109.61 53.05-1.77 1.26-3.72 1.89-5.86 1.89-6.69 0-16.3-4.13-28.84-12.39-12.55-8.26-18.82-15.1-18.82-20.52 0-10.84 5.11-40.67 15.32-89.46 10.21-48.8 22.13-96.27 35.75-142.42-6.94-4.41-13.62-10.69-20.05-18.82s-9.65-14.53-9.65-19.2c0-2.02 0.76-3.47 2.27-4.35 13.74-7.19 39.06-16.2 75.94-27.05 36.88-10.84 59.61-16.27 68.19-16.27 7.19 0 14.78 5.61 22.79 16.83s12.01 20.18 12.01 26.86c0 1.26-0.07 2.36-0.19 3.31-0.13 0.95-0.32 1.73-0.57 2.36s-0.63 1.13-1.13 1.51c-0.51 0.38-0.88 0.69-1.13 0.95s-0.85 0.44-1.8 0.57-1.55 0.19-1.8 0.19h-4.16c-16.27 0-41.61 5.42-76.04 16.27-4.42 15.01-10.34 37.01-17.78 66.01 17.53-6.68 27.24-10.09 29.13-10.21 4.41 0 11.19 5.17 20.33 15.51s13.71 18.35 13.71 24.02c0 2.52-1.39 4.1-4.16 4.73-20.93 4.67-45.27 12.55-73.01 23.64-7.44 32.03-12.86 59.27-16.27 81.71 23.7-11.09 47.98-21.62 72.82-31.59 24.84-9.96 44.26-17.27 58.26-21.94 14-4.66 21.88-7 23.64-7z"/><path d="m1072.6 360.28c-7.69 0-16.77-3.82-27.24-11.44-10.47-7.63-15.7-14.53-15.7-20.71 0-1.76 0.76-3.59 2.27-5.49 42.62-53.46 81.77-108.19 117.46-164.18 25.6-40.22 35.87-72.13 30.83-95.71-10.85 1.77-21.22 7.03-31.11 15.79-9.9 8.77-17.91 18.57-24.02 29.41-6.12 10.85-10.97 21.25-14.56 31.21s-5.39 17.78-5.39 23.45c0 3.15-1.83 4.73-5.49 4.73-6.94 0-16.08-3.88-27.43-11.63-11.35-7.76-16.9-14.59-16.64-20.52 0.5-13.11 5.07-28.59 13.71-46.43s21.21-34.14 37.73-48.89 33.86-22.13 52.01-22.13 35.15 6.59 52.87 19.77c17.71 13.18 26.57 29.48 26.57 48.89 0 42.62-28.81 99.93-86.44 171.93 19.42-8.82 40.16-16.64 62.23-23.45 22.06-6.81 35.56-10.21 40.48-10.21 5.17 0 11.47 5.55 18.91 16.64 7.44 11.1 11.16 20.11 11.16 27.05 0 2.27-0.69 4.13-2.08 5.58s-2.74 2.3-4.07 2.55c-1.32 0.25-3.4 0.6-6.24 1.04s-4.63 0.66-5.39 0.66c-17.02 3.66-45.62 12.96-85.78 27.9s-73.29 31.81-99.39 50.6c-3.28 2.39-6.37 3.59-9.27 3.59z"/><path d="m1436.3 37.98c23.96 21.18 36 55.55 36.13 103.08 0 21.18-2.9 43.38-8.7 66.58s-13.75 44.89-23.83 65.07c-10.09 20.18-22.95 36.85-38.59 50.03s-32.34 19.77-50.12 19.77c-31.02 0-54.35-11.32-69.98-33.95-15.64-22.63-23.45-52.04-23.45-88.24 0-31.27 4.73-62.32 14.19-93.15s23.01-56.71 40.67-77.64c17.65-20.93 37.07-31.4 58.26-31.4 8.57 0 16.2 3.09 22.89 9.27 20.68 0.13 34.86 3.66 42.56 10.59zm-98.35 257.23c20.43-11.85 37.23-33.29 50.41-64.31 13.17-31.02 19.77-62.42 19.77-94.19 0-29.38-5.8-52.77-17.4-70.17-20.18 11.35-36.48 31.97-48.89 61.85-12.42 29.88-18.63 60.15-18.63 90.79s4.92 55.61 14.75 76.04z"/><path d="m1548.6 366.9c-7.19 0-16.8-5.11-28.84-15.32s-18.06-18.66-18.06-25.35c0-9.33 11.22-30.07 33.67-62.23 22.44-32.15 53.56-70.58 93.34-115.28s79.97-84.7 120.58-120.01c2.52-2.27 4.66-3.47 6.43-3.59 6.18 0 13.49 5.42 21.94 16.27s12.67 20.05 12.67 27.61c0 2.52-1.7 5.49-5.11 8.89-27.36 27.36-48.07 48.33-62.13 62.89s-32.19 33.92-54.38 58.07-41.04 46.75-56.55 67.81-28.94 41.8-40.29 62.23c0.5 1.26 0.76 2.4 0.76 3.4 0 7.69-6.37 18.54-19.1 32.53-1.26 1.39-2.9 2.08-4.92 2.08zm20.81-216.95c-6.43 0-14.63-2.08-24.59-6.24s-18.41-9.71-25.35-16.64c-9.08-9.33-13.56-21.5-13.43-36.5 0-22.19 7.15-43.22 21.47-63.08 14.31-19.86 30.86-29.79 49.65-29.79 5.67 0 12.64 2.18 20.9 6.53s14.34 9.55 18.25 15.6c11.85 3.15 20.05 7.66 24.59 13.52s6.81 13.97 6.81 24.31c0 10.85-3.28 23.3-9.84 37.36s-16.11 26.73-28.66 38.02-25.82 16.93-39.81 16.93zm-13.43-35.37c12.36-8.32 22.79-20.46 31.3-36.41s10.56-30.1 6.15-42.46c-11.85 4.16-21.63 14.41-29.32 30.74s-10.4 32.38-8.13 48.14zm153.77 250.61c-15.51 0-30.96-5.61-46.34-16.83-15.39-11.22-23.08-25.6-23.08-43.12 0-19.67 6.71-39.56 20.14-59.67s30.1-30.17 50.03-30.17c7.19 0 15.82 3.85 25.91 11.54 11.35 0 22.57 4 33.67 12.01 11.09 8.01 16.64 19.89 16.64 35.65 0 19.67-7.73 39.69-23.17 60.05-15.45 20.36-33.38 30.55-53.81 30.55zm-18.73-34.05c12.36-4.92 23.61-16.01 33.76-33.29 10.15-17.27 13.52-33.54 10.12-48.8-10.34 3.4-19.14 10.25-26.39 20.52-7.25 10.28-12.17 20.9-14.75 31.87-2.59 10.97-3.5 20.87-2.74 29.7z"/></g></svg>';
  }

  if (icon_id == "badge-30-off") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="58" height="20" fill="none" viewBox="0 0 58 20">' +
      '      <path d="M19.096 19.332a3.049 3.049 0 01-.076-1.12c.037-.401.137-.624.3-.668.721-.195 3.107-.426 7.157-.691 4.054-.267 7.644-.436 10.769-.507.181-.012.304.102.368.34.075.276.079.648.012 1.115-.066.471-.223.74-.469.807a1.973 1.973 0 01-.503.05 7.612 7.612 0 01-.672-.023 7.43 7.43 0 00-.473-.02c-1.703-.011-4.407.126-8.111.41-3.703.29-6.229.553-7.576.79-.101.028-.18.045-.235.05a.378.378 0 01-.178-.03.357.357 0 01-.179-.164 1.299 1.299 0 01-.134-.339zM2.12 13.506c-.392 0-.756-.18-1.094-.54-.337-.36-.505-.718-.505-1.073 0-.196.097-.294.293-.294.543 0 1.206-.199 1.99-.595.784-.397 1.5-.9 2.146-1.51.652-.612 1.067-1.193 1.244-1.744-.838 0-1.604.214-2.297.643-.177.104-.442-.05-.793-.465-.35-.42-.526-.76-.526-1.019 0-.082.043-.152.13-.212.542-.364.927-.624 1.155-.779.228-.16.584-.426 1.067-.8.487-.374.872-.718 1.155-1.032.287-.32.499-.634.636-.943-.99 0-2.156.48-3.5 1.442-.123.082-.212.125-.267.13-.196 0-.44-.196-.731-.588-.287-.392-.431-.716-.431-.97 0-.115.062-.217.185-.308.551-.438 1.232-.816 2.044-1.135.81-.324 1.549-.485 2.214-.485.588 0 1.133.25 1.634.751.533.534.8 1.108.8 1.723 0 .346-.191.763-.574 1.251-.383.483-.802.925-1.258 1.326.346.15.665.392.957.725.296.328.444.706.444 1.135 0 .524-.212 1.11-.635 1.756a8.318 8.318 0 01-1.539 1.75c-.606.52-1.273.96-2.002 1.32-.725.36-1.372.54-1.942.54zM15.983 1.857c.866.766 1.302 2.008 1.306 3.726 0 .766-.105 1.568-.314 2.406-.21.839-.497 1.623-.862 2.352a5.642 5.642 0 01-1.394 1.811c-.565.474-1.17.711-1.812.711-1.12 0-1.964-.408-2.53-1.223-.564-.82-.847-1.885-.847-3.193 0-1.13.171-2.251.513-3.363.342-1.117.832-2.053 1.47-2.81.638-.756 1.34-1.134 2.105-1.134.31 0 .586.111.827.335.748.004 1.26.132 1.538.382zm-3.554 9.297c.738-.428 1.344-1.203 1.818-2.324a8.602 8.602 0 00.718-3.404c0-1.062-.21-1.907-.63-2.536-.728.41-1.318 1.155-1.77 2.235a8.52 8.52 0 00-.67 3.281c0 1.094.178 2.01.534 2.748zM20.79 5.904c-.233 0-.53-.075-.89-.225-.36-.15-.665-.351-.916-.602-.328-.337-.49-.777-.485-1.32 0-.801.258-1.56.773-2.276.519-.72 1.118-1.08 1.797-1.08.205 0 .456.08.752.24.301.155.522.341.663.56.429.114.725.278.889.492.164.21.246.502.246.875 0 .392-.118.843-.355 1.354a4.302 4.302 0 01-1.04 1.374c-.45.405-.93.608-1.435.608zm-.753 7.841c-.26 0-.608-.184-1.046-.554-.433-.369-.65-.674-.65-.916 0-.337.406-1.087 1.218-2.249.81-1.162 1.934-2.55 3.37-4.163a48.276 48.276 0 014.361-4.34c.091-.083.169-.126.233-.13.223 0 .487.196.792.587.306.392.458.725.458.999 0 .09-.061.198-.184.32-.99.99-1.739 1.749-2.25 2.277-.505.524-1.159 1.224-1.961 2.099a29.311 29.311 0 00-2.044 2.447 21.01 21.01 0 00-1.456 2.25.335.335 0 01.027.122c0 .278-.23.67-.69 1.176a.229.229 0 01-.178.075zm.267-9.119c.446-.3.822-.738 1.128-1.313.31-.578.385-1.091.225-1.538-.428.15-.781.522-1.06 1.115-.277.588-.375 1.166-.293 1.736zm5.557 9.058c-.56 0-1.119-.203-1.675-.609-.555-.405-.834-.925-.834-1.558 0-.711.242-1.43.725-2.154.488-.729 1.092-1.093 1.812-1.093.26 0 .572.139.936.417.41 0 .816.145 1.217.437.401.287.602.716.602 1.285 0 .711-.28 1.436-.841 2.174-.556.734-1.203 1.1-1.942 1.1zm-.676-1.23c.446-.179.852-.58 1.216-1.204.37-.624.493-1.212.37-1.764-.374.123-.693.372-.957.745-.26.37-.438.752-.534 1.149a3.487 3.487 0 00-.095 1.073zM38.665 1.324a3.37 3.37 0 012.386.95c.674.634 1.011 1.452 1.011 2.455 0 .81-.12 1.695-.362 2.652-.241.957-.56 1.852-.957 2.686-.396.834-.889 1.532-1.476 2.092-.588.56-1.194.841-1.819.841-.56 0-1.112-.19-1.654-.567-.542-.379-.898-.83-1.066-1.354-.142-.42-.21-.973-.206-1.661 0-1.062.149-2.23.445-3.507.3-1.276.567-2.087.8-2.433.054-.092.17-.137.348-.137.114 0 .265.023.451.068a3.79 3.79 0 01.848-1.463c.387-.414.804-.622 1.251-.622zm.615 5.995c.347-1.194.52-2.324.52-3.39 0-.456-.039-.82-.116-1.094-.356.232-.657.588-.903 1.066-.246.474-.369.916-.369 1.327 0 .054.005.12.014.198.009.073.014.12.014.143 0 .105-.09.155-.267.15-.169 0-.392-.045-.67-.136-.515 1.782-.773 3.26-.773 4.437 0 .651.067 1.137.199 1.456.989-.725 1.773-2.11 2.351-4.157zM51.25.593c.269 0 .542.205.82.615.278.406.417.716.417.93 0 .132-.07.207-.212.225-1.522.16-3.431.54-5.728 1.142-.15.483-.328 1.146-.533 1.99.729-.242 1.155-.363 1.278-.363.214 0 .483.182.807.547.328.364.492.663.492.895 0 .114-.069.19-.205.226-.971.241-1.919.53-2.844.868-.428 2.12-.638 3.723-.629 4.812a.57.57 0 01.041.226c0 .114-.032.196-.096.246-.059.05-.191.075-.396.075-.383 0-.777-.095-1.183-.287-.405-.191-.608-.403-.608-.636 0-.81.2-2.187.602-4.128-.402-.438-.602-.784-.602-1.04 0-.063.032-.113.096-.15.15-.082.44-.219.868-.41.196-.802.373-1.493.533-2.071-.223-.028-.492-.226-.807-.595-.31-.37-.464-.665-.464-.889 0-.105.036-.175.109-.212.374-.177 1.666-.558 3.876-1.141 2.21-.584 3.666-.875 4.368-.875z" fill="#08B1FF"/><path d="M56.302 1.112c.205.037.442.258.71.663.274.401.41.718.41.95 0 .124-.052.187-.156.192-.812.082-1.965.34-3.46.772a84.682 84.682 0 00-.67 2.742c.917-.32 1.457-.477 1.62-.472.224 0 .5.198.828.595.328.396.492.715.492.957 0 .141-.066.212-.198.212-.542 0-1.611.307-3.206.923-.365 1.895-.556 3.249-.574 4.06a.453.453 0 01.068.267c.005.109-.05.25-.164.423-.114.174-.24.26-.376.26-.355 0-.754-.098-1.196-.294-.438-.196-.657-.41-.657-.642 0-.524.17-1.673.506-3.446a73.36 73.36 0 011.203-5.263 2.936 2.936 0 01-.499-.636c-.14-.246-.211-.449-.211-.608 0-.114.045-.19.136-.226a25.248 25.248 0 014.567-1.271c.072-.124.237-.185.492-.185.11 0 .22.01.335.027z" fill="#08B1FF"/>' +
      "    </svg>";
  }

  if (icon_id == "badge-35-off") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="58" height="20" fill="none" viewBox="0 0 58 20">>' +
      '      <path d="M19.096 19.332a3.049 3.049 0 01-.076-1.12c.037-.401.137-.624.3-.668.721-.195 3.107-.426 7.157-.691 4.054-.267 7.644-.436 10.769-.507.181-.012.304.102.368.34.075.276.079.648.012 1.115-.066.471-.223.74-.469.807a1.973 1.973 0 01-.503.05 7.612 7.612 0 01-.672-.023 7.43 7.43 0 00-.473-.02c-1.703-.011-4.407.126-8.111.41-3.703.29-6.229.553-7.576.79-.101.028-.18.045-.235.05a.378.378 0 01-.178-.03.357.357 0 01-.179-.164 1.299 1.299 0 01-.134-.339zM2.12 13.506c-.392 0-.756-.18-1.094-.54-.337-.36-.505-.718-.505-1.073 0-.196.097-.294.293-.294.543 0 1.206-.199 1.99-.595.784-.397 1.5-.9 2.146-1.51.652-.612 1.067-1.193 1.244-1.744-.838 0-1.604.214-2.297.643-.177.104-.442-.05-.793-.465-.35-.42-.526-.76-.526-1.019 0-.082.043-.152.13-.212.542-.364.927-.624 1.155-.779.228-.16.584-.426 1.067-.8.487-.374.872-.718 1.155-1.032.287-.32.499-.634.636-.943-.99 0-2.156.48-3.5 1.442-.123.082-.212.125-.267.13-.196 0-.44-.196-.731-.588-.287-.392-.431-.716-.431-.97 0-.115.062-.217.185-.308.551-.438 1.232-.816 2.044-1.135.81-.324 1.549-.485 2.214-.485.588 0 1.133.25 1.634.751.533.534.8 1.108.8 1.723 0 .346-.191.763-.574 1.251-.383.483-.802.925-1.258 1.326.346.15.665.392.957.725.296.328.444.706.444 1.135 0 .524-.212 1.11-.635 1.756a8.318 8.318 0 01-1.539 1.75c-.606.52-1.273.96-2.002 1.32-.725.36-1.372.54-1.942.54zM16.729.962c.214 0 .457.205.731.615.278.41.417.759.417 1.046 0 .196-.089.294-.267.294-.606 0-1.362.077-2.27.232-.902.155-1.665.335-2.29.54a9.245 9.245 0 00-.717 2.1c.88-.525 1.584-.785 2.112-.78.534 0 1.055.237 1.566.71.515.475.772.95.772 1.43 0 .729-.33 1.588-.991 2.577a10.71 10.71 0 01-2.386 2.556c-.93.711-1.745 1.067-2.447 1.067-.41 0-.816-.196-1.217-.588-.4-.392-.601-.752-.601-1.08 0-.16.107-.237.32-.233.634 0 1.336-.237 2.106-.71a8.166 8.166 0 002.03-1.792c.584-.715.946-1.394 1.088-2.037-.42.028-.894.187-1.422.479a6.592 6.592 0 00-1.49 1.134c-.055.055-.14.082-.253.082-.301 0-.654-.125-1.06-.375-.401-.256-.602-.49-.602-.705 0-.196.121-.77.363-1.722.241-.953.487-1.778.738-2.475-.26-.337-.39-.617-.39-.84 0-.133.098-.235.294-.308a18.598 18.598 0 013.398-.903c1.226-.21 2.048-.314 2.468-.314zM20.79 5.904c-.233 0-.53-.075-.89-.225-.36-.15-.665-.351-.916-.602-.328-.337-.49-.777-.485-1.32 0-.801.258-1.56.773-2.276.519-.72 1.118-1.08 1.797-1.08.205 0 .456.08.752.24.301.155.522.341.663.56.429.114.725.278.889.492.164.21.246.502.246.875 0 .392-.118.843-.355 1.354a4.302 4.302 0 01-1.04 1.374c-.45.405-.93.608-1.435.608zm-.753 7.841c-.26 0-.608-.184-1.046-.554-.433-.369-.65-.674-.65-.916 0-.337.406-1.087 1.218-2.249.81-1.162 1.934-2.55 3.37-4.163a48.276 48.276 0 014.361-4.34c.091-.083.169-.126.233-.13.223 0 .487.196.792.587.306.392.458.725.458.999 0 .09-.061.198-.184.32-.99.99-1.739 1.749-2.25 2.277-.505.524-1.159 1.224-1.961 2.099a29.311 29.311 0 00-2.044 2.447 21.01 21.01 0 00-1.456 2.25.335.335 0 01.027.122c0 .278-.23.67-.69 1.176a.229.229 0 01-.178.075zm.267-9.119c.446-.3.822-.738 1.128-1.313.31-.578.385-1.091.225-1.538-.428.15-.781.522-1.06 1.115-.277.588-.375 1.166-.293 1.736zm5.557 9.058c-.56 0-1.119-.203-1.675-.609-.555-.405-.834-.925-.834-1.558 0-.711.242-1.43.725-2.154.488-.729 1.092-1.093 1.812-1.093.26 0 .572.139.936.417.41 0 .816.145 1.217.437.401.287.602.716.602 1.285 0 .711-.28 1.436-.841 2.174-.556.734-1.203 1.1-1.942 1.1zm-.676-1.23c.446-.179.852-.58 1.216-1.204.37-.624.493-1.212.37-1.764-.374.123-.693.372-.957.745-.26.37-.438.752-.534 1.149a3.487 3.487 0 00-.095 1.073zM38.665 1.324a3.37 3.37 0 012.386.95c.674.634 1.011 1.452 1.011 2.455 0 .81-.12 1.695-.362 2.652-.241.957-.56 1.852-.957 2.686-.396.834-.889 1.532-1.476 2.092-.588.56-1.194.841-1.819.841-.56 0-1.112-.19-1.654-.567-.542-.379-.898-.83-1.066-1.354-.142-.42-.21-.973-.206-1.661 0-1.062.149-2.23.445-3.507.3-1.276.567-2.087.8-2.433.054-.092.17-.137.348-.137.114 0 .265.023.451.068a3.79 3.79 0 01.848-1.463c.387-.414.804-.622 1.251-.622zm.615 5.995c.347-1.194.52-2.324.52-3.39 0-.456-.039-.82-.116-1.094-.356.232-.657.588-.903 1.066-.246.474-.369.916-.369 1.327 0 .054.005.12.014.198.009.073.014.12.014.143 0 .105-.09.155-.267.15-.169 0-.392-.045-.67-.136-.515 1.782-.773 3.26-.773 4.437 0 .651.067 1.137.199 1.456.989-.725 1.773-2.11 2.351-4.157zM51.25.593c.269 0 .542.205.82.615.278.406.417.716.417.93 0 .132-.07.207-.212.225-1.522.16-3.431.54-5.728 1.142-.15.483-.328 1.146-.533 1.99.729-.242 1.155-.363 1.278-.363.214 0 .483.182.807.547.328.364.492.663.492.895 0 .114-.069.19-.205.226-.971.241-1.919.53-2.844.868-.428 2.12-.638 3.723-.629 4.812a.57.57 0 01.041.226c0 .114-.032.196-.096.246-.059.05-.191.075-.396.075-.383 0-.777-.095-1.183-.287-.405-.191-.608-.403-.608-.636 0-.81.2-2.187.602-4.128-.402-.438-.602-.784-.602-1.04 0-.063.032-.113.096-.15.15-.082.44-.219.868-.41.196-.802.373-1.493.533-2.071-.223-.028-.492-.226-.807-.595-.31-.37-.464-.665-.464-.889 0-.105.036-.175.109-.212.374-.177 1.666-.558 3.876-1.141 2.21-.584 3.666-.875 4.368-.875z" fill="#08B1FF"/><path d="M56.302 1.112c.205.037.442.258.71.663.274.401.41.718.41.95 0 .124-.052.187-.156.192-.812.082-1.965.34-3.46.772a84.682 84.682 0 00-.67 2.742c.917-.32 1.457-.477 1.62-.472.224 0 .5.198.828.595.328.396.492.715.492.957 0 .141-.066.212-.198.212-.542 0-1.611.307-3.206.923-.365 1.895-.556 3.249-.574 4.06a.453.453 0 01.068.267c.005.109-.05.25-.164.423-.114.174-.24.26-.376.26-.355 0-.754-.098-1.196-.294-.438-.196-.657-.41-.657-.642 0-.524.17-1.673.506-3.446a73.36 73.36 0 011.203-5.263 2.936 2.936 0 01-.499-.636c-.14-.246-.211-.449-.211-.608 0-.114.045-.19.136-.226a25.248 25.248 0 014.567-1.271c.072-.124.237-.185.492-.185.11 0 .22.01.335.027z" fill="#08B1FF"/>' +
      "    </svg>";
  }

  if (icon_id == "badge-40-off") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" viewBox="0 0 1792.87 541.31"><path d="M1065,510c-42.19,2.9-83.75,6.12-125.62,9-32.53,2.58-65.39,4.51-97.92,7.73-39,2.9-78,6.44-116.61,10-18.68,1.61-38,2.9-56.69,4.51-14.17,1-20.93-5.48-21.9-20.94a140.27,140.27,0,0,1,0-23.19c.64-12.24,7.73-20.94,18.68-24.48,14.82-4.51,30-8.06,45.1-9,48.31-3.55,96.31-6.12,144.62-8.7,30-1.61,59.92-3.54,89.87-5.48,40.59-2.57,81.5-5.47,122.08-8.05,15.79-1,30.93-1.93,46.71-1.93,25.45.64,42.52,21.9,29,47.67-9,16.75-19.65,26.41-39.94,24.48-12.24-1.61-24.48,0-36.4,0C1065,510.29,1065,510,1065,510Z" style="fill:#e62817"/><path d="M278.83,182.42q10.23,0,23,17.06T314.55,228c0,3.34-1.61,5.15-4.82,5.41q-33.32,5-83.08,18.47-16.86,82.27-16.86,120,0,6.21-9.43,6.22-15.65,0-36.82-10.24t-21.18-22.27q0-3.21,3.82-7,2.81-25.08,10.23-64.82-44.74,15.66-78.87,32.91-5.82,2.82-9.43,2.81-11.43,0-29-14.55T21.55,272.13q0-10.63,38.83-113.49T122.3,18.06c1.06-1.87,3.54-2.81,7.42-2.81q12.24,0,30.3,11.84t18.07,20.47a8.38,8.38,0,0,1-1.21,3.82q-10.63,16.46-36.72,80.17t-37.93,103q22.67-9.43,67.23-23.88,20.46-89.5,40.33-149.11,2-5.82,8.23-5.82,13.24,0,31.51,10.54t18.26,19.56a13.23,13.23,0,0,1-.8,3.21q-9.84,29.5-27.09,101.55Q272.6,182.42,278.83,182.42Z" style="fill:#e62817"/><path d="M485.13,42.75q38.13,33.71,38.33,109.37,0,33.7-9.23,70.64a335.22,335.22,0,0,1-25.29,69Q472.89,323.9,448,344.87t-53.19,21q-49.36,0-74.25-36T295.69,236.2a335.15,335.15,0,0,1,15.05-98.83q15-49.07,43.14-82.38t61.81-33.32q13.65,0,24.29,9.84Q472.89,31.71,485.13,42.75ZM380.78,315.68q32.5-18.87,53.48-68.24t21-99.94q0-46.75-18.46-74.45-32.11,18.06-51.88,65.62T365.12,235Q365.12,283.17,380.78,315.68Z" style="fill:#e62817"/><path d="M604.34,391.73q-11.45,0-30.61-16.25t-19.16-26.89q0-14.85,35.72-66t99-122.31Q752.65,89.1,817.26,32.91c2.68-2.41,5-3.68,6.83-3.81q9.82,0,23.28,17.26t13.44,29.3q0,4-5.42,9.43-43.54,43.54-65.92,66.73t-57.7,61.61q-35.32,38.43-60,71.94a616.52,616.52,0,0,0-42.75,66,10,10,0,0,1,.8,3.61q0,12.24-20.26,34.52A6.73,6.73,0,0,1,604.34,391.73Zm22.07-230.18q-10.23,0-26.09-6.62a82.5,82.5,0,0,1-26.89-17.66Q559,122.42,559.18,98.54q0-35.33,22.78-66.93T634.64,0q9,0,22.18,6.92t19.36,16.56q18.87,5,26.09,14.35t7.23,25.79q0,17.25-10.44,39.63a125.45,125.45,0,0,1-30.4,40.34Q648.68,161.55,626.41,161.55ZM612.16,124q19.67-13.24,33.22-38.63t6.52-45Q633,47,620.79,73T612.16,124ZM775.32,389.93q-24.69,0-49.17-17.86t-24.48-45.76Q701.67,295,723,263t53.08-32q11.45,0,27.5,12.24,18.06,0,35.72,12.74T857,293.8q0,31.31-24.59,63.72T775.32,389.93ZM755.45,353.8q19.66-7.82,35.82-35.32T802,266.71q-16.46,5.42-28,21.77a97.13,97.13,0,0,0-15.66,33.82Q754.25,339.76,755.45,353.8Z" style="fill:#e62817"/><path d="M1150.8,27.09q40.34,0,70,27.9t29.7,72q0,35.73-10.64,77.87a426.19,426.19,0,0,1-28.09,78.87q-17.46,36.72-43.35,61.41t-53.38,24.68q-24.69,0-48.57-16.66t-31.3-39.73q-6.23-18.47-6-48.77,0-46.75,13.15-102.95t23.38-71.44c1.6-2.68,5-4,10.23-4a58.83,58.83,0,0,1,13.25,2,111.37,111.37,0,0,1,24.88-42.95Q1131.13,27.1,1150.8,27.09Zm18.06,176q15.26-52.58,15.25-99.54,0-20.05-3.41-32.11-15.65,10.25-26.49,31.21t-10.84,39a48.14,48.14,0,0,0,.41,5.72c.26,2.21.4,3.65.4,4.32q0,4.62-7.83,4.41-7.42,0-19.67-4Q1094,230.59,1094,282.36q0,28.71,5.82,42.75Q1143.38,293.19,1168.86,203.09Z" style="fill:#e62817"/><path d="M1520.46,5.62q11.83,0,24.08,18T1556.78,51c0,3.89-2.07,6.09-6.22,6.63q-67,7-168.17,33.51-6.63,21.27-15.66,58.4,32.12-10.63,37.53-10.64,9.43,0,23.78,16.06t14.35,26.29q0,5-6,6.62a825.41,825.41,0,0,0-83.48,25.49q-18.87,93.32-18.47,141.28a16.58,16.58,0,0,1,1.21,6.62c0,3.35-.9,5.75-2.71,7.22s-5.72,2.21-11.74,2.21q-16.86,0-34.72-8.43t-17.86-18.66q0-35.71,17.66-121.21-17.65-19.28-17.66-30.51a4.89,4.89,0,0,1,2.81-4.41q6.61-3.62,25.49-12,8.63-35.33,15.65-60.81-9.84-1.2-23.58-17.46T1275.22,71c0-3.07,1.07-5.15,3.21-6.22q16.46-7.83,113.79-33.51T1520.46,5.62Z" style="fill:#e62817"/><path d="M1735,5.62q11.84,0,24.08,18T1771.31,51c0,3.89-2.07,6.09-6.22,6.63q-67,7-168.17,33.51-6.63,21.27-15.65,58.4,32.1-10.63,37.52-10.64,9.43,0,23.78,16.06t14.35,26.29q0,5-6,6.62a826.19,826.19,0,0,0-83.48,25.49q-18.87,93.32-18.46,141.28a16.76,16.76,0,0,1,1.2,6.62c0,3.35-.9,5.75-2.71,7.22s-5.72,2.21-11.74,2.21q-16.86,0-34.72-8.43t-17.86-18.66q0-35.71,17.66-121.21-17.65-19.28-17.66-30.51a4.91,4.91,0,0,1,2.81-4.41q6.63-3.62,25.49-12,8.63-35.33,15.65-60.81-9.84-1.2-23.58-17.46T1489.75,71c0-3.07,1.07-5.15,3.21-6.22q16.45-7.83,113.79-33.51T1735,5.62Z" style="fill:#e62817"/></svg>';
  }

  if (icon_id == "badge-50-off") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="61" height="20" fill="none" viewBox="0 0 61 20">' +
      '      <path d="M19.096 19.332a3.049 3.049 0 01-.076-1.12c.037-.401.137-.624.3-.668.721-.195 3.107-.426 7.157-.691 4.054-.267 7.644-.436 10.769-.507.181-.012.304.102.368.34.075.276.079.648.012 1.115-.066.471-.223.74-.469.807a1.973 1.973 0 01-.503.05 7.612 7.612 0 01-.672-.023 7.43 7.43 0 00-.473-.02c-1.703-.011-4.407.126-8.111.41-3.703.29-6.229.553-7.576.79-.101.028-.18.045-.235.05a.378.378 0 01-.178-.03.357.357 0 01-.179-.164 1.299 1.299 0 01-.134-.339zM8.382.962c.214 0 .458.205.731.615.278.41.417.759.417 1.046 0 .196-.089.294-.266.294-.606 0-1.363.077-2.27.232-.902.155-1.666.335-2.29.54a9.246 9.246 0 00-.718 2.1c.88-.525 1.584-.785 2.113-.78.533 0 1.055.237 1.565.71.515.475.773.95.773 1.43 0 .729-.33 1.588-.992 2.577a10.71 10.71 0 01-2.385 2.556c-.93.711-1.746 1.067-2.448 1.067-.41 0-.815-.196-1.216-.588-.402-.392-.602-.752-.602-1.08 0-.16.107-.237.321-.233.634 0 1.336-.237 2.106-.71a8.165 8.165 0 002.03-1.792c.583-.715.946-1.394 1.087-2.037-.42.028-.893.187-1.422.479a6.593 6.593 0 00-1.49 1.134c-.055.055-.14.082-.253.082-.3 0-.654-.125-1.06-.375-.4-.256-.601-.49-.601-.705 0-.196.12-.77.362-1.722.242-.953.488-1.778.738-2.475-.26-.337-.39-.617-.39-.84 0-.133.099-.235.295-.308a18.598 18.598 0 013.397-.903C7.14 1.066 7.963.962 8.382.962zM16.182 1.857c.866.766 1.3 2.008 1.305 3.726 0 .766-.104 1.568-.314 2.406-.21.839-.497 1.623-.861 2.352a5.642 5.642 0 01-1.395 1.811c-.565.474-1.169.711-1.812.711-1.12 0-1.964-.408-2.529-1.223-.565-.82-.847-1.885-.847-3.193 0-1.13.17-2.251.512-3.363.342-1.117.832-2.053 1.47-2.81.638-.756 1.34-1.134 2.105-1.134.31 0 .586.111.828.335.747.004 1.26.132 1.538.382zm-3.555 9.297c.738-.428 1.344-1.203 1.818-2.324a8.602 8.602 0 00.718-3.404c0-1.062-.21-1.907-.629-2.536-.729.41-1.32 1.155-1.77 2.235a8.52 8.52 0 00-.67 3.281c0 1.094.178 2.01.533 2.748zM20.987 5.904c-.232 0-.528-.075-.888-.225-.36-.15-.666-.351-.916-.602-.328-.337-.49-.777-.486-1.32 0-.801.258-1.56.773-2.276.52-.72 1.119-1.08 1.798-1.08.205 0 .455.08.752.24.3.155.521.341.663.56.428.114.724.278.888.492.164.21.246.502.246.875 0 .392-.118.843-.355 1.354a4.302 4.302 0 01-1.04 1.374c-.45.405-.929.608-1.435.608zm-.752 7.841c-.26 0-.608-.184-1.046-.554-.433-.369-.649-.674-.649-.916 0-.337.406-1.087 1.217-2.249.811-1.162 1.934-2.55 3.37-4.163a48.263 48.263 0 014.361-4.34c.091-.083.169-.126.233-.13.223 0 .487.196.793.587.305.392.458.725.458.999 0 .09-.062.198-.185.32-.989.99-1.738 1.749-2.249 2.277-.506.524-1.16 1.224-1.962 2.099a29.333 29.333 0 00-2.044 2.447c-.56.761-1.046 1.51-1.456 2.25a.336.336 0 01.027.122c0 .278-.23.67-.69 1.176a.229.229 0 01-.178.075zm.267-9.119c.447-.3.823-.738 1.128-1.313.31-.578.385-1.091.226-1.538-.429.15-.782.522-1.06 1.115-.278.588-.376 1.166-.294 1.736zm5.558 9.058c-.561 0-1.12-.203-1.675-.609-.556-.405-.834-.925-.834-1.558 0-.711.241-1.43.724-2.154.488-.729 1.092-1.093 1.812-1.093.26 0 .572.139.936.417.41 0 .816.145 1.217.437.401.287.602.716.602 1.285 0 .711-.28 1.436-.841 2.174-.556.734-1.203 1.1-1.941 1.1zm-.677-1.23c.446-.179.852-.58 1.217-1.204.369-.624.492-1.212.369-1.764-.374.123-.693.372-.957.745-.26.37-.438.752-.534 1.149a3.493 3.493 0 00-.095 1.073zM38.077 12.72c-.588 0-1.173-.169-1.757-.506a2.75 2.75 0 01-1.223-1.443c-.205-.514-.308-1.17-.308-1.968 0-1.158.182-2.309.547-3.452.364-1.144.85-2.088 1.456-2.83.606-.743 1.226-1.115 1.86-1.115.496 0 .945.178 1.346.533.711.215 1.212.561 1.504 1.04.292.473.438 1.125.438 1.955 0 1.13-.244 2.397-.732 3.8-.483 1.4-.984 2.438-1.504 3.118-.442.578-.984.868-1.627.868zm-.697-1.627c.524-.42 1.028-1.324 1.51-2.714.484-1.39.725-2.664.725-3.821 0-.497-.05-.912-.15-1.245-.738.429-1.324 1.208-1.757 2.338a9.597 9.597 0 00-.65 3.46c0 .806.108 1.467.322 1.982zM49.035 1.112c.205.037.442.258.711.663.273.401.41.718.41.95 0 .124-.052.187-.157.192-.811.082-1.964.34-3.459.772a84.682 84.682 0 00-.67 2.742c.916-.32 1.456-.477 1.62-.472.224 0 .5.198.827.595.328.396.493.715.493.957 0 .141-.067.212-.199.212-.542 0-1.61.307-3.206.923-.364 1.895-.556 3.249-.574 4.06a.453.453 0 01.068.267c.005.109-.05.25-.164.423-.114.174-.239.26-.376.26-.355 0-.754-.098-1.196-.294-.437-.196-.656-.41-.656-.642 0-.524.169-1.673.506-3.446a73.36 73.36 0 011.203-5.263 2.936 2.936 0 01-.5-.636c-.14-.246-.211-.449-.211-.608 0-.114.045-.19.137-.226a25.248 25.248 0 014.566-1.271c.073-.124.237-.185.492-.185.11 0 .221.01.335.027zM59.282.593c.27 0 .543.205.82.615.279.406.418.716.418.93 0 .132-.071.207-.212.225-1.523.16-3.432.54-5.729 1.142-.15.483-.328 1.146-.533 1.99.73-.242 1.155-.363 1.278-.363.214 0 .483.182.807.547.328.364.492.663.492.895 0 .114-.068.19-.205.226-.97.241-1.919.53-2.844.868-.428 2.12-.638 3.723-.629 4.812a.569.569 0 01.041.226c0 .114-.032.196-.095.246-.06.05-.192.075-.397.075-.383 0-.777-.095-1.182-.287-.406-.191-.609-.403-.609-.636 0-.81.2-2.187.602-4.128-.401-.438-.602-.784-.602-1.04 0-.063.032-.113.096-.15.15-.082.44-.219.868-.41.196-.802.374-1.493.533-2.071-.223-.028-.492-.226-.806-.595-.31-.37-.465-.665-.465-.889 0-.105.036-.175.11-.212.373-.177 1.665-.558 3.875-1.141 2.21-.584 3.666-.875 4.368-.875z" fill="#E62817"/>' +
      "    </svg>";
  }

  if (icon_id == "close-circle") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="61" height="20" fill="none" viewBox="0 0 61 20">' +
      '      <path d="M19.096 19.332a3.049 3.049 0 01-.076-1.12c.037-.401.137-.624.3-.668.721-.195 3.107-.426 7.157-.691 4.054-.267 7.644-.436 10.769-.507.181-.012.304.102.368.34.075.276.079.648.012 1.115-.066.471-.223.74-.469.807a1.973 1.973 0 01-.503.05 7.612 7.612 0 01-.672-.023 7.43 7.43 0 00-.473-.02c-1.703-.011-4.407.126-8.111.41-3.703.29-6.229.553-7.576.79-.101.028-.18.045-.235.05a.378.378 0 01-.178-.03.357.357 0 01-.179-.164 1.299 1.299 0 01-.134-.339zM8.382.962c.214 0 .458.205.731.615.278.41.417.759.417 1.046 0 .196-.089.294-.266.294-.606 0-1.363.077-2.27.232-.902.155-1.666.335-2.29.54a9.246 9.246 0 00-.718 2.1c.88-.525 1.584-.785 2.113-.78.533 0 1.055.237 1.565.71.515.475.773.95.773 1.43 0 .729-.33 1.588-.992 2.577a10.71 10.71 0 01-2.385 2.556c-.93.711-1.746 1.067-2.448 1.067-.41 0-.815-.196-1.216-.588-.402-.392-.602-.752-.602-1.08 0-.16.107-.237.321-.233.634 0 1.336-.237 2.106-.71a8.165 8.165 0 002.03-1.792c.583-.715.946-1.394 1.087-2.037-.42.028-.893.187-1.422.479a6.593 6.593 0 00-1.49 1.134c-.055.055-.14.082-.253.082-.3 0-.654-.125-1.06-.375-.4-.256-.601-.49-.601-.705 0-.196.12-.77.362-1.722.242-.953.488-1.778.738-2.475-.26-.337-.39-.617-.39-.84 0-.133.099-.235.295-.308a18.598 18.598 0 013.397-.903C7.14 1.066 7.963.962 8.382.962zM16.182 1.857c.866.766 1.3 2.008 1.305 3.726 0 .766-.104 1.568-.314 2.406-.21.839-.497 1.623-.861 2.352a5.642 5.642 0 01-1.395 1.811c-.565.474-1.169.711-1.812.711-1.12 0-1.964-.408-2.529-1.223-.565-.82-.847-1.885-.847-3.193 0-1.13.17-2.251.512-3.363.342-1.117.832-2.053 1.47-2.81.638-.756 1.34-1.134 2.105-1.134.31 0 .586.111.828.335.747.004 1.26.132 1.538.382zm-3.555 9.297c.738-.428 1.344-1.203 1.818-2.324a8.602 8.602 0 00.718-3.404c0-1.062-.21-1.907-.629-2.536-.729.41-1.32 1.155-1.77 2.235a8.52 8.52 0 00-.67 3.281c0 1.094.178 2.01.533 2.748zM20.987 5.904c-.232 0-.528-.075-.888-.225-.36-.15-.666-.351-.916-.602-.328-.337-.49-.777-.486-1.32 0-.801.258-1.56.773-2.276.52-.72 1.119-1.08 1.798-1.08.205 0 .455.08.752.24.3.155.521.341.663.56.428.114.724.278.888.492.164.21.246.502.246.875 0 .392-.118.843-.355 1.354a4.302 4.302 0 01-1.04 1.374c-.45.405-.929.608-1.435.608zm-.752 7.841c-.26 0-.608-.184-1.046-.554-.433-.369-.649-.674-.649-.916 0-.337.406-1.087 1.217-2.249.811-1.162 1.934-2.55 3.37-4.163a48.263 48.263 0 014.361-4.34c.091-.083.169-.126.233-.13.223 0 .487.196.793.587.305.392.458.725.458.999 0 .09-.062.198-.185.32-.989.99-1.738 1.749-2.249 2.277-.506.524-1.16 1.224-1.962 2.099a29.333 29.333 0 00-2.044 2.447c-.56.761-1.046 1.51-1.456 2.25a.336.336 0 01.027.122c0 .278-.23.67-.69 1.176a.229.229 0 01-.178.075zm.267-9.119c.447-.3.823-.738 1.128-1.313.31-.578.385-1.091.226-1.538-.429.15-.782.522-1.06 1.115-.278.588-.376 1.166-.294 1.736zm5.558 9.058c-.561 0-1.12-.203-1.675-.609-.556-.405-.834-.925-.834-1.558 0-.711.241-1.43.724-2.154.488-.729 1.092-1.093 1.812-1.093.26 0 .572.139.936.417.41 0 .816.145 1.217.437.401.287.602.716.602 1.285 0 .711-.28 1.436-.841 2.174-.556.734-1.203 1.1-1.941 1.1zm-.677-1.23c.446-.179.852-.58 1.217-1.204.369-.624.492-1.212.369-1.764-.374.123-.693.372-.957.745-.26.37-.438.752-.534 1.149a3.493 3.493 0 00-.095 1.073zM38.077 12.72c-.588 0-1.173-.169-1.757-.506a2.75 2.75 0 01-1.223-1.443c-.205-.514-.308-1.17-.308-1.968 0-1.158.182-2.309.547-3.452.364-1.144.85-2.088 1.456-2.83.606-.743 1.226-1.115 1.86-1.115.496 0 .945.178 1.346.533.711.215 1.212.561 1.504 1.04.292.473.438 1.125.438 1.955 0 1.13-.244 2.397-.732 3.8-.483 1.4-.984 2.438-1.504 3.118-.442.578-.984.868-1.627.868zm-.697-1.627c.524-.42 1.028-1.324 1.51-2.714.484-1.39.725-2.664.725-3.821 0-.497-.05-.912-.15-1.245-.738.429-1.324 1.208-1.757 2.338a9.597 9.597 0 00-.65 3.46c0 .806.108 1.467.322 1.982zM49.035 1.112c.205.037.442.258.711.663.273.401.41.718.41.95 0 .124-.052.187-.157.192-.811.082-1.964.34-3.459.772a84.682 84.682 0 00-.67 2.742c.916-.32 1.456-.477 1.62-.472.224 0 .5.198.827.595.328.396.493.715.493.957 0 .141-.067.212-.199.212-.542 0-1.61.307-3.206.923-.364 1.895-.556 3.249-.574 4.06a.453.453 0 01.068.267c.005.109-.05.25-.164.423-.114.174-.239.26-.376.26-.355 0-.754-.098-1.196-.294-.437-.196-.656-.41-.656-.642 0-.524.169-1.673.506-3.446a73.36 73.36 0 011.203-5.263 2.936 2.936 0 01-.5-.636c-.14-.246-.211-.449-.211-.608 0-.114.045-.19.137-.226a25.248 25.248 0 014.566-1.271c.073-.124.237-.185.492-.185.11 0 .221.01.335.027zM59.282.593c.27 0 .543.205.82.615.279.406.418.716.418.93 0 .132-.071.207-.212.225-1.523.16-3.432.54-5.729 1.142-.15.483-.328 1.146-.533 1.99.73-.242 1.155-.363 1.278-.363.214 0 .483.182.807.547.328.364.492.663.492.895 0 .114-.068.19-.205.226-.97.241-1.919.53-2.844.868-.428 2.12-.638 3.723-.629 4.812a.569.569 0 01.041.226c0 .114-.032.196-.095.246-.06.05-.192.075-.397.075-.383 0-.777-.095-1.182-.287-.406-.191-.609-.403-.609-.636 0-.81.2-2.187.602-4.128-.401-.438-.602-.784-.602-1.04 0-.063.032-.113.096-.15.15-.082.44-.219.868-.41.196-.802.374-1.493.533-2.071-.223-.028-.492-.226-.806-.595-.31-.37-.465-.665-.465-.889 0-.105.036-.175.11-.212.373-.177 1.665-.558 3.875-1.141 2.21-.584 3.666-.875 4.368-.875z" fill="#E62817"/>' +
      "    </svg>";
  }

  if (icon_id == "info") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">' +
      '      <path d="M11 7h2v2h-2V7zm0 4h2v6h-2v-6zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />' +
      "    </svg>";
  }

  if (icon_id == "badge-bluelight") {
    returnBadge =
      '<?xml version="1.0" encoding="utf-8"?>' +
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" version="1.1" width="88" height="28" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"' +
      '	 viewBox="0 0 478.86 164.94" style="enable-background:new 0 0 478.86 164.94;" xml:space="preserve">' +
      '<style type="text/css">' +
      "	.st0{fill:#002970;}" +
      "</style>" +
      "<g>" +
      '	<path class="st0" d="M379.61,70.59c3.95-1.14,7.73-2.21,11.49-3.36c0.33-0.1,0.65-0.7,0.73-1.12c2.05-11.22,4.53-22.34,8.06-33.21' +
      "		c0.56-1.71,1.34-2.32,3.07-2.03c3.24,0.55,6.22,1.76,8.77,3.87c1.78,1.47,1.93,2.26,1.13,4.37c-0.35,0.92-0.65,1.85-1.09,3.09" +
      "		c3.57-1.04,6.77-2.11,10.03-2.9c10.82-2.63,21.65-5.28,32.52-7.7c5.36-1.2,7.86,0.14,10.56,4.99c0.83,1.49,1.48,3.11,2.02,4.73" +
      "		c0.44,1.33-0.22,2.15-1.67,2.21c-0.61,0.03-1.29,0.16-1.83-0.05c-3.78-1.49-7.49-0.3-11.19,0.31c-3.13,0.52-6.23,1.25-9.3,2.03" +
      "		c-0.59,0.15-1.31,0.85-1.48,1.44c-3.97,13.76-6.64,27.8-8.63,41.96c-0.54,3.85-0.67,7.76-0.96,11.64c-0.05,0.6-0.02,1.23,0.08,1.83" +
      "		c0.38,2.41-0.11,3.05-2.56,3.05c-3.49,0.01-6.7-1.01-9.67-2.8c-1.48-0.89-2.23-2.12-1.99-3.89c0.9-6.55,1.5-13.17,2.76-19.65" +
      "		c1.79-9.22,4.05-18.35,6.1-27.51c0.11-0.47,0.14-0.96,0.25-1.7c-2.61,0.8-5.16,1.29-7.44,2.34c-3.04,1.4-5.13,0.33-7.06-1.86" +
      "		c-0.65-0.75-1.28-1.51-2.14-2.53c-0.78,3.49-1.51,6.72-2.22,9.96c-0.38,1.74-1.24,3.61-0.88,5.2c0.32,1.42,2.14,2.45,3.05,3.81" +
      "		c1.05,1.55,2,3.22,2.68,4.96c0.67,1.71,0.06,2.43-1.75,2.77c-1.75,0.33-3.52,0.6-5.24,1.05c-0.48,0.13-1.13,0.72-1.2,1.18" +
      "		c-1.05,7.04-2.03,14.09-2.97,21.15c-0.17,1.26-0.07,2.56-0.17,3.83c-0.12,1.53-0.98,2.27-2.55,2.23c-3.66-0.1-7-1.18-10.11-3.08" +
      "		c-1.63-1-1.88-2.46-1.62-4.19c0.83-5.39,1.62-10.78,2.42-16.17c0.04-0.26,0.06-0.53,0.12-1.08c-1.43,0.36-2.71,0.64-3.96,0.99" +
      "		c-2.42,0.67-4.84,1.31-7.22,2.11c-0.53,0.18-1.21,0.88-1.27,1.4c-0.64,5.63-1.41,11.26-1.67,16.92c-0.28,5.91-2.14,7.35-7.61,5.2" +
      "		c-0.67-0.26-1.34-0.55-1.99-0.87c-4.72-2.36-5.3-3.4-4.64-8.61c0.44-3.48,0.99-6.94,1.53-10.4c0.17-1.05-0.03-1.83-0.71-2.74" +
      "		c-1.08-1.45-1.94-3.09-2.69-4.75c-0.54-1.18-0.13-2.36,1.3-2.51c3.87-0.42,4.25-3.21,4.89-6.26c2.32-11.04,4.88-22.03,7.36-33.04" +
      "		c0.13-0.59,0.38-1.16,0.56-1.75c0.75-2.4,1.35-2.77,3.76-2.2c3.09,0.74,5.89,2.06,8.3,4.14c1.73,1.5,1.87,2.29,1.11,4.41" +
      '		c-3.27,9.08-5.42,18.45-7.13,27.93C379.65,69.94,379.64,70.15,379.61,70.59z"/>' +
      '	<path class="st0" d="M107.41,86.29c-8.16,1.85-15.83,4.84-23.7,7.7c0.06-0.73,0.05-1.33,0.18-1.9c2.1-9.5,3.92-19.07,6.43-28.46' +
      "		c2.06-7.72,4.92-15.23,7.49-22.81c0.5-1.48,0.57-2.69-0.81-3.68c-2.76-1.99-5.83-3.23-9.2-3.75c-1.57-0.24-2.47,0.28-2.96,1.87" +
      "		c-2.2,7.12-4.63,14.17-6.71,21.31c-3.48,11.92-5.99,24.06-7.76,36.35c-0.36,2.53-0.64,5.09-1.34,7.53" +
      "		c-0.37,1.28-0.37,2.24,0.57,2.97c1.96,1.53,3.97,3.04,6.1,4.32c2.02,1.21,4.15,1.11,6.38,0.06c8.65-4.08,17.64-7.25,26.92-9.59" +
      '		C112.62,96.84,111.01,85.41,107.41,86.29z"/>' +
      '	<path class="st0" d="M279.37,86.29c-8.16,1.85-15.83,4.84-23.7,7.7c0.06-0.73,0.05-1.33,0.18-1.9c2.1-9.5,3.92-19.07,6.43-28.46' +
      "		c2.06-7.72,4.92-15.23,7.49-22.81c0.5-1.48,0.57-2.69-0.81-3.68c-2.76-1.99-5.83-3.23-9.2-3.75c-1.57-0.24-2.47,0.28-2.96,1.87" +
      "		c-2.2,7.12-4.63,14.17-6.71,21.31c-3.48,11.92-5.99,24.06-7.76,36.35c-0.36,2.53-0.64,5.09-1.34,7.53" +
      "		c-0.37,1.28-0.37,2.24,0.57,2.97c1.96,1.53,3.97,3.04,6.1,4.32c2.02,1.21,4.15,1.11,6.38,0.06c8.65-4.08,17.64-7.25,26.92-9.59" +
      '		C284.58,96.84,282.97,85.41,279.37,86.29z"/>' +
      '	<path class="st0" d="M165.56,41.94c-2.21-1.71-4.73-2.71-7.48-3.1c-1.7-0.24-2.74,0.38-3.52,2.04' +
      "		c-6.68,14.27-13.76,28.34-21.94,41.83c-1.17,1.93-2.41,3.82-3.61,5.72c-0.28-0.37-0.3-0.63-0.25-0.87" +
      "		c1.62-8.18,2.97-16.42,4.95-24.51c1.91-7.77,4.46-15.37,6.76-23.04c0.35-1.16,0.41-2.16-0.58-3.03c-2.59-2.26-5.6-3.61-8.96-4.2" +
      "		c-1.53-0.27-2.48,0.27-3,1.87c-4.88,14.98-9.31,30.07-11.61,45.7c-0.59,3.98-1.38,8.27-0.82,12.29c0.5,3.56,2.55,6.31,5.63,8.11" +
      "		c1.36,0.79,2.75,1.43,4.27,1.88c4.28,1.24,7.96,0.56,10.63-3.3c1.96-2.84,3.95-5.66,5.8-8.57c1.8-2.84,3.44-5.77,5.15-8.67" +
      "		c0.11,0.03,0.22,0.06,0.33,0.09c-0.05,1.14-0.09,2.28-0.16,3.42c-0.3,5-0.65,10-0.89,15c-0.03,0.69,0.22,1.68,0.71,2.06" +
      "		c3,2.3,6.49,3.45,10.26,3.48c1.77,0.02,2.48-0.95,2.36-2.73c-0.06-0.89-0.27-1.77-0.27-2.65c-0.1-18.74,1.59-37.24,7.41-55.18" +
      '		C167.25,43.94,166.76,42.87,165.56,41.94z"/>' +
      '	<path class="st0" d="M58.7,61.75c1.53,1.3,2.99,2.41,4.3,3.67c4.44,4.25,5.26,9.49,2.34,14.89c-2.42,4.48-5.91,8.08-9.69,11.42' +
      "		c-6.94,6.12-14.54,11.25-23.15,14.78c-1.28,0.53-2.66,0.8-3.98,1.26c-2.66,0.93-5,0.31-6.92-1.61c-1.6-1.6-3.17-3.3-4.43-5.18" +
      "		c-1.45-2.14-1.01-2.89,1.35-3.75c0.49-0.18,1.13-0.8,1.15-1.26c0.48-8.5,2.42-16.73,4.56-24.91c1.73-6.62,3.7-13.17,5.62-19.73" +
      "		c0.28-0.96,0.13-1.49-0.59-2.29c-1.68-1.88-3.19-3.95-4.59-6.06c-0.78-1.18-0.26-2.17,1.06-2.82c8.86-4.32,17.98-7.81,27.81-9.25" +
      "		c8.07-1.19,14.35,1.65,18.44,8.28c2.1,3.41,2.39,6.83-0.27,9.89c-3.02,3.48-6.36,6.67-9.63,9.93C61.13,60,59.94,60.77,58.7,61.75z" +
      "		 M33.31,90.99c0.16,0.11,0.32,0.22,0.48,0.32c2.69-1.72,5.44-3.36,8.06-5.18c4.49-3.12,8.76-6.54,11.93-11.06" +
      "		c1.08-1.54,1.75-3.36,2.73-5.28c-0.81-0.09-1.07-0.16-1.34-0.14c-6.39,0.36-12.29,2.47-18.03,5.09c-0.38,0.17-0.77,0.68-0.86,1.09" +
      "		C35.26,80.88,34.29,85.94,33.31,90.99z M62.49,40.46c-0.53-0.06-0.74-0.12-0.94-0.1c-5.34,0.59-10.46,2.06-15.45,3.98" +
      "		c-0.45,0.17-0.84,0.84-1.02,1.36c-0.82,2.36-1.56,4.74-2.31,7.12c-0.69,2.19-1.36,4.38-2.03,6.57" +
      '		C49.17,54.39,57.03,48.97,62.49,40.46z"/>' +
      '	<path class="st0" d="M309.79,37.54c-2.6-1.07-5.28-2.05-8.02-2.63c-2.18-0.46-2.92,0.36-3.56,2.53' +
      "		c-4.05,13.73-6.89,27.73-9.08,41.86c-0.61,3.91-1.24,7.82-1.66,11.76c-0.27,2.5-0.53,5.01-0.79,7.51c-0.11,1.01-0.34,2.09,0.1,3.06" +
      "		c0.36,0.8,1.07,1.36,1.88,1.66c2.58,0.96,5.24,1.91,7.94,2.29c3.06,0.44,3.7-0.36,3.94-3.44c0.03-0.39,0.07-0.78,0.05-1.17" +
      "		c-0.06-1.48-0.36-2.99-0.18-4.44c0.73-5.74,1.54-11.47,2.46-17.17c2.07-12.85,4.6-25.61,8.32-38.1" +
      '		C311.73,39.44,311.33,38.17,309.79,37.54z"/>' +
      '	<path class="st0" d="M341.74,40.45c-9.64,6.2-13.76,15.95-17.11,26.67c3.78-1.03,7.18-2,10.61-2.88c3.99-1.02,7.98-2.09,12.02-2.9' +
      "		c4.09-0.82,7.69,0.67,10.98,2.96c1.08,0.75,1.23,1.8,0.94,3.1c-2.69,12.08-4.41,24.3-5.47,36.62c-0.1,1.21-0.11,2.44-0.2,3.65" +
      "		c-0.12,1.6-1.17,2.45-2.59,2.13c-2.58-0.57-5.16-1.31-7.61-2.29c-1.73-0.69-2.51-2.26-2.25-4.24c0.65-4.85,1.24-9.71,1.86-14.56" +
      "		c0.06-0.44,0.11-0.87-0.1-1.46c-0.27,0.42-0.54,0.84-0.82,1.25c-2.5,3.75-4.95,7.55-7.53,11.24c-2.28,3.26-4.56,4.03-8.43,2.98" +
      "		c-8.33-2.26-13.88-7.41-15.39-16.02c-2.9-16.5,1-31.49,11.02-44.85c3.06-4.08,7.03-7.14,12.08-8.55c3.67-1.02,7.28-0.94,10.76,0.77" +
      "		c1.45,0.71,2.92,1.4,4.32,2.2c3.86,2.2,6.02,5.6,6.55,9.94c0.26,2.14,0.14,4.33,0.1,6.5c-0.02,1.42-0.89,2.14-2.28,2.12" +
      "		c-3.5-0.05-6.67-1.14-9.51-3.19c-1.09-0.79-1.41-1.84-1.35-3.2c0.12-2.59,0.03-5.19,0.03-7.79" +
      "		C342.17,40.6,341.95,40.53,341.74,40.45z M338.94,72.45c-5.43,1.06-10.15,4.72-15.55,1.21c-0.88,6.03-1.13,11.67,1.06,17.49" +
      '		C330.05,85.41,334.39,79.09,338.94,72.45z"/>' +
      '	<path class="st0" d="M188.26,61.05c1.95-0.71,3.46-1.25,4.96-1.82c1.21-0.47,2.37-0.41,3.23,0.57c1.79,2.04,3.63,4.05,5.16,6.27' +
      "		c1.01,1.46,0.54,2.04-1.15,2.58c-4.67,1.48-9.33,3-13.97,4.57c-0.54,0.18-1.25,0.72-1.35,1.21c-1.14,5.33-2.19,10.68-3.25,16.02" +
      "		c-0.04,0.21-0.01,0.43-0.01,0.93c0.82-0.35,1.49-0.66,2.18-0.93c9.62-3.82,19.26-7.6,28.87-11.47c2.53-1.02,4.56-0.5,5.97,1.67" +
      "		c1.5,2.3,2.76,4.78,3.99,7.24c0.48,0.96,0.03,1.51-1.15,1.83c-14.97,4.05-29.2,9.92-42.61,17.72c-1.16,0.67-2.28,1.05-3.45,0.38" +
      "		c-2.49-1.44-4.98-2.9-7.36-4.5c-1.22-0.83-1.54-2.15-1.33-3.71c1.73-12.76,4.68-25.26,7.87-37.71c0.88-3.45,1.86-6.87,2.86-10.29" +
      "		c0.28-0.96-0.03-1.44-0.7-2.12c-1.7-1.74-3.4-3.53-4.77-5.53c-1.31-1.91-1.02-2.75,1.17-3.5c7.06-2.41,14.16-4.72,21.27-6.97" +
      "		c2.22-0.7,4.56-1.06,6.83-1.64c2.17-0.56,4.12-0.1,5.4,1.68c1.51,2.1,2.94,4.32,3.98,6.67c0.87,1.96,0,2.82-2.17,2.91" +
      '		c-5.46,0.23-10.64,1.81-15.82,3.35c-0.33,0.1-0.76,0.4-0.84,0.69C190.8,51.64,189.6,56.13,188.26,61.05z"/>' +
      "</g>" +
      '<path class="st0" d="M276.79,136.36c-4.8,0.1-9.6,0.33-14.39,0.66c-7.58,0.53-15.16,1.11-22.74,1.7c-7.8,0.61-15.6,1.24-23.39,1.89' +
      "	c-5.55,0.46-11.1,1.04-16.65,1.39c-1.93,0.12-4.19,0.86-6.03-0.04c-2.46-1.2-1.98-4.17-2.18-6.44c-0.33-3.64,0.95-5.92,4.38-7.24" +
      "	c4.25-1.63,8.82-1.64,13.29-1.85c4.99-0.23,9.99-0.53,14.98-0.82c6.67-0.39,13.33-0.8,20-1.22c8.87-0.55,17.91-1.26,26.84-1.84" +
      "	c4.56-0.29,9.13-0.58,13.71-0.74c3.19-0.11,6.7,1.65,7.39,5.03c0.01,0.07,0.02,0.13,0.04,0.2c0.3,1.84-0.47,3.28-1.32,4.84" +
      '	c-0.8,1.48-1.63,3.1-3.19,3.89c-1.74,0.88-3.81,0.53-5.68,0.53C280.15,136.3,278.47,136.32,276.79,136.36z"/>' +
      "</svg>";
  }
  if (icon_id == "badge-rx") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" version="1.1" width="28" height="24" id="Layer_1" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 111.1 130.3" style="enable-background:new 0 0 111.1 130.3;" xml:space="preserve"><style type="text/css">	.st0{fill:#4B5360;}</style><path class="st0" d="M60.4,64.4c2.1-3.7,3.8-7.4,6.2-10.8c2.6-3.8,3-7.5,1.7-12.1c-2-7.4-3.2-15-4.8-22.5c-0.3-1.5,0.2-2.5,1.5-3.2	c3.4-1.9,7-1.8,10.6-1.1c0.5,0.1,1.2,1.1,1.3,1.7c0.6,4,1.1,8.1,1.7,12.1c0.2,1.1,0.4,2.2,0.7,3.8c1.6-2.6,3-4.7,4.3-6.8	c2.9-4.6,5.8-9.2,8.7-13.8C93.5,9.9,95.1,9,97,9.6c2.6,0.8,5.2,1.9,7.7,3.1c1.4,0.7,1.5,1.7,0.5,3c-6.8,9-13.2,18.2-18.8,27.9	c-2.6,4.5-2.6,4.5-0.8,9.4c3.1,8.1,6.6,16,12.1,22.7c0.8,0.9,1,2-0.3,2.5c-2.4,1-4.7,2.1-7.2,2.7c-2.7,0.7-4.9-0.5-6.7-2.7	c-2.8-3.4-4.7-7.3-6.4-11.4c-0.5-1.2-1-2.4-1.7-3.9c-0.5,0.9-0.8,1.4-1.1,2c-2.3,5.6-4.6,11.2-6.8,16.9c-0.9,2.3-1,2.5-3.5,2.5	c-3,0.1-5.7-0.5-8.4-1.8c-2.7-1.3-3-2.2-1.9-4.9c0.2-0.6,0.4-1.1,0.6-1.7c-10.6-3.7-21.1-7.4-32-11.2c-0.4,4.8-1,9.6-1.2,14.3	c-0.1,2.1-0.6,3.1-2.7,3.2c-1.9,0.1-3.9,0.1-5.7-0.3c-4.1-0.8-5.4-3-4.6-7.1c2.6-14.8,6-29.5,10.1-44c0.6-2.1,0.5-3.7-1.1-5.4	c-1.2-1.2-1.9-2.9-2.7-4.5c-1-2.1-0.7-2.5,1.3-3.6c5.2-2.7,10.6-4.6,16.3-5.9c4-0.9,8-1.6,12.1-0.5C53.8,13.8,58.9,25,54.2,34	c-2.4,4.7-5.6,9-9.2,12.8c-3.2,3.3-6.4,6.6-9.8,10.1C43.7,59.4,52,61.9,60.4,64.4z M26.7,46.4c0.5-0.1,0.6-0.1,0.7-0.2	c6.4-5.8,12.5-12,16.8-19.6c0.9-1.6,1.4-3.4,2.2-5.2c-4.7-0.9-8.7,0.3-12.7,1.7c-0.5,0.2-0.9,1-1,1.6c-0.7,2.3-1.3,4.6-1.9,6.9	C29.3,36.5,28.1,41.3,26.7,46.4z"></path><path class="st0" d="M94.8,113c-7.7,0.4-15.4,0.6-23.1,1.2c-11.4,0.8-22.7,1.7-34.1,2.7c-8.4,0.7-16.8,1.5-25.2,2.3	c-3.2,0.3-4.9-1.1-5.2-4.4c0-0.6,0-1.3,0-1.9c-0.5-5.8,2.2-7.1,6.2-8.2c2.5-0.6,5.1-0.9,7.7-1.1c10.9-0.7,21.9-1.2,32.8-1.8	c10.1-0.6,20.3-1.4,30.4-2c4.8-0.3,9.6-0.7,14.4-0.9c2.6-0.1,5,0.8,6.5,3.1c1.3,2.1,0.9,4.2-0.2,6.3c-0.4,0.7-0.8,1.4-1.2,2.1	c-1,1.7-2.5,2.7-4.6,2.7c-1.5,0-3,0-4.4,0C94.8,113.1,94.8,113,94.8,113z"></path></svg>';
  }
  if (icon_id == "badge-readers") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="157.22" height="38" viewBox="0 0 828 200">  <image id="Vector_Smart_Object" data-name="Vector Smart Object" x="53" y="45" width="722" height="109" xlink:href="data:img/png;base64,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"></image></svg>';
  }
  if (icon_id == "badge-reversible") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="82" height="18" version="1.1" id="Layer_1" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 524.2 127.8" style="enable-background:new 0 0 524.2 127.8;" xml:space="preserve"><style type="text/css">	.st0rev{fill:#0078D4;}</style><path class="st0rev" d="M297.6,119.5c-4.8,0.1-9.6,0.3-14.4,0.7c-7.6,0.5-15.2,1.1-22.7,1.7c-7.8,0.6-15.6,1.2-23.4,1.9	c-5.5,0.5-11.1,1-16.7,1.4c-1.9,0.1-4.2,0.9-6,0c-2.5-1.2-2-4.2-2.2-6.4c-0.3-3.6,0.9-5.9,4.4-7.2c4.2-1.6,8.8-1.6,13.3-1.8	c5-0.2,10-0.5,15-0.8c6.7-0.4,13.3-0.8,20-1.2c8.9-0.6,17.9-1.3,26.8-1.8c4.6-0.3,9.1-0.6,13.7-0.7c3.2-0.1,6.7,1.6,7.4,5	c0,0.1,0,0.1,0,0.2c0.3,1.8-0.5,3.3-1.3,4.8s-1.6,3.1-3.2,3.9c-1.7,0.9-3.8,0.5-5.7,0.5C301,119.4,299.3,119.4,297.6,119.5z"></path><g>	<path class="st0rev" d="M175.3,12c4.9-1.6,9.8-3.4,14.8-4.8c6.3-1.8,12.7-3.3,19.1-4.9c0.3-0.1,0.8-0.1,1-0.3c2-1.8,3.7-0.6,5.2,0.6		c1,0.8,2,1.9,2.6,3c1.1,2.1,2,4.4,2.7,6.7c0.6,2,0.2,2.5-1.9,2.9c-6.7,1.3-13.5,2.7-20.2,4.1c-1.3,0.2-1.9,0.8-2.3,2.1		c-1.4,4.5-2.9,9-4.4,13.4c-0.1,0.4-0.1,0.8-0.2,1.3c2.5-0.7,4.8-1.4,7-2.2c1.9-0.6,3.5-0.4,4.8,1c2.1,2.4,4.1,4.8,5.9,7.4		c1.3,1.9,0.7,2.7-1.6,3.2c-6.9,1.4-13.5,3.9-19.9,7c-0.5,0.2-1.1,0.8-1.2,1.2c-1.2,5.8-2.4,11.5-3.6,17.3c0,0.1,0,0.3,0.1,0.7		c0.6-0.4,1.1-0.7,1.6-1c5.4-3,10.7-6,16.1-9.1c1.3-0.8,2.6-0.6,3.7,0.3c3.3,2.4,5.7,5.4,7.1,9.2c0.4,1.2,0.4,2.1-1,2.8		c-10,4.4-19.2,10-28,16.3c-1.7,1.2-3.4,1.4-5.2,0.5c-3.6-1.7-6.7-4.1-9.2-7.3c-0.9-1.1-1.3-2.4-1.2-3.8c0.4-7.6,1.7-15.1,3.6-22.4		c2.8-11,5.9-21.9,9-32.9c0.3-0.9,0.1-1.4-0.6-2c-2-1.6-3.9-3.4-6-5.2c-1.7,0.6-2.6,2.3-3.4,4c-6,11.2-10.9,22.8-15.4,34.7		c-3.7,9.6-7,19.3-10.3,28.9c-0.4,1.3-1.1,2-2.4,2.2c-4,0.5-7.8,0-11.4-1.7c-1.9-0.9-2.8-2.2-2.8-4.5c-0.3-16.2-0.5-32.5-1.2-48.7		c-0.4-9.6-1.7-19.1-2.6-28.6c-0.2-2.1,0.2-2.8,2.3-3c4.2-0.4,8.1,0.6,11.6,2.9c0.8,0.5,1.4,1.7,1.5,2.7c0.6,5.4,1.3,10.8,1.5,16.2		c0.4,8.6,0.4,17.2,0.5,25.8c0,0.5,0,1.1,0,1.6c0.1,0,0.2,0,0.4,0.1c1-2.6,2-5.3,3.1-7.9c5-11.4,10.2-22.8,15.2-34.3		c0.7-1.6,1.8-2.3,3.5-2.1c4.3,0.4,8.1,2.2,11.3,5C174.6,10.8,174.9,11.4,175.3,12z"></path>	<path class="st0rev" d="M493.3,36c2.5-0.8,4.9-1.4,7.2-2.2c1.7-0.5,3.1-0.2,4.4,0.9c2.6,2.2,4.8,4.8,6.2,7.9c0.8,1.9,0.5,2.5-1.5,2.9		c-7.1,1.4-13.8,3.9-20.3,7.1c-0.4,0.2-0.9,0.7-1,1.2c-1.2,5.7-2.3,11.3-3.5,17c0,0.2,0,0.5,0,1c0.8-0.6,1.5-1,2.2-1.4		c5.2-2.9,10.4-5.8,15.6-8.7c1.3-0.8,2.6-0.5,3.7,0.3c3.2,2.3,5.6,5.3,7,9c0.7,1.8,0.4,2.4-1.4,3.2c-9.6,4.3-18.6,9.7-27.1,15.8		c-2.3,1.6-4.3,1.7-6.5,0.4c-1.5-0.9-2.9-1.8-4.2-2.8c-4.2-2.9-6.4-6.7-5-12c0.1-0.6,0.1-1.2,0.2-2.1c-1.9,0.6-3.5,1.1-5.1,1.6		c-7.7,2.7-15.1,6.2-22.2,10.3c-1.5,0.8-2.9,1-4.4,0.6c-3.9-1.2-7.3-3.2-10.3-6c-1.6-1.4-1.7-3.2-1.4-5.1c1.2-6.2,2.3-12.5,3.8-18.7		c4.1-17,9-33.9,14.6-50.5c0.2-0.5,0.3-1,0.2-1.5c-0.3-2.5,1.5-4.7,4-4.4c4.1,0.4,7.8,1.9,11.1,4.5c1.4,1.1,1.5,2.3,0.8,3.9		c-5.5,14-10.2,28.2-13.9,42.8c-1.3,5.4-2.3,10.8-3.4,16.2c-0.1,0.4-0.1,0.8-0.2,1.5c0.7-0.4,1.3-0.7,1.9-0.9		c4.8-2.2,9.7-4.5,14.5-6.7c1.7-0.8,3.3-0.6,4.8,0.5c1.7,1.3,3.3,2.8,4.9,4.2c0.4,0.3,0.7,0.7,1.2,1.3c0.6-3.1,1.1-6,1.9-8.8		c3-11.2,6-22.4,9.1-33.6c0.3-1.2,0.1-1.8-0.9-2.6c-2-1.7-3.9-3.5-5.4-5.6c-1.4-1.8-1-3,1.2-3.7c7.8-2.6,15.5-5.3,23.4-7.7		c3.8-1.2,7.8-1.9,11.7-2.8c0.3-0.1,0.8-0.1,1-0.3c1.6-1.6,3.2-0.7,4.6,0.2c3,2.1,4.5,5.3,5.5,8.7c1.1,3.7,0.9,3.7-2.9,4.4		c-6.5,1.2-13,2.7-19.4,4.1c-0.5,0.1-1.2,0.7-1.4,1.1c-1.7,4.9-3.3,9.9-5,14.9C493.3,35.5,493.3,35.7,493.3,36z"></path>	<path class="st0rev" d="M407.9,40.3c0.5,0.3,1,0.5,1.4,0.8c1.7,1.2,3.5,2.2,5,3.6c4.5,3.9,5.6,8.7,3.7,14.3c-1.5,4.5-4.1,8.3-7.4,11.8		c-7.5,7.9-16.4,13.9-26.4,18.2c-2.7,1.2-5.3,1.1-8-0.2c-2.9-1.5-5.6-3.2-7.9-5.6c-1.1-1.2-1.6-2.5-1.5-4.2		c0.4-11.4,2.1-22.5,4.7-33.6c2.2-9.5,4.8-18.8,7.3-28.3c0.3-0.9,0.1-1.6-0.4-2.4c-1.2-1.8-2.3-3.6-3.2-5.6		c-0.6-1.2-0.1-2.2,1.3-2.8c9.5-3.8,19.2-5.9,29.5-5.1c3.4,0.3,6.6,1.4,9.3,3.4c2.3,1.8,4.5,3.7,6.4,5.9c3.1,3.5,3.1,7.7,1.6,11.9		c-2.2,6.3-6.6,11-11.7,15.1C410.4,38.6,409.2,39.4,407.9,40.3z M404.6,50c-0.6-0.1-1-0.2-1.5-0.3c-5.9-0.3-11.4,1-16.7,3.3		c-0.5,0.2-0.9,1.1-1,1.7c-0.7,3.8-1.3,7.7-1.9,11.5c-0.3,2.3-0.6,4.5-0.9,7.2c1.3-0.8,2.2-1.3,3.1-1.9c6.1-4,11.9-8.4,16.1-14.5		C403.2,55,404.4,52.8,404.6,50z M411.7,13.6c-0.6-0.2-0.8-0.3-1-0.3c-5-0.4-9.9,0.5-14.7,1.9c-0.4,0.1-0.8,0.7-1,1.2		c-0.9,2.9-1.9,5.8-2.7,8.8c-1,3.4-1.9,6.9-2.8,10.3c2-0.8,3.8-1.8,5.5-2.9c5.3-3.5,10.3-7.3,13.7-12.8		C409.9,18,410.7,15.8,411.7,13.6z"></path>	<path class="st0rev" d="M21.7,55.7c-0.7,3.7-1.6,7-2,10.3c-0.8,5.4-1.3,10.9-1.9,16.3c-0.1,1.2-0.5,2-1.8,2.2		c-4.7,0.6-9.1-0.3-13.1-2.9c-1.4-0.9-1.2-2.3-1-3.6c0.7-4,1.2-8.1,2.1-12.1c3.6-15.1,7.4-30.1,11.2-45.2c0.3-1.2,0.2-2.1-0.5-3.1		c-1.1-1.5-2-3.2-2.9-4.9c-0.7-1.3-0.3-2.3,1.1-3c7.9-4.2,16-7.7,24.9-9C43.6-0.2,49.1,1,53.4,5.3c2.2,2.1,4.4,4.4,5.8,7.1		c2.4,4.3,1.6,8.9-0.1,13.4c-2.8,7.3-7.1,13.7-12.2,19.6c-2.7,3.1-5.8,5.8-8.7,8.7c-0.7,0.7-0.9,1.2-0.5,2.1		c3.8,8.4,8.4,16.3,13.7,23.9c0.2,0.3,0.4,0.6,0.7,0.8c1.2,1.2,1.3,2.8,0,3.9c-3.6,3-7.8,4.6-12.5,4c-0.9-0.1-2.1-1-2.6-1.8		C31.1,77.4,26.1,67.5,22.3,57C22.2,56.7,22,56.4,21.7,55.7z M46.8,12.6c-0.5,0-0.9,0-1.2,0c-4.5,0.3-8.7,1.8-12.8,3.7		c-0.5,0.2-0.9,0.9-1.1,1.5c-2.2,7.8-4.4,15.6-6.6,23.3c-0.4,1.6-0.8,3.2-1.3,5.2c1-0.7,1.6-1,2.2-1.5c8.2-6.5,14.4-14.5,18.7-24		C45.9,18.4,46.8,15.7,46.8,12.6z"></path>	<path class="st0rev" d="M241.5,55.6c-0.9,4.5-1.8,8.6-2.4,12.7c-0.7,4.7-1.1,9.4-1.5,14c-0.1,1.1-0.6,1.9-1.7,2		c-4.7,0.6-9.1-0.3-13.1-2.9c-0.6-0.4-1.1-1.7-1-2.5c0.6-4.4,1.1-8.8,2.1-13c3.7-15.2,7.5-30.4,11.3-45.6c0.2-1,0.1-1.7-0.4-2.5		c-1.2-1.7-2.2-3.6-3.1-5.4c-0.6-1.1-0.2-2,0.9-2.6c8.1-4.4,16.5-8,25.6-9.3c7.3-1,13,1.9,17.9,7.2c4.3,4.6,5.4,9.8,3.7,15.8		c-2.1,7.1-5.9,13.2-10.5,18.8c-3.4,4.1-7.4,7.8-11.2,11.6c-0.6,0.6-0.9,1.1-0.5,1.9c3.9,8.5,8.5,16.5,13.8,24.1		c0.2,0.2,0.4,0.5,0.6,0.7c1.2,1.3,1.3,2.8,0,3.9c-3.6,3-7.8,4.6-12.5,4c-0.9-0.1-2.1-1-2.6-1.8c-5.9-9.5-10.9-19.5-14.7-30		C242.1,56.5,241.9,56.3,241.5,55.6z M243.8,46.3c0.8-0.5,1.2-0.7,1.6-0.9c9.1-7.1,15.9-15.9,20.1-26.6c0.8-1.9,1-4,1.5-6.1		c-0.9,0-1.4,0-1.9,0c-4.1,0.3-7.9,1.7-11.6,3.3c-1.1,0.5-1.7,1.2-2,2.3c-1.6,5.8-3.3,11.5-4.9,17.3		C245.6,38.9,244.8,42.4,243.8,46.3z"></path>	<path class="st0rev" d="M86.2,36c2.5-0.8,4.9-1.5,7.2-2.2c1.6-0.5,3-0.2,4.3,0.9c2.5,2.2,4.7,4.6,6.1,7.6c1,2.1,0.6,2.8-1.6,3.3		c-7,1.4-13.6,3.9-20,7c-0.4,0.2-0.9,0.6-1,1c-1.3,5.9-2.6,11.9-3.9,17.8c0.2,0.1,0.3,0.2,0.5,0.3c0.5-0.3,1-0.6,1.5-0.9		c5.4-3,10.7-6,16.1-9.1c1.4-0.8,2.7-0.6,3.9,0.3c3.2,2.3,5.5,5.2,6.9,8.9c0.7,1.9,0.4,2.5-1.5,3.3c-9.7,4.4-18.8,9.9-27.5,16.1		c-1.7,1.2-3.4,1.4-5.2,0.5c-3.7-1.7-6.9-4.1-9.3-7.4c-0.7-1-1.2-2.4-1.1-3.7c0.2-7.4,1.6-14.7,3.4-21.8c2.9-11.2,6-22.3,9.1-33.5		c0.3-1,0-1.5-0.8-2.1c-2-1.7-3.9-3.5-5.5-5.5c-1.6-2-1.1-3.1,1.2-4.1C78,9,87.4,6.2,96.9,3.8c2.3-0.6,4.7-1,7.1-1.5		c0.3-0.1,0.7-0.1,0.9-0.2c1.7-1.7,3.4-0.8,4.8,0.3c3.5,2.8,5.1,6.7,5.8,11c0.2,1.2-0.7,1.5-1.7,1.7c-4.2,0.7-8.4,1.4-12.6,2.2		c-2.9,0.6-5.8,1.4-8.7,2.1c-0.5,0.1-1.2,0.6-1.3,1c-1.7,4.9-3.3,9.9-5,14.9C86.1,35.5,86.2,35.7,86.2,36z"></path>	<path class="st0rev" d="M316.8,26.9c-0.6-3-1-6.1-1.9-9.1c-0.7-2.5-2.4-4.5-4.6-6c-0.8-0.5-1.3-0.5-2,0.2c-2.6,2.7-3.5,6-3.4,9.6		c0.1,4.5,1.6,8.7,3.4,12.7c3,6.3,6.2,12.5,9.3,18.7c2.7,5.3,5.5,10.6,6.7,16.4c1.3,6.4-0.6,11.2-6.3,14.5		c-11.6,6.7-24.1,5.9-34.4-4.6c-2.4-2.5-4.4-5.5-6.3-8.4c-1.3-2-1-3.4,0.7-5.1c2.7-2.8,6-4.5,9.8-5.2c1.6-0.3,2.7,0.3,3.6,1.7		c2.6,4.5,5.8,8.5,9.9,11.6c1.3,1,2.9,1.8,4.4,2.4c1.6,0.7,2,0.3,2.2-1.4c0.2-3.2-0.7-6.2-2-9.1c-3-6.5-6.2-12.8-9.2-19.3		c-2.3-5.1-4.9-10.1-6.5-15.4c-4.1-12.9,2.9-25.1,16.1-28.5c4-1.1,8.1-1.5,12.2-0.4c6,1.6,9.6,5.9,11.8,11.4		c1.8,4.8,2.4,9.7,1.7,14.8c-0.2,1.7-1,2.8-2.6,3.4c-3.5,1.3-7,1.6-10.6,1.1c-2.1-0.3-2.5-1-2.4-3.1c0.1-1,0.1-1.9,0.2-2.9		C316.5,26.9,316.7,26.9,316.8,26.9z"></path>	<path class="st0rev" d="M345.9,88.1c-2.8-0.2-6-1-9-2.8c-1.8-1-2.6-2.5-2.4-4.7c1.1-10.7,3.1-21.3,5.4-31.8c1.6-7.6,3.5-15.2,5.2-22.8		c0.4-1.6,1.2-2.3,2.7-2.3c4.1-0.1,7.8,1.1,11.1,3.4c1.2,0.9,1.5,2,1.1,3.5c-3.8,12.1-6,24.6-8,37c-0.5,3.1-0.9,6.3-1.3,9.4		c-0.1,0.9,0.1,1.8,0.1,2.7c0,1.5,0.1,3.1-0.1,4.6C350.4,87.5,349.6,88.1,345.9,88.1z"></path>	<path class="st0rev" d="M359.4,17.9c-2.7-0.9-5.4-1.5-8-2.6c-2.3-0.9-2.7-2-2.2-4.4c0.7-3.1,1.6-6.2,2.4-9.4c0.4-1.5,1.5-2.2,3-2.1		c3.7,0.1,7.2,1,10.5,2.8c1.9,1.1,2.2,1.9,1.6,4.1c-1,3.3-2,6.5-3.1,9.8c-0.2,0.6-0.9,1.1-1.5,1.3c-0.7,0.3-1.6,0.2-2.4,0.3		C359.5,17.6,359.5,17.7,359.4,17.9z"></path></g></svg>';
  }

  if (icon_id == "badge-bogo") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2290.42 541.31"><g id="BUY_1_GET_1" data-name="BUY 1 GET 1"><path d="M1313.79,510c-42.19,2.9-83.75,6.12-125.62,9-32.53,2.58-65.39,4.51-97.92,7.73-39,2.9-78,6.44-116.61,10-18.68,1.61-38,2.9-56.69,4.51-14.17,1-20.93-5.48-21.9-20.94a138.12,138.12,0,0,1,0-23.19c.64-12.24,7.73-20.94,18.68-24.48,14.82-4.51,30-8.06,45.1-9,48.31-3.55,96.31-6.12,144.62-8.7,30-1.61,59.92-3.54,89.87-5.48,40.59-2.57,81.5-5.47,122.08-8.05,15.79-1,30.92-1.93,46.71-1.93,25.44.64,42.52,21.9,29,47.67-9,16.75-19.65,26.41-39.94,24.48-12.24-1.61-24.48,0-36.4,0C1313.79,510.29,1313.79,510,1313.79,510Z" style="fill:#e62817"/><path d="M289,68.75q0,17.19-23.64,41.21a375.23,375.23,0,0,1-48,41.6q19.53,13.68,30,27.25t10.45,32.71q0,27.94-38.38,66.6a399.58,399.58,0,0,1-85.45,65.63q-47.07,27-72.66,26.95-10.35,0-26.75-16.79T18.1,326.76a10.22,10.22,0,0,1,.39-3.13,3.9,3.9,0,0,1,2.05-2.05,20.26,20.26,0,0,1,2.83-1.27c.78-.26,2.38-.65,4.79-1.17a36.41,36.41,0,0,0,5.56-1.56q0-62.31,50-222.46Q74.15,88.67,65,76.76T55.79,56.84a6.76,6.76,0,0,1,3.52-6.06q43.16-22.06,84.37-34.28T212,4.3q17.19,0,29.4,5.08t26.27,18.55Q289,49.22,289,68.75ZM99,291.21q43.55-23.62,75.19-53.42t31.64-49.31q-38.86,0-93,25.58A516.37,516.37,0,0,0,99,291.21Zm33.59-148.83a453.62,453.62,0,0,0,63.58-46.09q28.41-24.81,39.94-46.68-35.94,3.12-80.67,20.31Q136.07,129.5,132.55,142.38Z" style="fill:#e62817"/><path d="M498.76,361.13q-14.07,0-32.23-7.81t-18.17-14.06q0-31.65,6.06-96.1-35.55,62.31-52.05,83.21t-30.76,20.9a77.78,77.78,0,0,1-21.39-3,93.18,93.18,0,0,1-21.87-9.67q-11.24-6.63-18-20.41t-6.74-32.91q0-49.21,22.17-134.86T364,18.36q1.56-4.48,8.79-4.3,12.89,0,31.64,10t18.75,18a12.91,12.91,0,0,1-.78,3.13Q373.94,191.6,365.16,280.47,420.43,198.83,490,49.22l.78-1.95q2.34-4.5,10.35-4.5,13.27,0,29.69,8.6t16.4,17a14.38,14.38,0,0,1-.78,3.71q-35.94,108-36.13,268A34,34,0,0,1,512,350Q512,361.13,498.76,361.13Z" style="fill:#e62817"/><path d="M795.43,46.88q0,1.56-2.74,10-1.56,5.27-18.75,56.25t-26.56,79.68q-9.37,28.71-23,72.56T704.12,337.4q-6.55,28.23-6.54,40.92c0,.52.06,1.92.19,4.2a22.85,22.85,0,0,1,0,4.39,5.18,5.18,0,0,1-2,2.45,8.56,8.56,0,0,1-5.37,1.46q-16.41,0-38.58-14.06t-22.16-27.15q0-7.62,7.42-17.19,8.4-34.37,18.16-64.84a88.58,88.58,0,0,1-23.43-4.4q-10.56-3.6-12.31-8.49-9.18-26.37-14.94-77.74t-6.93-83.59q-1.19-32.22-1.18-51Q596.4,32,611.83,32q14.85,0,32.23,7.81t17.38,16.21q0,90,10.94,154.69,21.29-66.41,60.74-179.1a44.59,44.59,0,0,0,.59-6.05,25,25,0,0,1,1-6.45c.52-1.56,2.06-3.35,4.59-5.37s4.59-3,6.16-3Q757,10.74,776.19,24T795.43,46.88Z" style="fill:#e62817"/><path d="M1035.45,366.8a89.21,89.21,0,0,1-33.69-7q-17.28-7-17.29-17a87.59,87.59,0,0,1,8-36.72q11.13-66,25.2-126.26t20.5-77.45q-10.74,6.06-29.39,20.61T987.4,141.21a5.74,5.74,0,0,1-4.49,2.34q-9.57,0-25.19-13.76t-15.63-23.74q0-3.51,5.67-9.17,16.4-16.41,67.57-48.44t58.4-32q8.4,0,26.66,14.74t18.26,24.51c0,1.31-1.1,4-3.32,8q-18,32.43-36.13,115.33t-29.88,182.13Q1048.74,366.8,1035.45,366.8Z" style="fill:#e62817"/><path d="M1501.65,172.07a21.56,21.56,0,0,1-.79,4.69q-18,80.85-26.36,177.93a24.74,24.74,0,0,0,.19,2.83,23.74,23.74,0,0,1,.2,2.44q0,11.52-3.22,15.14t-9.67,3.61q-13.29,0-30.18-7.32t-16.89-18.27q0-24,10.74-85.15-30.47,49.21-46.09,68.75-8.4,10-22.66,10.16-18.36,0-46.88-17-43.55-26-43.55-104.29,0-48.06,16.8-96.39t49-81.93q32.22-33.6,70.51-33.6a60.89,60.89,0,0,1,24.8,5.08,221.11,221.11,0,0,1,22.66,11,94.77,94.77,0,0,1,17,13.37,48.44,48.44,0,0,1,13,21.59q3.81,12.8,3.81,30.76,0,14.05-2.25,18.65t-11,4.59q-14.46,0-32.23-8.2t-17.77-17.39c0-.51.06-1.72.19-3.61s.36-4.42.69-7.62.48-6.21.48-9.08q0-14.44-2.14-22.85-27.94,14.46-49.52,49.41a287.59,287.59,0,0,0-32.91,77.35q98.45-28.71,116-28.71,12.89,0,30.47,7.81T1501.65,172.07ZM1336.41,290q10.74-9.57,31-35.84t38.38-53.42q-41.61,14.46-49.61,14.45-10.74,0-24.81-7.61a245.13,245.13,0,0,0-2.93,35.93Q1328.4,272.86,1336.41,290Z" style="fill:#e62817"/><path d="M1979.18,4.3q6,7.62,11.23,22.85t5.17,26q0,6.84-1.56,8.7c-1,1.24-2.9,1.85-5.57,1.85s-5.63-1.49-8.88-4.49q-2.74-.78-13.87-.78-28.32,0-86.91,5.66a1291.3,1291.3,0,0,0-45.9,257q2.34,2.75,2.34,9.77,0,18.36-3.61,22.95t-14.36,4.59q-15.63,0-33.2-7.42t-17.58-16.21q0-23.64,13-107.23A1486.32,1486.32,0,0,1,1812,71.09q-90.43,11.14-155.66,24.42-14.46,44.73-23.83,82,40-14.46,48.24-11.52,8,3.12,16.8,17t8.79,23c0,5.35-2.35,8-7,8q-8.4,0-34.08,7.91a449,449,0,0,0-48,17.68q-8,33.21-10.35,59.57,41.21-19.53,75.2-28.91,3.9-1.95,5.86-1.95,10,0,22.55,18.85t12.6,29.2q0,3.51-1.95,3.9A583.3,583.3,0,0,0,1654,342.38q-35.94,14.07-58,28.71a12.78,12.78,0,0,1-5.46,2.15q-11.54,0-29.69-16.4-11.92-11.14-15.14-19.24T1542.46,318q0-57.23,45.51-210.74-9.2-6.45-17.78-21.49t-8.59-23a4.28,4.28,0,0,1,2.73-4.3q43.56-17.58,195.22-38T1964.33,0q7.62,0,9.87.59T1979.18,4.3Z" style="fill:#e62817"/><path d="M2189.12,366.8a89.21,89.21,0,0,1-33.69-7q-17.28-7-17.28-17a87.58,87.58,0,0,1,8-36.72q11.14-66,25.2-126.26t20.51-77.45q-10.76,6.06-29.4,20.61t-21.38,18.26a5.78,5.78,0,0,1-4.5,2.34q-9.57,0-25.19-13.76t-15.63-23.74q0-3.51,5.67-9.17,16.4-16.41,67.58-48.44t58.39-32q8.4,0,26.66,14.74t18.27,24.51q0,2-3.32,8Q2251,96.1,2232.87,179T2203,361.13Q2202.4,366.8,2189.12,366.8Z" style="fill:#e62817"/></g></svg>';
  }

  if (icon_id == "badge-bogo-50") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 848.3 127.8" style="enable-background:new 0 0 848.3 127.8" xml:space="preserve"><style type="text/css">.st0{fill:#3455db}.st1{fill:#fff}</style><path class="st0" d="M459.5,119.5c-4.8,0.1-9.6,0.3-14.4,0.7c-7.6,0.5-15.2,1.1-22.7,1.7c-7.8,0.6-15.6,1.2-23.4,1.9c-5.5,0.5-11.1,1-16.7,1.4c-1.9,0.1-4.2,0.9-6,0c-2.5-1.2-2-4.2-2.2-6.4c-0.3-3.6,0.9-5.9,4.4-7.2c4.2-1.6,8.8-1.6,13.3-1.8c5-0.2,10-0.5,15-0.8c6.7-0.4,13.3-0.8,20-1.2c8.9-0.6,17.9-1.3,26.8-1.8c4.6-0.3,9.1-0.6,13.7-0.7c3.2-0.1,6.7,1.6,7.4,5c0,0.1,0,0.1,0,0.2c0.3,1.8-0.5,3.3-1.3,4.8s-1.6,3.1-3.2,3.9c-1.7,0.9-3.8,0.5-5.7,0.5C462.9,119.4,461.2,119.4,459.5,119.5z"/><g><g><path class="st0" d="M795.9,25.1c-3.2-4.1-5.7-7.4-8.9-11.5c-6.2,1.4-13.5,3.1-20.9,4.9c-0.7,0.2-1.5,0.9-1.7,1.6c-1,3.3-1.9,6.6-2.9,10.5c2.3-0.6,4.1-1.1,5.9-1.5c3.5-0.8,10,4.5,9.5,8c-0.1,0.8-1.6,1.7-2.6,2.1c-4.4,1.4-8.8,2.7-13.3,4c-1.7,0.5-2.7,1.4-2.9,3.2c-1,9.3-2.1,18.5-3.3,27.7c-0.1,0.9-1.6,2.4-2.1,2.3c-3.4-0.8-6.9-1.7-10-3.2c-0.9-0.4-1.5-2.8-1.4-4.1c0.7-6.3,1.6-12.7,2.7-19c0.4-2.6,0.5-4.7-1.3-7c-2.5-3.2-2.1-4.1,1.7-5.7c2-0.8,2.9-2,3.3-4.1c0.6-3.1,1.5-6.1,2.2-8.5c-2.5-3-4.8-5.5-6.8-8.2c-1.2-1.7-0.7-3.2,1.5-3.8c14.6-3.7,29.1-7.7,43.8-11.1c6.5-1.5,8.4,0,11.4,6.1c0.3,0.6,0.6,1.1,0.9,1.8c8-2,15.9-4.1,23.9-6c4.4-1,8.9-1.7,13.4-2.2c3.6-0.4,9.1,5.5,8.3,9c-0.2,0.8-2,1.6-3.1,1.8c-9.7,2-19.4,4-29.1,5.8c-2.7,0.5-4,1.7-4.5,4.3c-0.5,2.7-1.3,5.2-2.2,8.5c2.3-0.6,4-1.1,5.8-1.5c3.5-0.9,10,4.4,9.5,7.9c-0.1,0.8-1.6,1.8-2.6,2.1c-4.4,1.5-8.8,2.8-13.3,4c-1.9,0.5-2.7,1.6-2.9,3.5c-1,9.2-2,18.3-3.2,27.4c-0.1,0.9-1.6,2.4-2.1,2.3c-3.4-0.8-6.8-1.8-10-3.2c-0.9-0.4-1.4-2.6-1.3-3.8c0.8-6.7,1.7-13.3,2.8-19.9c0.4-2.3,0.3-4.1-1.2-6.1c-2.6-3.3-2.2-4.3,1.6-6c1.8-0.8,2.8-1.9,3.2-3.8C794.5,30.4,795.3,27.3,795.9,25.1z"/><path class="st0" d="M540.2,45.9c0.4-9.6,2.7-21,9.4-30.9c2.4-3.5,5.9-6.5,9.4-9c3-2.1,6.7-2.3,10.2-0.2c0.8,0.5,1.8,0.7,2.7,0.7c5.6,0.1,9.6,2.8,11.6,7.8c1.7,4.2,3.1,8.8,3.5,13.3c1,12.4-1.9,24.2-8.3,34.9c-1.9,3.3-4.5,6.4-7.4,8.9c-8.5,7.2-21,4.9-26.8-4.5C541.5,62.1,540.1,56,540.2,45.9z M557.7,64.7c12.7-5.8,20.7-38.3,11.3-49.2C556.6,22.1,550.2,49.8,557.7,64.7z"/><path class="st0" d="M691.8,54.3c0.3-11.4,2.5-21.9,6-32.2c0.8-2.5,1.7-4.8,5.2-4.2c0.5,0.1,1.2-0.6,1.7-1.1c0.3-0.3,0.4-0.7,0.5-1.1c5.5-11.9,14.5-12.8,24.7-5.6c5.2,3.7,7.8,9.2,7.7,15.5c-0.2,14.9-4.4,28.7-12.9,41.1c-0.9,1.4-2.1,2.6-3.3,3.8c-4.8,4.8-10.2,7.4-17.1,4.8c-7.1-2.7-11.5-7.6-12.2-15.4C691.9,58,691.9,55.9,691.8,54.3z M722.8,15.4c-3.9,2.4-7.4,8.3-7.3,13.2c0.1,3.3-1.1,4.1-4,3.3c-0.5-0.1-1,0-1.5,0c-4.4,9.7-6.3,29.7-3.4,34.6C716.9,60.5,727.5,26.9,722.8,15.4z"/><path class="st0" d="M519.1,39.4c-6.4,1.2-11.2,4.4-15.7,8.4c-2.7,2.4-4.7,2.4-8.8,0c-3.9-2.3-4.8-3.7-3.9-7.2c1.6-6.5,3.3-13,5.2-19.4c0.6-2.1,0.9-3.8-0.3-5.9c-1.7-2.8-1.2-3.8,1.9-4.9c10.6-3.7,21.5-5.8,32.7-6.9c4-0.4,9.6,6.1,8.6,10.1c-0.2,0.8-2,1.5-3.1,1.7c-7.8,1.4-15.5,2.6-23.3,3.9c-2,0.3-3.1,1.4-3.8,3.3c-1,3.1-2.1,6.1-3.4,10.1c2.3-1.1,3.9-1.9,5.4-2.6c5.1-2.4,10-2.8,14.9,0.6c6.5,4.5,8.4,9.6,5.4,16.9c-5.3,13-14.3,22.9-26.9,29.3c-7.2,3.7-13.7,1.4-17.1-5.3c-1.6-3.1-1.1-4,2.2-4.4c11.5-1.5,27-14.9,30-25.9C519.1,40.7,519.1,40.3,519.1,39.4z"/><path class="st0" d="M657.5,15c-1.2,1.5-1.9,2.6-2.8,3.6c-9.9,10.6-20.1,21-29.8,31.7c-4.4,4.9-8.2,10.4-11.9,15.8c-1.8,2.6-2.8,5.8-4.2,8.6c-3.9,7.6-4.9,7.6-10.8,3.1c-5-3.8-5.4-5.7-2.1-11.2c8.7-14.7,19.9-27.6,31.6-40c6.2-6.6,12.9-12.6,19.3-19c2-2,3.9-2,5.6,0.1C654.2,10,655.7,12.5,657.5,15z"/><path class="st0" d="M656,62.3c-0.9,6.5-4.2,12.8-11.1,16.7c-5.2,2.9-10.2,1.5-14.9-1.5c-4.4-2.9-6.6-6.9-5.8-12.3c0.8-5.5,3-10.3,7.1-14.1c4-3.8,8-4.1,12.9-1.6c1.2,0.6,2.6,0.8,3.9,1.2C653.2,52.1,656.1,55.9,656,62.3z M644.3,55.5c-5.7,2.2-9.9,10.2-8.9,17C641.3,70.6,646.2,61.2,644.3,55.5z"/><path class="st0" d="M625.6,14.4c-1.1,6.8-4.5,13.6-11.9,17.6c-7.8,4.2-18.8-2.3-19-11.1c-0.1-7.1,2.5-13.2,7.9-17.8c4.9-4.2,9.9-4,14.8,0.2c1,0.9,2.2,1.6,3.4,2.2C624.3,7.1,625.6,9,625.6,14.4z M613.7,8.7c-5.4,2-9.3,10.3-7.8,16.1C611.2,22.2,615.1,14.3,613.7,8.7z"/></g><path class="st0" d="M316.2,13.2c7.6-1.7,14.1-3.6,20.7-4.5c20.4-2.7,40.9-5.2,61.3-7.5c7.9-0.9,12.1,4.7,10.1,12c-7.2,0.3-14.2,0.7-21.1,0.9c-2.3,0.1-3.2,1-3.8,3.1c-4.4,17.6-8.5,35.3-8.5,53.7c0,4.4-1.4,5.6-5.9,4.9c-7.3-1.1-9.2-3.1-8.1-10c2.5-16.4,5.2-32.7,8-49.6c-2.1,0.2-4.7,0.3-7.3,0.7c-7,1.1-13.9,2.3-20.9,3.3c-2.7,0.4-4,1.6-4.7,4.2c-1.1,4.2-2.4,8.4-3.9,13.5c2.8-0.8,4.7-1.7,6.6-1.7c2.1,0.1,4.7,0.6,6,1.9c4.3,4.5,3.5,6.8-2.4,8.4c-1.7,0.5-3.3,0.9-5,1.5c-9.8,3.3-10.1,3.8-10.2,15c4.6-1.7,9.1-3.4,13.7-4.9c4.4-1.5,11,4.1,10.1,8.6c-0.2,0.8-1.4,1.6-2.4,2c-7.8,3.3-15.7,6.4-23.5,9.7c-4.9,2.1-12.4-4.6-11.9-11.2c0.3-5.1,1.2-10.2,2.3-15.3c1.8-8.1,3.9-16.1,6.1-24.1c0.7-2.7,0.8-4.7-1.2-7C318.7,19,318,16.5,316.2,13.2z"/><path class="st0" d="M3.6,69.3c0.7-2,1.7-3.9,2.2-6c3.1-12.6,6-25.3,9.1-37.9c0.7-2.8,1-4.8-1.4-7.1c-4.7-4.5-4.3-6.4,1.9-8.6c8.4-3,16.9-5.6,25.5-7.4c3.4-0.7,7.9,0.4,11,2.2c9.1,5.3,9.7,12,2.5,19.5c-2.9,3-6.1,5.6-10,9.2c0.8,0.4,1.7,0.6,2.3,1.1c7.5,6.2,8.5,12.1,2.5,19.7c-8.6,11-19.8,18.7-32.8,23.6c-6.3,2.3-11.3-0.8-14-8.2C2.9,69.4,3.2,69.4,3.6,69.3z M19.3,61.3c10-3.4,21.7-14.4,22-21.7c-6.2,2-12,3.8-17.7,5.8c-0.7,0.2-1.3,1.2-1.5,1.9C21.1,51.8,20.3,56.4,19.3,61.3z M26.8,29.9c8.6-3.7,19-13.1,20.7-18.9c-5.3,1.5-10,2.8-14.8,4.2c-0.7,0.2-1.5,1-1.7,1.7C29.6,21,28.4,25,26.8,29.9z"/><path class="st0" d="M289.2,11.1c-10.3,6.9-14.5,15.8-17.7,26.7c7-1.7,13.1-3.4,19.2-4.7c2.3-0.5,4.9-0.9,7.2-0.6c7,0.8,8.2,3.1,7.1,9.9c-1.8,10.7-3.1,21.5-4.6,32.3c-0.3,2.5,0.6,5.9-3.8,5.7c-5.6-0.3-9.2-3.2-8.8-7.3c0.4-4.4,1-8.8,0.9-13.5c-2.2,3.2-4.4,6.4-6.7,9.6c-3.4,4.8-6,5.5-11.5,3.5c-7.1-2.5-11.8-7.3-13.1-14.7c-3.1-17.2,0.8-32.8,12-46.1c7.4-8.8,16-10,25.4-4.7c5.7,3.3,8.7,9.7,7.3,16.1c-0.2,0.8-0.9,2.1-1.2,2c-3-0.4-6.3-0.5-9-1.8c-1.4-0.6-2.3-3.2-2.7-5C288.9,16.5,289.2,14.3,289.2,11.1z M270.2,60.7c0.7,0.2,1.3,0.3,2,0.5c4.2-5.5,8.4-11.1,13-17c-5.6,0.7-10.1,1.3-15.7,2.1C269.7,50.5,270,55.6,270.2,60.7z"/><path class="st0" d="M92.2,53.7c-3.2,5-6,9.6-9.1,14.1c-4.2,6-6.7,7-12.6,5.2c-5.8-1.7-9.5-5.9-9.2-12c0.4-7.1,1.1-14.3,2.7-21.2c2.4-10.6,5.6-21,8.7-31.4C74,3.5,75,3.1,79.8,4.9c6.3,2.3,6.7,3.6,5.1,9.7C81.3,28,78,41.5,74.7,55c-0.2,0.8-0.1,1.6,0.5,2.7c0.9-1.4,2-2.7,2.7-4.1c7.1-13.3,14.4-26.4,21.1-39.9c2-4,4.4-4.2,7.9-2.9c5,1.9,6,3.3,4.6,7.5c-5.5,17.4-7,35.3-6.8,53.4c0.1,4.5-0.7,5.2-5.3,4.4c-6.8-1.1-8.2-2.9-7.7-9.6c0.3-4,0.5-8,0.7-12C92.6,54.4,92.5,54.3,92.2,53.7z"/><path class="st0" d="M133.7,56.9c-8.1,0.3-8.9-5.2-9.4-10.6c-1.1-11.2-2.1-22.5-2.9-33.7c-0.3-4.4,0.9-5.3,5.4-4.6c6.7,1.1,8,2.7,8.4,9.4c0.4,8.5,1,17.1,2.6,25.7c0.4-0.9,0.9-1.9,1.3-2.8c3.8-11.4,7.6-22.8,11.4-34.2c0.8-2.3,2-3.2,4.5-2.4c7.1,2.1,9,5.7,6.8,12.7c-6,18.9-11.9,37.9-17.8,56.9c-0.5,1.8-0.9,3.7-0.9,5.5c0.1,4-1.7,4.9-5.1,3.4c-2-0.9-4-1.8-5.7-2.9c-3.2-2.1-4.5-4.5-2.5-8.7C131.6,66.6,132.2,62.1,133.7,56.9z"/><path class="st0" d="M210.9,22.4c-3.6,2.8-6.4,4.8-9.1,6.9c-2.8,2.2-5.5,1.3-9-2.6c-2.4-2.7-2.1-4.9,0.8-6.8c7.5-4.8,14.9-9.7,22.5-14.4c4.1-2.6,6.7,0.8,9.4,2.9c2.6,2.1,2.8,4.3,1.4,7.5c-6.2,14.1-8.5,29.3-11,44.4c-0.8,4.5-1.4,9.1-1.8,13.6c-0.3,3.2-2.1,4.2-5,3.7c-1.3-0.2-2.6-0.4-3.8-0.8c-4.8-1.4-5.9-3-4.9-7.8c3-13.7,6.1-27.3,9.2-41C210,26.6,210.3,25.1,210.9,22.4z"/><path class="st0" d="M446.3,22.8c-3.2,2.5-5.9,4.5-8.5,6.5c-2.9,2.2-5.4,1.4-9-2.6c-2.4-2.6-2.2-4.8,0.7-6.7c7.6-4.9,15.1-9.9,22.9-14.6c4.1-2.5,6.6,1.2,9.3,3.3c2.3,1.8,2.6,3.9,1.3,6.8c-6.1,13.6-8.3,28.2-10.8,42.7c-0.9,5.3-1.7,10.7-2.3,16.1c-0.3,2.9-1.7,3.7-4.3,3.4c-1.4-0.2-2.9-0.4-4.2-0.8c-5.2-1.5-6.1-3.3-4.9-8.5c3.3-14.5,6.6-29,9.8-43.5C446.4,24.6,446.3,24.1,446.3,22.8z"/></g></svg>';
  }

  if (icon_id == "badge-limited-heart") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation"  viewBox="0 0 3425.4 541.3" height="28" width="120"><g fill="#bf3530"><path d="M1877.7 510l-125.6 9-97.9 7.7-116.6 10-56.7 4.5c-14.2 1-20.9-5.5-21.9-20.9-.6-7.7-.6-15.5 0-23.2.7-12.2 7.7-20.9 18.7-24.5 14.8-4.5 30-8.1 45.1-9l144.6-8.7 89.9-5.5 122.1-8c15.8-1 30.9-1.9 46.7-1.9 25.4.6 42.5 21.9 29 47.7-9 16.8-19.7 26.4-39.9 24.5-12.2-1.6-24.5 0-36.4 0-1.1-1.4-1.1-1.7-1.1-1.7zM57.4 376.2c-8.6 0-19-4.3-31.1-12.8S8.2 348.1 8.2 343c0-.8.6-2.1 1.8-4 1.2-2 1.9-4.2 2.1-6.5C25.3 227.5 50.2 124.4 86.5 25c1.3-3.5 4-5.3 8-5.3 9.1 0 20.4 3.2 33.9 9.6s20.2 12.2 20.2 17.6c0 1-.6 3.1-1.8 6.1-32.6 87-55.2 171.8-68 254.3 20.3-8.6 44.5-17.3 72.5-26.2s44.3-13.3 48.8-13.3c6.9 0 14.9 6.3 24.1 19s13.8 22.1 13.8 28.5c0 1.8-.5 2.9-1.6 3.3-11.2 4.3-18.6 6.7-22.1 7.2-2.1.2-4.2-.4-5.9-1.8-17.6 3.8-40.9 10.7-70 20.9s-52 19.5-68.9 27.9c-3.6 2.2-7.8 3.3-12.1 3.4z"/><path d="M268.7 362.1c-10.4 0-21.4-2.5-33-7.4s-17.4-10.4-17.4-16.2c0-18.9 5.5-61.6 16.6-128.1s24.6-125.7 40.6-177.5c1-4 5.3-6 12.7-5.9 9.4 0 19.8 2.5 31.2 7.6s17.2 10.3 17.2 15.6c-.1 1.1-.4 2.1-.8 3.1-9.4 29.8-19.3 71.6-29.9 125.4S287.8 281.3 283 325c1.1 1 1.9 2.4 2.1 3.9 0 15-1 24.3-3 27.8s-6.4 5.4-13.4 5.4zm313.9 22.5c-10.1.1-20.1-1.7-29.6-5.1-9.3-3.4-14-7.9-14-13.5 0-17 2-46.9 6.1-89.5 4-42.7 8.6-79.6 13.7-110.8-24.5 41.3-44.8 81.2-60.9 119.7-2.1 4.8-7.5 7.2-16.3 7.2-8.5 0-16.9-1.2-25-3.8-7.9-2.5-11.8-6-11.8-10.3V143.4c-13.3 35.7-24.9 75.3-34.8 118.9s-14.8 72.8-14.8 87.5c0 4.8-4.8 7.2-14.5 7-10.7-.1-21.3-2-31.4-5.6-10.8-3.7-16.2-9.1-16.2-16.3 0-22.1 11.3-69.3 33.9-141.6s45.5-131.5 68.6-177.7c2.1-4.6 7-6.8 14.9-6.7 10.4 0 20.7 2 30.4 5.8C491 18.6 496 23 496 28.1c0 .3-.2 2.8-.6 7.6L494 55.5l-1.4 29.4c-.4 11.2-.5 25.1-.4 41.6s.6 33.6 1.4 51.2c14.2-26.7 31.1-55.2 50.8-85.6s34.2-51.4 43.6-62.8c2.5-3.4 6.5-5.4 10.7-5.3 9.1 0 18.9 2.1 29.3 6.2s15.6 8.5 15.6 13.1c-.1 1.3-.4 2.6-.8 3.9-10.9 44-20.5 98.3-28.8 162.8s-12.4 119.8-12.4 165.7c-.2 6-6.5 8.9-19 8.9zm127.1-22.5c-10.4 0-21.4-2.5-33-7.4s-17.4-10.4-17.4-16.2c0-18.9 5.5-61.6 16.6-128.1s24.6-125.7 40.6-177.5c1-4 5.3-6 12.7-5.9 9.4 0 19.8 2.5 31.2 7.6s17.2 10.3 17.2 15.6c-.1 1.1-.4 2.1-.8 3.1-9.4 29.8-19.3 71.6-29.9 125.4S728.8 281.3 724 325a7.27 7.27 0 0 1 2.2 3.9c0 15-1 24.3-3 27.8-2 3.6-6.5 5.4-13.5 5.4z"/><path d="M1020.5 2.2c5.6 0 12.7 6.8 21.4 20.4s13 23.6 13 30c0 6.9-3.6 10.3-10.9 10.3-2.4-.1-4.8-.9-6.7-2.3-2.4-1.6-4.1-2.3-5.2-2.3s-5.4.4-13.2 1.2c-7.7.8-19.6 2.4-35.5 4.8s-31.5 5.2-46.9 8.3a1525.89 1525.89 0 0 0-45.2 172.3c-12 59.6-18.1 97.7-18.1 114.2a16.52 16.52 0 0 0 1.8 6.1c1.1 2.4 1.7 5 1.8 7.7 0 8.2-5.7 12.4-17.2 12.5-10.9 0-22.9-3.1-35.9-9.4s-19.6-12.6-19.6-19.1c0-13.3 6.2-48.5 18.6-105.6s25.7-110.1 39.9-159.1c-14.9 4.6-29.5 10.2-43.8 16.8-1 .5-2.5 1.3-4.3 2.3-1.5.9-3.1 1.7-4.8 2.3-1.5.5-3.2.8-4.8.8-5.6 0-13.9-6-25-18s-16.6-20.3-16.6-24.8c0-3 1.8-5.4 5.5-7.2 18.9-9.3 63.6-22 134.3-38.1s109.7-24.1 117.4-24.1z"/><path d="M1217.1 232.5c6.4 0 14 6.3 22.8 18.9s13.2 22.6 13.2 30c0 3.3-1.2 4.9-3.5 4.9-10.9 0-42.1 10.3-93.7 30.8-51.5 20.5-89.2 38.8-113.2 54.8-1.8 1.3-3.9 2-6.1 2-6.9 0-16.8-4.3-29.8-12.8s-19.4-15.6-19.4-21.2c0-11.2 5.3-42 15.8-92.4s22.9-99.4 36.9-147.1c-7.2-4.6-14.1-11-20.7-19.4s-10-15-10-19.8c-.1-1.8.8-3.6 2.3-4.5 14.2-7.4 40.3-16.7 78.4-27.9s61.6-16.8 70.4-16.8c7.4 0 15.3 5.8 23.5 17.4 8.3 11.6 12.4 20.8 12.4 27.7 0 1.1-.1 2.3-.2 3.4-.1.8-.3 1.7-.6 2.4a3.11 3.11 0 0 1-1.2 1.6c-.4.3-.8.6-1.2 1-.6.4-1.2.6-1.9.6l-1.8.2h-4.3c-16.8 0-43 5.6-78.5 16.8-4.6 15.5-10.7 38.2-18.4 68.2 18.1-6.9 28.1-10.4 30.1-10.5 4.6 0 11.6 5.3 21 16s14.2 18.9 14.2 24.8c0 2.6-1.4 4.2-4.3 4.9-21.6 4.8-46.7 13-75.4 24.4-7.7 33.1-13.3 61.2-16.8 84.4 24.5-11.5 49.5-22.3 75.2-32.6s45.7-17.8 60.2-22.6c14.7-5.2 22.8-7.6 24.6-7.6z"/><path d="M1424.2 51.8c17.8 18.1 26.8 38.8 26.8 61.9 0 28-9.4 62.1-28.2 102.4s-40.5 75.1-65 104.4-44.6 43.9-60.2 43.9c-17.1 0-35.5-4.9-55.3-14.6-8.2-4-14.3-9.1-18.2-15.4s-5.9-15.3-5.9-27.1c0-40.5 14.1-107 42.4-199.6-8.1-4.9-15.4-11-21.6-18.2-7-7.8-10.5-14-10.4-18.6 0-2.3 1.2-4.4 3.7-6.1 43.2-28.8 84.1-43.2 122.6-43.2 26.1.1 49.2 10.1 69.3 30.2zm-142 256.8c11.5-10.4 23.6-24.8 36.3-43.1 13.3-19.2 25.4-39.3 36.1-60.1a350.39 350.39 0 0 0 26.9-68.9c6.6-24.2 8.7-45.8 6.5-64.8-22.9-1.3-48.3 4.8-76 18.4 10.4 6.1 15.6 12.6 15.6 19.3 0 2.4-1.3 8.9-3.9 19.5-.3 1.3-3.8 14-10.6 38l-14.1 50.6c-2.5 9.7-5.7 23.9-9.4 42.5-3.3 16.1-5.8 32.3-7.4 48.6h0zm566.9-76.1c6.4 0 14 6.3 22.8 18.9s13.2 22.6 13.2 30c0 3.3-1.2 4.9-3.5 4.9-10.9 0-42.2 10.3-93.7 30.8s-89.2 38.8-113.2 54.8c-1.8 1.3-3.9 2-6.1 2-6.9 0-16.8-4.3-29.8-12.8s-19.4-15.6-19.4-21.2c0-11.2 5.3-42 15.8-92.4s22.9-99.4 36.9-147.1c-7.2-4.6-14.1-11-20.7-19.4s-10-15-10-19.8c-.1-1.8.8-3.6 2.3-4.5 14.2-7.4 40.3-16.7 78.4-27.9s61.6-16.8 70.4-16.8c7.4 0 15.3 5.8 23.5 17.4s12.4 20.8 12.4 27.7c0 1.1-.1 2.3-.2 3.4-.1.8-.3 1.7-.6 2.4a3.11 3.11 0 0 1-1.2 1.6c-.4.3-.8.6-1.2 1-.6.4-1.2.6-1.9.6l-1.8.2h-4.3c-16.8 0-43 5.6-78.5 16.8-4.6 15.5-10.7 38.2-18.4 68.2 18.1-6.9 28.1-10.4 30.1-10.5 4.6 0 11.6 5.3 21 16s14.2 18.9 14.2 24.8c0 2.6-1.4 4.2-4.3 4.9-21.6 4.8-46.7 13-75.4 24.4-7.7 33.1-13.3 61.2-16.8 84.4 24.5-11.5 49.5-22.3 75.2-32.6s45.7-17.8 60.2-22.6c14.7-5.2 22.8-7.6 24.6-7.6z"/><path d="M2056.1 51.8c17.8 18.1 26.8 38.7 26.8 61.9 0 28-9.4 62.1-28.2 102.4s-40.5 75.1-65 104.4c-24.6 29.3-44.6 43.9-60.2 43.9-17.1 0-35.5-4.9-55.3-14.6-8.2-4-14.3-9.1-18.2-15.4s-5.9-15.3-5.9-27.1c0-40.5 14.1-107 42.4-199.6-8.1-4.9-15.4-11-21.6-18.2-7-7.8-10.5-14-10.4-18.6 0-2.3 1.2-4.4 3.7-6.1 43.2-28.8 84.1-43.2 122.6-43.2 26.2.1 49.3 10.1 69.3 30.2zm-142 256.8c11.5-10.4 23.6-24.8 36.3-43.1 13.3-19.2 25.4-39.3 36.1-60.1a350.39 350.39 0 0 0 26.9-68.9c6.6-24.2 8.8-45.8 6.5-64.8-22.9-1.3-48.3 4.8-76 18.4 10.4 6.1 15.6 12.6 15.6 19.3 0 2.4-1.3 8.9-3.9 19.5-.3 1.3-3.8 14-10.6 38l-14.1 50.6c-2.5 9.7-5.7 23.9-9.4 42.5-3.2 16.1-5.7 32.3-7.4 48.6h0zm232.7 53.5c-10.4 0-21.4-2.5-33-7.4s-17.4-10.4-17.4-16.2c0-18.9 5.5-61.6 16.6-128.1s24.6-125.7 40.6-177.5c1-4 5.3-6 12.7-5.9 9.4 0 19.8 2.5 31.2 7.6s17.2 10.3 17.2 15.6c-.1 1.1-.4 2.1-.8 3.1-9.4 29.8-19.3 71.6-29.9 125.4-10.5 53.8-18.2 102.5-23.1 146.3 1.1 1 1.9 2.4 2.1 3.9 0 15-1 24.3-3 27.8s-6.3 5.4-13.2 5.4z"/><path d="M2457.5 2.2c5.6 0 12.7 6.8 21.4 20.4s13 23.6 13 30c0 6.9-3.6 10.3-10.9 10.3-2.4-.1-4.8-.9-6.7-2.3-2.4-1.6-4.1-2.3-5.2-2.3s-5.4.4-13.2 1.2c-7.7.8-19.6 2.4-35.4 4.8-15.9 2.4-31.5 5.2-46.9 8.3a1525.89 1525.89 0 0 0-45.2 172.3c-12 59.6-18.1 97.7-18.1 114.3a16.52 16.52 0 0 0 1.8 6.1c1.1 2.4 1.7 5 1.8 7.7 0 8.2-5.7 12.4-17.2 12.5-10.9 0-22.9-3.1-35.9-9.4s-19.5-12.6-19.5-19.1c0-13.3 6.2-48.5 18.6-105.6s25.6-110.1 39.8-159.1c-14.9 4.6-29.5 10.2-43.8 16.8-1.1.5-2.5 1.3-4.3 2.3-1.5.9-3.1 1.7-4.8 2.3-1.5.5-3.2.8-4.8.8-5.6 0-13.9-6-25-18s-16.6-20.3-16.6-24.8c0-3 1.8-5.4 5.5-7.2 18.9-9.4 63.6-22.1 134.3-38.2 70.5-16.1 109.6-24.2 117.3-24.1z"/><path d="M2463.8 362.1c-10.4 0-21.4-2.5-33-7.4s-17.4-10.4-17.4-16.2c0-18.9 5.5-61.6 16.6-128.1s24.6-125.7 40.6-177.5c1-4 5.3-6 12.7-5.9 9.4 0 19.8 2.5 31.2 7.6 11.5 5.1 17.2 10.3 17.2 15.6-.1 1.1-.4 2.1-.8 3.1-9.4 29.8-19.3 71.6-29.9 125.4s-18.2 102.6-23 146.3c1.1 1 1.9 2.4 2.1 3.9 0 15-1 24.3-3 27.8s-6.4 5.4-13.3 5.4zm200.3-333.6c26.2 0 48.9 9 68.2 27.1s28.9 41.5 28.9 70.1c0 23.2-3.4 48.4-10.4 75.8-6.6 26.4-15.7 52.1-27.4 76.8-11.3 23.8-25.4 43.8-42.2 59.8s-34.1 24-52 24c-16 0-31.8-5.4-47.3-16.2s-25.7-23.7-30.5-38.7c-4-12-6-27.8-5.9-47.5 0-30.3 4.3-63.7 12.8-100.2s16.1-59.6 22.8-69.5c1.6-2.6 4.9-3.9 10-3.9 4.4.2 8.7.8 12.9 2 4.8-15.6 13.1-29.9 24.2-41.8 11.3-11.8 23.2-17.8 35.9-17.8zm17.6 171.3c9.9-34.1 14.8-66.4 14.8-96.9 0-13-1.1-23.4-3.3-31.2-10.1 6.7-18.7 16.8-25.8 30.4s-10.6 26.2-10.6 38c0 1.9.2 3.7.4 5.6.3 2.2.4 3.6.4 4.2 0 3-2.5 4.4-7.6 4.3-4.8 0-11.2-1.3-19.1-3.9-14.7 50.9-22.1 93.2-22.1 126.8 0 18.6 1.9 32.5 5.7 41.6 28.3-20.8 50.7-60.4 67.2-118.9zM2828 371.3c-10.2 0-20.9-2.7-32.2-8.2s-17-11.1-17-17c0-25.1 7.7-73.1 23.1-143.9s30-129.1 43.8-174.9c1-3.2 4.9-4.9 11.7-4.9 8.8 0 18.7 2.4 29.6 7.2s16.7 9.8 17.5 14.8c9.9 67.4 21.5 123.2 34.8 167.2 8.6-46.9 17.5-90.6 26.9-131.1s15.7-64.9 19.2-72.9c1.6-3.8 5.3-5.6 11.1-5.5 9.4 0 20.7 3.6 34.1 10.7 13.4 7.2 20 13.5 20 19.1 0 1.1-.3 2.2-.8 3.2-.6 1.3-1.5 2.4-2.4 3.4-.8.8-1.5 1.7-2.1 2.7-10.4 18.4-24 65-40.6 139.8-16.7 74.8-26.7 129.5-30.1 164.2-.3 3.8-4.7 5.7-13.3 5.7-8.9 0-18.5-2-28.8-6-10.4-4-16.6-8.9-18.8-14.5-3.5-8.6-10.4-33.3-20.6-74l-21.8-92.8c-5.6 21.6-11.8 52.1-18.8 91.6-6.9 39.5-10.4 69.6-10.4 90.4 0 3.9.2 7.8.8 11.6l.8 6c0 2.1-1.4 3.9-4.2 5.6-2.9 1.8-6.7 2.6-11.5 2.5z"/></g><g fill="#be362f"><path d="M3340.6 321.9c-63.8-63.3-139.9-116.1-192.8-189.6-12.7-17.6-24-36.4-32.8-56.2-2.1-4.2-3.7-8.7-4.9-13.2l8-16.5c6.2-4.6 18.1 2.4 23.2 5.5 10.3 6.2 19.7 14.6 28.7 22.6 37.4 33.1 67.4 73.3 93.5 115.7 3.7 6.1 14.6 4 14.1-3.8-2.5-37.6 7-74.9 27.3-106.6 10.3-16.2 23.2-30.6 38.3-42.6 6.6-5.2 14.6-11.8 22.5-14.7 7.5-2.7 16.9-3.8 20 4.5 1.4 3.6.9 9.1.8 12.9-1 46.8-8.4 94.2-17.7 140-4.3 21.5-9.4 42.8-15.2 64-5.9 21.7-23.3 60.3-25.6 82.7-.8 7.7 10.4 9.7 13.9 3.8 14.5-24 29.1-71.4 35.4-98.6 6.8-29.2 12.3-58.6 16.4-88.3 3.7-26.5 6.3-53.1 7.9-79.7 1-16.7 5.8-43.6-9.2-56.4-15.6-13.3-36.9 2.7-50 12-16.2 11.5-30.5 25.5-42.4 41.3-26.9 35.9-40.8 80.8-37.6 125.6l14.1-3.8c-24.1-38.8-51.5-75.9-84.7-107.4-18.6-17.6-61.2-62.3-88.6-35.4-13.2 12.9-5.4 31.4 1.1 45.6 9.2 19.7 20.2 38.5 33.1 56 24.2 33.4 53.3 62.9 83.6 90.8 36.3 33.6 74.4 65.3 109.4 100.3 6.5 6.6 17-3.9 10.2-10.5h0z" stroke="#be362f" stroke-width="9" stroke-miterlimit="10"/><path d="M3122.8 38.8c-6.5 1.5-16.5 12.8-18.4 19.2-2.1 7.2 34.2 94.3 111 157.8s119.4 108.5 119.4 108.5 37.6-94.3 48.4-168.7 16.2-122.1 2.2-134.5c-14-12.3-41.4.9-61.5 21.8-11.9 12.4-30.9 40.1-41.7 72.6-9.1 27.3-12.5 71.8-12.5 71.8s-50.1-69.4-70.1-93.5c-32.5-39.2-53.8-60.5-76.8-55z"/></g></svg>';
  }

  if (icon_id == "badge-limited-clover") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 3442.32 541.31"><path d="M1889.74,510c-42.2,2.9-83.75,6.12-125.62,9-32.54,2.58-65.39,4.51-97.93,7.73-39,2.9-78,6.44-116.6,10-18.68,1.61-38,2.9-56.69,4.51-14.17,1-20.94-5.48-21.9-20.94a138.12,138.12,0,0,1,0-23.19c.64-12.24,7.73-20.94,18.68-24.48,14.82-4.51,30-8.06,45.09-9,48.32-3.55,96.31-6.12,144.63-8.7,30-1.61,59.91-3.54,89.87-5.48,40.59-2.57,81.49-5.47,122.08-8.05,15.78-1,30.92-1.93,46.71-1.93,25.44.64,42.51,21.9,29,47.67-9,16.75-19.64,26.41-39.94,24.48-12.24-1.61-24.48,0-36.39,0C1889.74,510.29,1889.74,510,1889.74,510Z" style="fill:#00764b"/><path d="M63.55,374q-12.9,0-31.06-12.79T14.33,340.83c0-.78.58-2.12,1.76-4a15.24,15.24,0,0,0,2.14-6.54A1407.56,1407.56,0,0,1,92.65,22.86q1.95-5.28,8-5.28,13.66,0,33.88,9.57t20.22,17.58c0,1.05-.59,3.06-1.76,6.06Q104.18,181.26,85,305.08q30.47-12.88,72.46-26.17t48.83-13.28q10.35,0,24.12,18.95t13.77,28.51c0,1.83-.52,2.93-1.56,3.32q-16.8,6.45-22.07,7.23a8.25,8.25,0,0,1-5.86-1.76q-26.37,5.67-70,20.9T75.85,370.71A26.15,26.15,0,0,1,63.55,374Z" style="fill:#00764b"/><path d="M274.87,360q-15.63,0-33-7.42t-17.38-16.22q0-28.31,16.6-128.12T281.7,30.67q1.56-6,12.7-5.86,14.06,0,31.25,7.62t17.19,15.62a13.32,13.32,0,0,1-.78,3.13Q328,95.91,312.17,176.57t-23,146.29a6.57,6.57,0,0,1,2.14,3.9q0,22.47-3,27.84T274.87,360Z" style="fill:#00764b"/><path d="M588.73,382.43a86,86,0,0,1-29.59-5.08q-14-5.09-14-13.48,0-25.58,6.06-89.55T564.9,163.48Q528.18,225.4,504,283.21q-3.12,7.23-16.31,7.23a81,81,0,0,1-25-3.81q-11.82-3.81-11.81-10.26V141.22q-19.92,53.5-34.77,118.94t-14.84,87.5q0,7.23-14.46,7a96.56,96.56,0,0,1-31.44-5.56q-16.21-5.56-16.21-16.31,0-33.21,33.88-141.6T441.66,13.48q3.12-6.83,14.84-6.64a85,85,0,0,1,30.37,5.76Q502,18.38,502,26c0,.27-.2,2.8-.59,7.62s-.85,11.43-1.36,19.82-1,18.2-1.37,29.4-.52,25.07-.39,41.6.58,33.59,1.36,51.17q21.3-40,50.79-85.64T594,27.15a12.63,12.63,0,0,1,10.74-5.27q13.68,0,29.3,6.25t15.62,13.09a23.45,23.45,0,0,1-.78,3.9q-16.39,66-28.81,162.8t-12.4,165.72Q607.47,382.43,588.73,382.43Z" style="fill:#00764b"/><path d="M715.87,360q-15.63,0-33-7.42t-17.38-16.22q0-28.31,16.6-128.12T722.7,30.67q1.56-6,12.7-5.86,14.05,0,31.25,7.62t17.19,15.62a13.32,13.32,0,0,1-.78,3.13Q769,95.91,753.17,176.57t-23,146.29a6.57,6.57,0,0,1,2.14,3.9q0,22.47-3,27.84T715.87,360Z" style="fill:#00764b"/><path d="M1026.6,0Q1035,0,1048,20.42t13,30q0,10.35-10.94,10.35a12.53,12.53,0,0,1-6.74-2.35q-3.61-2.34-5.17-2.34t-13.19,1.17Q1013.32,58.4,989.49,62t-46.87,8.3A1515,1515,0,0,0,897.4,242.58Q879.34,332,879.34,356.84a15.68,15.68,0,0,0,1.75,6.15,18.14,18.14,0,0,1,1.76,7.72q0,12.3-17.19,12.5-16.39,0-35.93-9.38T810.2,354.69q0-19.92,18.55-105.56T868.59,90.05a365,365,0,0,0-43.75,16.79q-1.56.78-4.29,2.35a35.47,35.47,0,0,1-4.79,2.34,13.38,13.38,0,0,1-4.78.78q-8.4,0-25-18t-16.6-24.8c0-3,1.82-5.4,5.46-7.23q28.32-14.06,134.28-38.18T1026.6,0Z" style="fill:#00764b"/><path d="M1223.27,230.28q9.57,0,22.76,18.85t13.18,30q0,4.88-3.51,4.88-16.41,0-93.66,30.76t-113.18,54.79a10.2,10.2,0,0,1-6,1.95q-10.36,0-29.79-12.79t-19.43-21.19q0-16.8,15.82-92.39t36.91-147.07q-10.74-6.83-20.7-19.43t-10-19.82a4.81,4.81,0,0,1,2.34-4.5q21.29-11.13,78.42-27.93t70.41-16.79q11.13,0,23.53,17.38t12.41,27.73a26,26,0,0,1-.2,3.42,10.26,10.26,0,0,1-.59,2.44,3.52,3.52,0,0,1-1.17,1.57,11.47,11.47,0,0,0-1.17,1,3.55,3.55,0,0,1-1.85.59c-1,.13-1.6.19-1.86.19h-4.3q-25.19,0-78.51,16.8-6.84,23.25-18.36,68.16,27.15-10.35,30.08-10.54,6.83,0,21,16T1160,179.11q0,3.9-4.29,4.88-32.43,7.23-75.39,24.41-11.54,49.62-16.8,84.38,36.72-17.19,75.19-32.62t60.16-22.65Q1220.53,230.28,1223.27,230.28Z" style="fill:#00764b"/><path d="M1430.3,49.62q26.75,27.15,26.76,61.91,0,42-28.23,102.44t-65,104.4q-36.81,43.94-60.25,43.94-25.59,0-55.27-14.65-12.32-6-18.17-15.43t-5.86-27.15q0-60.74,42.39-199.6A89.35,89.35,0,0,1,1245,87.31q-10.44-11.72-10.45-18.55,0-3.53,3.72-6.06Q1303.14,19.55,1361,19.54,1400.22,19.54,1430.3,49.62Zm-142,256.83q17.18-15.61,36.32-43.06a546.38,546.38,0,0,0,36.14-60.06,343.87,343.87,0,0,0,26.85-69q9.86-36.33,6.54-64.84-34.37-2-76,18.36,15.61,9.18,15.62,19.33,0,3.52-3.9,19.53-.4,2-10.65,38t-14.06,50.59q-3.81,14.55-9.38,42.48A487.61,487.61,0,0,0,1288.31,306.45Z" style="fill:#00764b"/><path d="M1855.28,230.28q9.57,0,22.76,18.85t13.18,30q0,4.88-3.52,4.88-16.4,0-93.65,30.76t-113.18,54.79a10.21,10.21,0,0,1-6.06,1.95q-10.35,0-29.78-12.79t-19.44-21.19q0-16.8,15.82-92.39t36.92-147.07q-10.74-6.83-20.7-19.43t-10-19.82a4.82,4.82,0,0,1,2.35-4.5q21.29-11.13,78.42-27.93t70.41-16.79q11.13,0,23.53,17.38t12.4,27.73a26.2,26.2,0,0,1-.19,3.42,10.26,10.26,0,0,1-.59,2.44,3.52,3.52,0,0,1-1.17,1.57,11.47,11.47,0,0,0-1.17,1,3.56,3.56,0,0,1-1.86.59c-1,.13-1.59.19-1.85.19h-4.3q-25.2,0-78.51,16.8-6.84,23.25-18.36,68.16,27.13-10.35,30.07-10.54,6.84,0,21,16T1792,179.11q0,3.9-4.3,4.88-32.42,7.23-75.39,24.41-11.52,49.62-16.79,84.38,36.7-17.19,75.19-32.62t60.16-22.65Q1852.55,230.28,1855.28,230.28Z" style="fill:#00764b"/><path d="M2062.31,49.62q26.74,27.15,26.75,61.91,0,42-28.22,102.44t-65,104.4q-36.81,43.94-60.25,43.94-25.59,0-55.28-14.65-12.3-6-18.16-15.43t-5.86-27.15q0-60.74,42.38-199.6a89.5,89.5,0,0,1-21.58-18.17q-10.46-11.72-10.45-18.55,0-3.53,3.71-6.06Q1935.16,19.55,1993,19.54,2032.23,19.54,2062.31,49.62Zm-142,256.83q17.19-15.61,36.33-43.06a544.8,544.8,0,0,0,36.13-60.06,343.9,343.9,0,0,0,26.86-69q9.86-36.33,6.54-64.84-34.38-2-76,18.36,15.61,9.18,15.62,19.33,0,3.52-3.91,19.53-.39,2-10.64,38t-14.06,50.59q-3.81,14.55-9.38,42.48A488,488,0,0,0,1920.31,306.45Z" style="fill:#00764b"/><path d="M2152.92,360q-15.63,0-33-7.42t-17.38-16.22q0-28.31,16.6-128.12t40.63-177.54q1.56-6,12.69-5.86,14.07,0,31.25,7.62t17.19,15.62a12.8,12.8,0,0,1-.78,3.13Q2206,95.91,2190.23,176.57t-23.05,146.29a6.59,6.59,0,0,1,2.15,3.9q0,22.47-3,27.84T2152.92,360Z" style="fill:#00764b"/><path d="M2463.66,0Q2472,0,2485,20.42t13,30q0,10.35-10.94,10.35a12.47,12.47,0,0,1-6.73-2.35c-2.42-1.56-4.14-2.34-5.18-2.34s-5.44.39-13.18,1.17-19.57,2.38-35.45,4.79-31.52,5.17-46.88,8.3a1515,1515,0,0,0-45.21,172.26q-18.08,89.46-18.07,114.26a15.72,15.72,0,0,0,1.76,6.15,18.28,18.28,0,0,1,1.76,7.72q0,12.3-17.19,12.5-16.41,0-35.94-9.38t-19.53-19.14q0-19.92,18.56-105.56t39.84-159.08a364.31,364.31,0,0,0-43.75,16.79c-1,.52-2.48,1.3-4.3,2.35a35.42,35.42,0,0,1-4.78,2.34,13.48,13.48,0,0,1-4.79.78q-8.4,0-25-18t-16.6-24.8c0-3,1.83-5.4,5.47-7.23q28.32-14.06,134.28-38.18T2463.66,0Z" style="fill:#00764b"/><path d="M2469.9,360q-15.63,0-33-7.42t-17.38-16.22q0-28.31,16.6-128.12t40.62-177.54q1.58-6,12.7-5.86,14.07,0,31.25,7.62t17.19,15.62a12.8,12.8,0,0,1-.78,3.13Q2523,95.91,2507.2,176.57t-23,146.29a6.64,6.64,0,0,1,2.15,3.9q0,22.47-3,27.84T2469.9,360Z" style="fill:#00764b"/><path d="M2670.28,26.37q39.25,0,68.17,27.15t28.9,70.12q0,34.77-10.35,75.78a415.23,415.23,0,0,1-27.34,76.76q-17,35.74-42.19,59.76t-51.95,24q-24,0-47.27-16.21t-30.47-38.68q-6.06-18-5.86-47.46,0-45.49,12.8-100.19t22.75-69.53q2.34-3.91,10-3.91a57.44,57.44,0,0,1,12.89,2,108.35,108.35,0,0,1,24.22-41.79Q2651.15,26.37,2670.28,26.37Zm17.58,171.29q14.83-51.16,14.84-96.87,0-19.53-3.32-31.25-15.23,10-25.78,30.37t-10.54,38a45.15,45.15,0,0,0,.39,5.56q.39,3.22.39,4.2,0,4.5-7.62,4.3-7.23,0-19.14-3.91Q2615,224.43,2615,274.81q0,27.93,5.66,41.6Q2663.06,285.36,2687.86,197.66Z" style="fill:#00764b"/><path d="M2834.14,369.15q-15.24,0-32.23-8.21t-17-17q0-37.69,23-143.85t43.75-174.9q1.56-4.87,11.72-4.88,13.28,0,29.59,7.23t17.48,14.84q14.84,101.18,34.76,167.19,12.9-70.32,26.86-131.16t19.24-72.94Q2993.71-.19,3002.5,0q14.07,0,34.08,10.74t20,19.14a7.53,7.53,0,0,1-.78,3.22,13.47,13.47,0,0,1-2.44,3.42,10.21,10.21,0,0,0-2.05,2.73Q3035.7,66.8,3010.7,179t-30.07,164.16q-.4,5.67-13.29,5.66-13.28,0-28.8-6.05t-18.85-14.45q-5.28-12.9-20.61-74t-21.77-92.77q-8.4,32.41-18.75,91.6t-10.36,90.43a78.42,78.42,0,0,0,.78,11.62c.52,3.45.79,5.44.79,6q0,3.12-4.2,5.57T2834.14,369.15Z" style="fill:#00764b"/><path d="M3271,157c-25.81-28-67.43-76-113.12-76.27-46.78-.25-62.87,58.41-12.8,75.59-50.25,16.65-34.79,75.48,12,75.73C3202.71,232.32,3244.85,184.72,3271,157Z" style="fill:#00764b"/><path d="M3271,157c-28,25.81-76,67.43-76.27,113.12-.25,46.78,58.41,62.87,75.59,12.8,16.65,50.25,75.48,34.79,75.73-12C3346.25,225.28,3298.66,183.14,3271,157Z" style="fill:#00764b"/><path d="M3271,157c25.81,28,67.44,76,113.12,76.27,46.79.25,62.87-58.41,12.81-75.59,50.24-16.65,34.78-75.48-12-75.73C3339.21,81.73,3297.07,129.33,3271,157Z" style="fill:#00764b"/><path d="M3271,157c28-25.81,76-67.44,76.27-113.12.25-46.79-58.41-62.87-75.59-12.81-16.65-50.24-75.48-34.78-75.73,12C3195.67,88.78,3243.26,130.92,3271,157Z" style="fill:#00764b"/><path d="M3286.77,151.79a377.15,377.15,0,0,0-39,21.75A318.23,318.23,0,0,0,3212.17,200a295.34,295.34,0,0,0-29.69,29.3,289.16,289.16,0,0,0-22.89,29.79,303.15,303.15,0,0,0-16.18,27.46c-1,2.13-2.08,4.19-3,6.18s-2,3.91-2.76,5.8-1.64,3.68-2.41,5.39-1.51,3.36-2.12,4.95c-1.27,3.17-2.4,6-3.39,8.46s-1.66,4.61-2.28,6.34c-1.22,3.45-1.88,5.28-1.88,5.28A13.52,13.52,0,0,0,3151,338c.08-.23.16-.45.23-.68l.14-.5s.51-1.71,1.45-4.92c.47-1.6,1.06-3.58,1.75-5.9l2.65-7.89c.48-1.5,1.07-3,1.68-4.64l1.92-5.05c.64-1.78,1.42-3.57,2.22-5.44s1.62-3.81,2.47-5.81a279.73,279.73,0,0,1,13.4-26,267,267,0,0,1,19.55-28.66,277.34,277.34,0,0,1,26.13-28.87,302.74,302.74,0,0,1,32.2-26.88c9.51-6.88,19.64-13.24,30-19.27V151.79Z" style="fill:#00764b"/></svg>';
  }

  if (icon_id == "badge-be-kind") {
    returnBadge =
      '<svg class="' +
      icon_id +
      " icon icon--" +
      icon_id +
      '" xmlns="http://www.w3.org/2000/svg" width="45" height="45" fill="#22295b" xmlns:v="https://vecta.io/nano"><path d="M21.588 24.775V35.5H19.4V20.463c.038 0 .075-.012.113-.012h2.775c.1 0 .125.038.15.125l.375 1.4.475 1.837.5 1.9.475 1.813.262.938.188.788c.013.038.025.087.05.125v-8.913H26.9v15.025h-2.462l-2.863-10.725c.025.012.012.012.012.012zm-15.5-6.162V3.575c.038 0 .075-.013.113-.013h3.937c.188 0 .375.063.563.087.363.038.688.163 1.013.325a2.44 2.44 0 0 1 1.15 1.275 3.51 3.51 0 0 1 .262 1.125l.037 1.4c-.012.387-.05.787-.162 1.162-.15.488-.375.938-.775 1.275-.175.137-.362.25-.537.362l.6.363c.375.262.625.637.813 1.063.162.338.2.713.25 1.075.088.725.037 1.463.037 2.188 0 .275-.075.55-.1.825a2.16 2.16 0 0 1-.187.688 3.38 3.38 0 0 1-.425.7c-.463.6-1.088.862-1.8 1.025-.412.1-.838.113-1.262.113H6.238h-.15zm2.388-2.225h.05 1.438c.212 0 .412-.087.587-.2.162-.113.25-.287.3-.475.088-.263.113-.537.113-.812v-1.238c0-.312-.037-.637-.113-.937-.062-.262-.187-.487-.412-.637a1.47 1.47 0 0 0-.825-.225H8.575h-.113l.013 4.525zm0-10.637v3.9h.575l.713-.025c.387-.05.65-.287.812-.637.125-.263.15-.55.163-.838v-.863c-.013-.312-.038-.612-.15-.9a.88.88 0 0 0-.6-.55c-.5-.15-1-.038-1.512-.088zM28.588 20.45h.138 3.925a3.52 3.52 0 0 1 1.75.488c.275.163.5.375.712.613a2.79 2.79 0 0 1 .588 1.188c.075.313.112.637.162.95a3.35 3.35 0 0 1 .025.5v7.85c0 .637-.138 1.262-.425 1.85-.288.575-.712.975-1.275 1.262-.325.163-.675.25-1.038.288l-1.237.063h-3.175-.137l-.013-15.05zM31 22.65V33.3c.025 0 .038.013.05.013l1.463-.025c.337-.013.6-.187.762-.488a1.66 1.66 0 0 0 .2-.812V24.05a2.1 2.1 0 0 0-.062-.562c-.138-.512-.388-.738-.875-.812-.3-.038-.613-.025-.913-.025H31zM6.088 20.463h2.375v6.388h.012l.425-.888.4-.85.462-1.012.588-1.263.4-.812.412-.912c.063-.15.138-.288.213-.437.012-.012.012-.025.025-.038.025-.2.15-.2.313-.187h2.012.162l-.137.338-.363.725-.625 1.262-.737 1.5-.588 1.2-.55 1.112-.25.525c-.012.037-.012.1 0 .137l.688 1.738 1.275 3.225 1.088 2.75.162.425c.025.075.013.1-.062.1h-2.325c-.013 0-.013 0-.05-.012L9.138 29.55l-.225.438-.4.725c-.05.088-.062.163-.062.25v3.013 1.362.138H6.063l.025-15.013zM17.163 9.875H20.4c0 .037.013.075.013.113v1.975c0 .1-.038.125-.138.125h-2.962-.15V16.4h4.063v2.213H14.75V3.575h6.475v2.188h-4.062v4.113zm-1.8 10.588h2.4V35.5h-2.4V20.463zm6.412 19.762v.4h-.587v-3.337h.587v.975c.15-.1.275-.225.425-.3.375-.2.975-.125 1.325.212.213.213.363.438.425.738.075.413.05.837-.187 1.188-.287.413-.662.675-1.275.575-.262-.037-.463-.175-.637-.375-.013-.037-.038-.05-.075-.075zm1.613-.975l-.087-.375c-.113-.3-.512-.575-.887-.475-.35.1-.525.337-.6.675-.05.237-.012.45.113.65s.275.375.525.375c.15 0 .313.012.438-.05.313-.15.475-.437.5-.8zm13.362-3.737v-2.175h2.163v2.175H36.75zm-8.125 3.962c.025.25.113.462.325.575.175.088.375.113.575.063.175-.037.288-.137.388-.287.012-.025.037-.062.063-.062h.587c.025.137-.038.237-.1.313-.2.275-.45.487-.787.55-.562.112-1.062 0-1.437-.475-.175-.225-.238-.475-.262-.75-.038-.337.025-.675.188-.975a1.24 1.24 0 0 1 .3-.325c.475-.363 1.238-.363 1.7 0a1.08 1.08 0 0 1 .45.762c.025.163.012.338.025.5 0 .088-.05.1-.125.1h-1.787c-.013.013-.05.013-.1.013zm0-.45h1.4c-.012-.25-.112-.437-.325-.55a.73.73 0 0 0-.75 0c-.2.125-.262.325-.325.55zm7.325.45h-2.013c0 .15.063.262.125.375.112.25.487.3.688.275a.57.57 0 0 0 .487-.325c.013-.012.038-.037.063-.037h.588c.012.137-.05.237-.125.337a1.36 1.36 0 0 1-.588.475c-.237.1-.487.112-.75.087-.275-.038-.512-.138-.725-.325s-.325-.425-.375-.687c-.062-.4-.062-.788.137-1.163a1.2 1.2 0 0 1 .6-.537c.4-.163.813-.163 1.2.025.225.112.425.275.55.5a1.49 1.49 0 0 1 .125.4c.063.2.075.4.013.6zm-.613-.45c.013-.325-.225-.612-.637-.65-.363-.038-.65.163-.75.65h1.387zm1.676 1.6h-.588V37.9h.588v.337c.138-.187.287-.3.487-.35.45-.113.9-.013 1.213.387a.99.99 0 0 1 .2.6v1.688c0 .013 0 .025-.012.063h-.562c-.025 0-.05-.075-.05-.125v-1.513c0-.225-.1-.387-.288-.5a.68.68 0 0 0-.8.075c-.137.138-.187.337-.187.525V40.5v.125zm-12.3.838l.175-.387.175-.375a.28.28 0 0 0 .012-.263l-.437-1.05-.562-1.413c-.012-.025-.012-.038-.012-.075h.65c.013 0 .038.038.05.063l.425 1.087.3.8.175-.413.4-1.062.163-.4c.012-.025.037-.05.05-.05h.613l-.238.55-.45 1.075-.4.913-.413.95c-.012.038-.075.063-.113.063l-.562-.013zm7.587-4.175h.6v3.337h-.6v-3.337zm-.612 3.337H31.1v-3.337h.587v3.337z"/></svg>';
  }

  return returnBadge;
}

$(document).ready(function () {
  // Navigation
  var navFixed = false;
  $(window).on("scroll", function () {
    var y_scroll_pos = window.pageYOffset;
    var scroll_pos_test = 0;
    if (y_scroll_pos > scroll_pos_test) {
      if (navFixed == false) {
        //$('#main-fixed').hide();
        $("#main-fixed").addClass("sticky");
        //$('#main-fixed').slideDown();
        navFixed = true;
      }
    } else {
      $("#main-fixed").removeClass("sticky");
      navFixed = false;
    }
  });
  // Footer
  var $accordion = $("[data-accordion-parent]");
  var allItems = $("[data-accordion-parent]");
  $accordion.on("click", "[data-accordion-trigger]", function () {
    if (
      $(this).parent().closest("[data-accordion-parent]").hasClass("is-open")
    ) {
      $(".is-open").removeClass("is-open");
    } else {
      $(".is-open").removeClass("is-open");
      $(this).parent().closest("[data-accordion-parent]").addClass("is-open");
    }
    return false;
  });

  // CART
  $(document).ready(function () {
    if (Geolocation.isLocalizationAvailable && Geolocation.getExperience()) {
      // Redirect on checkout button clicks
      $("body").on(
        "click",
        ".cc-checkout-button, .real-checkout-button a, .real-next-step a",
        function (event) {
          event.preventDefault();
          Geolocation.redirectToCheckout();
        }
      );

      // Get Geolocation Compare Prices
      var extraGeolocationData = [];
      $("[cc-compare-geolocation]").each(function () {
        extraGeolocationData.push($(this).attr("cc-compare-geolocation"));
      });

      if (extraGeolocationData.length > 0) {
        Geolocation.variants.load({
          variants: extraGeolocationData, // List of variant ids to load
          experience: Geolocation.getExperience(), // Limits results by Geolocation experience key
          success: function (status, variants) {
            var compareGeolocationData = variants;

            $("[cc-compare-geolocation]").each(function () {
              var idCheck = $(this).attr("cc-compare-geolocation");
              var attrCheck = $(this).attr("cc-compare");

              if (
                compareGeolocationData[idCheck].prices.item.currency == "AUD"
              ) {
                if (
                  compareGeolocationData[idCheck].prices.item.includes.key ==
                  "vat_and_duty"
                ) {
                  $(this)
                    .closest(".product-form")
                    .find(".cc-price-wrap")
                    .append(
                      '<p class="product-duties">Taxes & Duties included.</p>'
                    );
                } else {
                  $(this)
                    .closest(".product-form")
                    .find(".cc-price-wrap")
                    .append(
                      '<p class="product-duties">Taxes calculated at checkout. Duties included.</p>'
                    );
                }
              }

              if (compareGeolocationData[idCheck].status == "excluded") {
                $(this).closest(".product-item, .collection-item").remove();
                $(this)
                  .after("<p>This product is unavailable in your region.</p>")
                  .remove();
              } else {
                var geolocationCompareLabel = false;

                if (
                  typeof attrCheck !== typeof undefined &&
                  attrCheck !== false &&
                  attrCheck != 0
                ) {
                  $(this).attr(
                    "cc-compare",
                    compareGeolocationData[idCheck].prices.compare_at.cents
                  );
                  geolocationCompareLabel = true;
                }

                var checkItemVariants = $(this)
                  .closest(".product-item")
                  .find("[data-variant-swatches]");

                if (checkItemVariants.length > 0) {
                  var newId = checkItemVariants
                    .find("[data-product-variant]")
                    .attr("data-product-variant");
                  $(this)
                    .closest(".product-item")
                    .find(".product-price__main")
                    .attr(
                      "geolocation-swatch-price",
                      compareGeolocationData[newId].prices.item.label
                    );
                  $(this)
                    .closest(".product-item")
                    .find(".product-price__main")
                    .html(
                      "<span>" +
                        compareGeolocationData[newId].prices.item.label +
                        "</span>"
                    );

                  if (geolocationCompareLabel) {
                    $(this)
                      .closest(".product-item")
                      .find(".product-price__compare")
                      .attr(
                        "geolocation-swatch-compare-price",
                        compareGeolocationData[newId].prices.compare_at.label
                      );
                    $(this)
                      .closest(".product-item")
                      .find(".product-price__compare")
                      .html(
                        "<span>" +
                          compareGeolocationData[newId].prices.compare_at
                            .label +
                          "</span>"
                      );
                  }

                  var mainItem = $(this).closest(".product-item");

                  $(".variant-swatch", mainItem).on("click", function () {
                    var updatePrice = $(this)
                      .closest(".product-item")
                      .find(".product-price__main");
                    var updatePriceCompare = $(this)
                      .closest(".product-item")
                      .find(".product-price__compare");

                    updatePrice.css("visibility", "hidden");
                    updatePriceCompare.css("visibility", "hidden");

                    window.setTimeout(function () {
                      $(updatePrice, "span").html(
                        updatePrice.attr("geolocation-swatch-price")
                      );
                      $(updatePriceCompare, "span").html(
                        updatePriceCompare.attr(
                          "geolocation-swatch-compare-price"
                        )
                      );
                      updatePrice.css("visibility", "visible");
                      updatePriceCompare.css("visibility", "visible");
                    }, 200);
                  });
                }

                var checkItemVariantsPDP = $(this)
                  .closest(".product-form")
                  .find("[data-variant-swatches]");

                if (checkItemVariantsPDP.length > 0) {
                  var newId = checkItemVariantsPDP
                    .find("[data-product-variant]")
                    .attr("data-product-variant");
                  $(this)
                    .closest(".product-form")
                    .find(".product-price__main")
                    .attr(
                      "geolocation-swatch-price",
                      compareGeolocationData[newId].prices.item.label
                    );
                  $(this)
                    .closest(".product-form")
                    .find(".product-price__main")
                    .html(
                      "<span>" +
                        compareGeolocationData[newId].prices.item.label +
                        "</span>"
                    );

                  if (geolocationCompareLabel) {
                    $(this)
                      .closest(".product-form")
                      .find(".product-price__compare")
                      .attr(
                        "geolocation-swatch-compare-price",
                        compareGeolocationData[newId].prices.compare_at.label
                      );
                    $(this)
                      .closest(".product-form")
                      .find(".product-price__compare")
                      .html(
                        "<span>" +
                          compareGeolocationData[newId].prices.compare_at
                            .label +
                          "</span>"
                      );
                  }

                  var mainItem = $(this).closest(".product-form");

                  $(".variant-swatch", mainItem).on("click", function () {
                    var updatePricePDP = $(this)
                      .closest(".product-form")
                      .find(".product-price__main");
                    var updatePriceComparePDP = $(this)
                      .closest(".product-form")
                      .find(".product-price__compare");

                    updatePricePDP.css("visibility", "hidden");
                    updatePriceComparePDP.css("visibility", "hidden");

                    window.setTimeout(function () {
                      $(updatePricePDP, "span").html(
                        updatePricePDP.attr("geolocation-swatch-price")
                      );
                      $(updatePriceComparePDP, "span").html(
                        updatePriceComparePDP.attr(
                          "geolocation-swatch-compare-price"
                        )
                      );
                      updatePricePDP.css("visibility", "visible");
                      updatePriceComparePDP.css("visibility", "visible");
                    }, 200);
                  });
                }
              }
            });
          },
          error: function (error) {
            console.log(error instanceof Error); //=> true
          },
        });
      }

      getFullGeolocationCart();
    } else {
      getFullCart();
    }
  });

  $("[data-search-trigger]").on("click", function (e) {
    e.preventDefault();
    $("#search-bar-d").slideToggle();
    $("#search-input").get(0).focus();
  });

  $(".snize-custom-widget-opener").on("click", function () {
    $(window).scrollTop(0);
  });

  $("[data-mini-cart-trigger]").click(function (e) {
    e.preventDefault();
  });

  $("#cc-cartItem").on("click", ".delete-button", function () {
    removeFromCart($(this).attr("cc-id"), 0);
  });
  $("#cc-cartItem").on("click", ".item-dec", function () {
    var quantSelector = $(this).siblings("input");
    var currentQuant = quantSelector.val();
    removeFromCart($(this).attr("cc-id"), currentQuant - 1);
    quantSelector.val(currentQuant - 1);
  });

  $("#cc-cartItem").on("click", ".item-inc", function () {
    var quantSelector = $(this).siblings("input");
    var currentQuant = parseInt(quantSelector.val());
    removeFromCart($(this).attr("cc-id"), currentQuant + 1);
    quantSelector.val(currentQuant + 1);
  });

  $("#cc-cartItem").on("blur", "input", function () {
    var currentQuant = parseInt($(this).val());
    removeFromCart($(this).siblings(".item-dec").attr("cc-id"), currentQuant);
  });

  $("body").on("click", "[data-atc]", function (event) {
    
    event.preventDefault();

    var compareP = null;
    if ($(this).attr("cc-compare")) {
      compareP = $(this).attr("cc-compare");
    }
    var vForm = $(this).closest("form");
    var formArray = vForm.serializeArray();
    var formData = {};
    for (var i = 0; i < formArray.length; i++) {
      formData[formArray[i]["name"]] = formArray[i]["value"];
    }
    var vId = formData.id;
    var lineItemColor = formData.item_frame;
    var recId = vForm.attr("id");
    var isPreOrder = false;
    if (formData.pre_order) {
      isPreOrder = formData.pre_order_target;
    }
    if (recId.indexOf("product_form_items_") !== -1) {
      recId = recId.replace("product_form_items_", "");
    } else if (recId.indexOf("collection_product_form_") !== -1) {
      recId = recId.replace("collection_product_form_", "");
    } else if (recId.indexOf("product_form_") !== -1) {
      recId = recId.replace("product_form_", "");
    } else {
      recId = null;
    }
    var openACart = true;
    if ($(this).closest("#cc-cart-bestsellers").length > 0) {
      openACart = false;
    }
    addToCart(
      vId,
      lineItemColor,
      openACart,
      recId,
      compareP,
      false,
      null,
      isPreOrder,
      vForm
    );
  });

  $("#cc-cart-trending").on("click", "[cc-trending]", function (event) {
    event.preventDefault();
    $(this).addClass("button--processing");
    var compareP = null;
    if ($(this).attr("cc-compare") > 0) {
      compareP = $(this).attr("cc-compare");
    }
    var vForm = $(this).closest("form");
    var vId = $("[data-single-variant-input]", vForm).val();
    var recId = vForm.attr("id");
    if (recId.indexOf("product_form_items_") !== -1) {
      recId = recId.replace("product_form_items_", "");
    } else {
      recId = null;
    }
    addToCart(vId, false, recId, compareP);
  });


  var ifDeleteId = null;
  $("#cc-real-items").on("click", ".delete-item", function () {
    ifDeleteId = $(this).attr("cc-id");
    $(".confirm-delete").hide();
    $(this).siblings(".confirm-delete").show();
  });
  $("#cc-real-items").on("click", ".confirm-yes", function () {
    removeFromCart(ifDeleteId, 0, true);
    ifDeleteId = null;
  });
  $("#cc-real-items").on("click", ".confirm-no", function () {
    $(this).closest(".confirm-delete").hide();
    var resetQuant = $(this).closest(".real-item").attr("cc-quant");
    $(this).closest(".real-item").find("input").val(resetQuant);
    ifDeleteId = null;
  });

  $("#cc-real-items").on("click", ".item-dec", function () {
    var quantSelector = $(this).siblings("input");
    var currentQuant = quantSelector.val();
    if (currentQuant - 1 == 0) {
      ifDeleteId = $(this).attr("cc-id");
      $(".confirm-delete").hide();
      $(this).closest(".real-item").find(".confirm-delete").show();
    } else {
      removeFromCart($(this).attr("cc-id"), currentQuant - 1, true);
      quantSelector.val(currentQuant - 1);
      ifDeleteId = null;
    }
  });

  $("#cc-real-items").on("click", ".item-inc", function () {
    var quantSelector = $(this).siblings("input");
    var currentQuant = parseInt(quantSelector.val());
    removeFromCart($(this).attr("cc-id"), currentQuant + 1, true);
    quantSelector.val(currentQuant + 1);
  });

  $("#cc-real-items").on("blur", "input", function () {
    var currentQuant = parseInt($(this).val());
    if (currentQuant == 0) {
      ifDeleteId = $(this).siblings(".item-dec").attr("cc-id");
      $(".confirm-delete").hide();
      $(this).closest(".real-item").find(".confirm-delete").show();
    } else {
      removeFromCart(
        $(this).siblings(".item-dec").attr("cc-id"),
        currentQuant,
        true
      );
      ifDeleteId = null;
    }
  });

  $("#cc-real-items").on("click", ".expand-rx-details", function () {
    $(this).toggleClass("opened");
    $(this).siblings(".details-breakdown.mobile").slideToggle();
  });

  $("#cc-real-items").on("click", ".rx-upsell .thumbs a", function () {
    $(".rx-upsell .thumbs a").removeClass("active");
    $(this).addClass("active");
    var newId = $(this).attr("cc-variant");
    var newFrame = $(this).attr("cc-frame");
    var newMainImg = $(this).attr("data-image");
    $(this).closest(".rx-upsell-img").find("img").attr("src", newMainImg);
    var atcSelector = $(this).closest(".rx-upsell").find(".rx-upsell-atc a");
    atcSelector.attr("cc-id", newId);
    atcSelector.attr("cc-frame", newFrame);
  });

  $("#cc-real-items").on("click", ".rx-upsell .rx-upsell-atc a", function () {
    var vId = $(this).attr("cc-id");
    var cFrame = $(this).attr("cc-frame");
    addToCart(vId, false, null, null, true, cFrame);
    $(this).closest(".rx-upsell").remove();
  });

  $(".cc-sticky-cont").on("click", ".triggerRX", function (e) {
    event.preventDefault(e);
    $("#cc-real-cart-container").hide();
    // $("#rx-upload-options").show();
    // $(window).scrollTop(0);
  });

  // $(".send-later").on("click", function (e) {
  //   event.preventDefault(e);
  //   var referenceName = makeid(12);
  //   jQuery.getJSON("/cart.js", function (cart) {
  //     var itemsToUpdate = Array();
  //     cart.items.forEach((item, index) => {
  //       if (item.sku.includes("RX")) {
  //         itemsToUpdate.push({
  //           id: item.key,
  //           properties: {
  //             __prescriptionFile: referenceName,
  //             __prescriptionType: "Later",
  //           },
  //         });
  //       }
  //     });
  //     addPropertiesToLine(itemsToUpdate);
  //   });
  // });

  // $(".method__btn--upload").on("click", function () {
  //   $(".method-placeholder").hide();
  //   $(".method-typein-option").hide();
  //   $(".method-upload-option").show();
  //   $(this).addClass("active");
  //   $(".method__btn--manual").removeClass("active");
  //   searchParams = window.location.search;
  //   if (searchParams.includes("+prescription-enter")) {
  //     searchParams = searchParams.replace("+prescription-enter", "");
  //   }
  //   var newurl =
  //     window.location.protocol +
  //     "//" +
  //     window.location.host +
  //     window.location.pathname +
  //     searchParams +
  //     "+prescription-upload";
  //   if (!searchParams.includes("+prescription-upload")) {
  //     window.history.pushState({ path: newurl }, "", newurl);
  //   }
  // });

  // $(".method__btn--manual").on("click", function () {
  //   $(".method-placeholder").hide();
  //   $(".method-upload-option").hide();
  //   $(".method-typein-option").show();
  //   $(this).addClass("active");
  //   $(".method__btn--upload").removeClass("active");
  //   searchParams = window.location.search;
  //   if (searchParams.includes("+prescription-upload")) {
  //     searchParams = window.location.search.replace("+prescription-upload", "");
  //   }
  //   var newurl =
  //     window.location.protocol +
  //     "//" +
  //     window.location.host +
  //     window.location.pathname +
  //     searchParams +
  //     "+prescription-enter";
  //   if (!searchParams.includes("+prescription-enter")) {
  //     window.history.pushState({ path: newurl }, "", newurl);
  //   }
  // });

  // $("#input_5").on("change", function (event) {
  //   event.preventDefault();
  //   $("#label_5").text($("#input_5")[0].files[0].name);
  // });

  // $(".upload-pd button").on("click", function (event) {
  //   event.preventDefault();
  //   var prescPD = "Manual";
  //   var addOneUploadPD = $(".pd-combined__upload").val();

  //   if (addOneUploadPD != null) {
  //     var left_pd = (Math.round((addOneUploadPD * 100.0) / 2) / 100).toString();
  //     var right_pd = (
  //       Math.round((addOneUploadPD * 100.0) / 2) / 100
  //     ).toString();
  //   } else {
  //     var left_pd = $("#pd-left").val();
  //     var right_pd = $("#pd-right").val();
  //   }

  //   if (left_pd != null && right_pd != null) {
  //     prescPD = "";
  //   }
  //   $(".upload-pd .error").remove();
  //   if ($("#input_5").get(0).files.length == 0) {
  //     $(".upload-pd")
  //       .eq(0)
  //       .append(
  //         '<p class="error">Please upload a photo of your prescription</p>'
  //       );
  //   } else if (
  //     ($("#pd-left").attr("required") &&
  //       $("#pd-right").attr("required") &&
  //       left_pd == null) ||
  //     right_pd == null
  //   ) {
  //     if (left_pd == null && right_pd == null && addOneUploadPD == null) {
  //       $(".upload-pd")
  //         .eq(0)
  //         .append('<p class="error">Please select your PD</p>');
  //     } else if (left_pd == null) {
  //       $(".upload-pd")
  //         .eq(0)
  //         .append('<p class="error">Please select your Left PD</p>');
  //     } else if (right_pd == null) {
  //       $(".upload-pd")
  //         .eq(0)
  //         .append('<p class="error">Please select your Right PD</p>');
  //     }
  //   } else {
  //     $("#validateUpload").prop("disabled", true);
  //     // Get form
  //     $("#input_6").val(left_pd);
  //     $("#input_7").val(right_pd);
  //     var form = $("#202167252443045")[0];
  //     var sendData = new FormData(form);
  //     var referenceName = makeid(12);
  //     sendData.set("q3_referenceName", referenceName);

  //     try {
  //       fetch("https://hipaa.jotform.com/submit/202167252443045/", {
  //         method: "POST",
  //         body: sendData, // the data you want to send, as a FormData object
  //       })
  //         .then((response) => {
  //           if (!response.ok) {
  //             throw new Error("Network response was not ok");
  //           }
  //           jQuery.getJSON("/cart.js", function (cart) {
  //             var itemsToUpdate = Array();
  //             cart.items.forEach((item, index) => {
  //               if (item.sku.includes("RX")) {
  //                 itemsToUpdate.push({
  //                   id: item.key,
  //                   properties: {
  //                     __prescriptionFile: referenceName,
  //                     __prescriptionType: "Upload",
  //                   },
  //                 });
  //               }
  //             });
  //             addPropertiesToLine(itemsToUpdate);
  //           });
  //         })
  //         .catch((error) => {
  //           $("#rx-upload-options").append(
  //             '<p class="error">Unfortunately, an error has occurred while processing your request. Please try again later or contact support if the problem persists.'
  //           );
  //           console.error("Error:", error);
  //           $("#validateUpload").prop("disabled", false);
  //         });
  //     } catch (error) {
  //       $("#rx-upload-options").append(
  //         '<p class="error">Unfortunately, an error has occurred while processing your request. Please try again later or contact support if the problem persists.'
  //       );
  //       console.error("Error:", error);
  //       $("#validateUpload").prop("disabled", false);
  //     }
  //   }
  // });

  // $(".send-later-pd").on("click", function (event) {
  //   event.preventDefault();
  //   $("#validateUpload").prop("disabled", true);
  //   // Get form
  //   var form = $("#202167252443045")[0];
  //   var sendData = new FormData(form);
  //   var referenceName = makeid(12);
  //   sendData.set("q3_referenceName", referenceName);

  //   fetch("https://hipaa.jotform.com/submit/202167252443045/", {
  //     method: "POST",
  //     body: sendData, // the data you want to send, as a FormData object
  //   })
  //     .then((response) => {
  //       if (!response.ok) {
  //         throw new Error("Network response was not ok");
  //       }
  //       jQuery.getJSON("/cart.js", function (cart) {
  //         var itemsToUpdate = Array();
  //         cart.items.forEach((item, index) => {
  //           if (item.sku.includes("RX")) {
  //             itemsToUpdate.push({
  //               id: item.key,
  //               properties: {
  //                 __prescriptionFile: referenceName,
  //                 __prescriptionType: "Later",
  //               },
  //             });
  //           }
  //         });
  //         addPropertiesToLine(itemsToUpdate);
  //       });
  //     })
  //     .catch((error) => {
  //       $("#validation-form").append(
  //         '<p class="error">Unfortunately, an error has occurred while processing your request. Please try again later or contact support if the problem persists.'
  //       );
  //       $("#validateUpload").prop("disabled", false);
  //       console.error("Error:", error);
  //     });
  // });

  // if (window.location.search.includes("?contains_rx=true+prescription-enter")) {
  //   $("#rx-upload-options").show();
  //   $("#cc-real-cart-container").hide();
  //   $(".method__btn--manual").addClass("active");
  //   $(".method-typein-option").show();
  // }

  // if (
  //   window.location.search.includes("?contains_rx=true+prescription-upload")
  // ) {
  //   $("#rx-upload-options").show();
  //   $("#cc-real-cart-container").hide();
  //   $(".method__btn--upload").addClass("active");
  //   $(".method-upload-option").show();
  // }

  // $("#rx-upload-options").on("click", ".more-info.all", function () {
  //   $("#INFO_rxpop.all").show();
  // });

  // $("#rx-upload-options").on(
  //   "click",
  //   "#INFO_rxpop.all .action-close",
  //   function () {
  //     $("#INFO_rxpop.all").hide();
  //   }
  // );

  // $("#rx-upload-options").on("click", ".more-info.allpd", function () {
  //   $("#INFO_rxpop.allpd").show();
  // });

  // $("#rx-upload-options").on(
  //   "click",
  //   "#INFO_rxpop.allpd .action-close",
  //   function () {
  //     $("#INFO_rxpop.allpd").hide();
  //   }
  // );

  // const toggleBtns = document.querySelectorAll(".pd-switch");
  // let toggleNumber;

  // toggleBtns.forEach((toggle) => {
  //   toggle.addEventListener("click", function () {
  //     toggleNumber = !toggleNumber;

  //     if (toggleNumber) {
  //       document.querySelectorAll("#pd-toggle-container").forEach((el) => {
  //         el.style.clipPath = "inset(0 0 0 50%)";
  //       });

  //       document.querySelectorAll("#pd-toggle-container").forEach((el) => {
  //         el.style.backgroundColor = "#0075da";
  //       });

  //       document.querySelectorAll(".pd-add-one").forEach((el) => {
  //         el.classList.add("hidden");
  //       });

  //       document.querySelectorAll(".pd-add-divided").forEach((el) => {
  //         el.classList.remove("hidden");
  //       });

  //       document.querySelectorAll("#left-pd").forEach((el) => {
  //         el.setAttribute("required", "");
  //       });

  //       document.querySelectorAll("#pd-left").forEach((el) => {
  //         el.setAttribute("required", "");
  //       });

  //       document.querySelectorAll("#right-pd").forEach((el) => {
  //         el.setAttribute("required", "");
  //       });

  //       document.querySelectorAll("#pd-right").forEach((el) => {
  //         el.setAttribute("required", "");
  //       });

  //       document.querySelectorAll("#pd-combined").forEach((el) => {
  //         el.removeAttribute("required", "");
  //         el.selectedIndex = 0;
  //       });
  //     } else {
  //       document.querySelectorAll("#pd-toggle-container").forEach((el) => {
  //         el.style.clipPath = "inset(0 50% 0 0)";
  //       });

  //       document.querySelectorAll("#pd-toggle-container").forEach((el) => {
  //         el.style.backgroundColor = "#0075da";
  //       });

  //       document.querySelectorAll(".pd-add-one").forEach((el) => {
  //         el.classList.remove("hidden");
  //       });

  //       document.querySelectorAll(".pd-add-divided").forEach((el) => {
  //         el.classList.add("hidden");
  //       });

  //       document.querySelectorAll("#pd-combined").forEach((el) => {
  //         el.setAttribute("required", "");
  //       });

  //       document.querySelectorAll("#left-pd").forEach((el) => {
  //         el.removeAttribute("required", "");
  //       });

  //       document.querySelectorAll("#pd-left").forEach((el) => {
  //         el.removeAttribute("required", "");
  //         el.selectedIndex = 0;
  //       });

  //       document.querySelectorAll("#right-pd").forEach((el) => {
  //         el.removeAttribute("required", "");
  //       });

  //       document.querySelectorAll("#pd-right").forEach((el) => {
  //         el.removeAttribute("required", "");
  //         el.selectedIndex = 0;
  //       });
  //     }
  //   });
  // });

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  var rxValidator = {
    sphere: [3, -8],
    cylinder: [3, -3],
    power: [3, -10],
    pd: [37, 27],
    add: [3, 0.75],
  };
  function validateRX(prefix) {
    var ranges = rxValidator;
    var progressiveInCart = false;
    var rightSphere = parseFloat($(`#${prefix}right-sphere`).val());
    var rightCylinder = parseFloat($(`#${prefix}right-cylinder`).val());
    var rightPD = parseFloat($(`#${prefix}right-pd`).val());
    var rightAxis = parseFloat($(`#${prefix}right-axis`).val());
    var rightAdd = parseFloat($(`#${prefix}right-add`).val());
    var totalRightPower = rightSphere + rightCylinder;
    var leftSphere = parseFloat($(`#${prefix}left-sphere`).val());
    var leftCylinder = parseFloat($(`#${prefix}left-cylinder`).val());
    var leftPD = parseFloat($(`#${prefix}left-pd`).val());
    var leftAxis = parseFloat($(`#${prefix}left-axis`).val());
    var leftAdd = parseFloat($(`#${prefix}left-add`).val());
    var totalLeftPower = leftSphere + leftCylinder;
    var error = false;
    var errorMessage = [];
    if (
      leftSphere > ranges.sphere[0] ||
      leftSphere < ranges.sphere[1] ||
      isNaN(leftSphere)
    ) {
      error = true;
      var message =
        "<p>Left Sphere is out of range. <b>Required Range: </b>" +
        ranges.sphere[1] +
        " to " +
        ranges.sphere[0] +
        "</p>";
      errorMessage.push(message);
    }
    if (
      leftCylinder > ranges.cylinder[0] ||
      leftCylinder < ranges.cylinder[1] ||
      isNaN(leftCylinder)
    ) {
      error = true;
      var message =
        "<p>Left Cylinder is out of range. <b>Required Range: </b>" +
        ranges.cylinder[1] +
        " to " +
        ranges.cylinder[0] +
        "</p>";
      errorMessage.push(message);
    }
    /*
			if(leftPD > ranges.pd[0] || leftPD < ranges.pd[1] || isNaN(leftPD)){
				error = true;
				var message = "<p>Left PD is out of range. <b>Required Range: </b>" + ranges.pd[1] + " to " + ranges.pd[0] + "</p>"; 
				errorMessage.push(message);
			}
			*/
    if (leftAxis > 180 || leftAxis < 0 || isNaN(leftAxis)) {
      error = true;
      var message =
        "<p>Left Axis is out of range. <b>Required Range: </b>0 to 180" +
        "</p>";
      errorMessage.push(message);
    }
    if (
      totalLeftPower > ranges.power[0] ||
      totalLeftPower < ranges.power[1] ||
      isNaN(totalLeftPower)
    ) {
      error = true;
      var message =
        "<p>Left Total Power is out of range. <b>Required Range: </b>" +
        ranges.power[1] +
        " to " +
        ranges.power[0] +
        "</p>";
      errorMessage.push(message);
    }
    if (
      rightSphere > ranges.sphere[0] ||
      rightSphere < ranges.sphere[1] ||
      isNaN(rightSphere)
    ) {
      error = true;
      var message =
        "<p>Right Sphere is out of range. <b>Required Range: </b>" +
        ranges.sphere[1] +
        " to " +
        ranges.sphere[0] +
        "</p>";
      errorMessage.push(message);
    }
    if (
      rightCylinder > ranges.cylinder[0] ||
      rightCylinder < ranges.cylinder[1] ||
      isNaN(rightCylinder)
    ) {
      error = true;
      var message =
        "<p>Right Cylinder is out of range. <b>Required Range: </b>" +
        ranges.cylinder[1] +
        " to " +
        ranges.cylinder[0] +
        "</p>";
      errorMessage.push(message);
    }
    /*
		  if(rightPD > ranges.pd[0] || rightPD < ranges.pd[1] || isNaN(rightPD)){
			  error = true;
			  var message = "<p>Right PD is out of range. <b>Required Range: </b>" + ranges.pd[1] + " to " + ranges.pd[0] + "</p>"; 
			  errorMessage.push(message);
		  }
		  */
    if (rightAxis > 180 || rightAxis < 0 || isNaN(rightAxis)) {
      error = true;
      var message =
        "<p>Right Axis is out of range. <b>Required Range: </b>0 to 180" +
        "</p>";
      errorMessage.push(message);
    }
    if (
      totalRightPower > ranges.power[0] ||
      totalRightPower < ranges.power[1] ||
      isNaN(totalRightPower)
    ) {
      error = true;
      var message =
        "<p>Right Total Power is out of range. <b>Required Range: </b>" +
        ranges.power[1] +
        " to " +
        ranges.power[0] +
        "</p>";
      errorMessage.push(message);
    }
    if (progressiveInCart) {
      if (
        rightAdd > ranges.add[0] ||
        rightAdd < ranges.add[1] ||
        isNaN(rightAdd)
      ) {
        error = true;
        message =
          "<p>Right Add is out of range. <b>Required Range: </b>" +
          ranges.add[1] +
          " to " +
          ranges.add[0] +
          "</p>";
        errorMessage.push(message);
      }
      if (
        leftAdd > ranges.add[0] ||
        leftAdd < ranges.add[1] ||
        isNaN(leftAdd)
      ) {
        error = true;
        message =
          "<p>Left Add is out of range. <b>Required Range: </b>" +
          ranges.add[1] +
          " to " +
          ranges.add[0] +
          "</p>";
        errorMessage.push(message);
      }
    }
    if (error) {
      var errorHTML =
        "<li class='error'>" + "<h4>Prescription is not valid.</h4><ul>";
      var x = 0;
      for (x = 0; x < errorMessage.length; x++) {
        var tmpstr = errorMessage[x];
        errorHTML = errorHTML + "<li>" + tmpstr + "</li>";
      }
      errorHTML = errorHTML + "</ul></li>";
      var returnArray = ["error"];
      return returnArray;
    } else {
      return "success";
    }
  }

  $(".continue-prescription-btn").click(function (e) {
    const prescriptionType = $(this).closest(".input-prescription-values-wrap").attr("data-prescription-type");
    const btnRole = $(this).attr("data-btn-role");
    
    const cartItemsCount = parseInt($(this).attr("data-cart-items-count"), 10);
    const currentCartItemNo = prescriptionType == 'single' ? cartItemsCount : parseInt($(this).attr("data-cart-item-no"), 10);

    const parameter = prescriptionType == 'single' ? `${btnRole}-0-` : `${btnRole}-${currentCartItemNo}-`;
    
    var theResponse = validateRX(parameter);

    if (theResponse == "success") {
      const form = $(this).closest("form")[0];
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (btnRole == "input") {
        if (currentCartItemNo < cartItemsCount) {
          $(this).closest(".eye-prescription-values-wrap").hide();
          $(`.eye-prescription-values-wrap[data-cart-item-no="${currentCartItemNo + 1}"]`).show();
          
          $(`.cart-item-image-wrap[data-cart-item-no="${currentCartItemNo}"]`).removeClass("selected").css("display", "none");
          $(`.cart-item-image-wrap[data-cart-item-no="${currentCartItemNo + 1}"]`).addClass("selected").css("display", "flex");
  
          $(".prev-cart-item-select-btn").attr("data-prev-cart-item-no", currentCartItemNo);
          $(".next-cart-item-select-btn").attr("data-next-cart-item-no", currentCartItemNo + 2);
  
          if (currentCartItemNo > 0) {
            $(".prev-cart-item-select-btn").prop("disabled", false)
          }
          if (currentCartItemNo + 2 > cartItemsCount) {
            $(".next-cart-item-select-btn").prop("disabled", true)
          }
        } else {
          const currentStep = parseInt($(".prescription-modal-back-btn").attr("data-current-step"), 10);
          $(".prescription-modal-back-btn").attr("data-current-step", currentStep + 1);
          $(".your-prescription-container").attr("data-rx-step", currentStep + 1);

          $(".input-prescription-values-container").hide();
          $(".your-prescription-container").css("display", "flex");
        }
      } else {
        if (prescriptionType == 'single') {
          $(`.added-prescription-values-wrap[data-cart-item-no="0"]`).css("display", "flex");
          $(`.edit-validation-form[data-cart-item-no="0"]`).attr("data-removed", "false");
        } else {
          $(`.added-prescription-values-wrap[data-cart-item-no="${currentCartItemNo}"]`).css("display", "flex");
          $(`.edit-validation-form[data-cart-item-no="${currentCartItemNo}"]`).attr("data-removed", "false");
        }

        setTimeout(() => {
          $(this).closest(".edit-prescription-values-container").addClass("hidden");
        }, 200);
      }

    } else {
      $(this).closest("form").find("p.error").remove();
      $(this).closest("form").append(
        '<p class="error">Unfortunately we are unable to fulfill your prescription at this time. Please visit our <a target="_blank" href="/pages/frequentlyaskedquestions">FAQ Page</a> for more information.</p>'
      );
    }
  });

  $("#continue-payment-btn").click(async function (e) {
    e.preventDefault();
    $(this).prop("disabled", true);
    $(this).css("cursor", "not-allowed");

    const prescriptionType = $(this).attr("data-prescription-type");
    if (prescriptionType === "single") {
      const $form = $(".your-prescription-wrap[data-prescription-type='single'] form.edit-validation-form");
      if ($form.attr("data-removed") == 'true') {
        window.location.href = "/checkout";
      } else {
        var referenceName = "TY-" + makeid(9);
        $form.find(".reference-name-rx").val(referenceName);
  
        const pdToggleButton = $form.find(".pd-toggle-btn");
        let isPDl, isPDr;
        if (pdToggleButton.hasClass("toggled")) {
          var addOnePD = $form.find(".pd-combined__self").val();
          isPDl = (Math.round((addOnePD * 100.0) / 2) / 100).toString();
          isPDr = (Math.round((addOnePD * 100.0) / 2) / 100).toString();
          $form.find(".left-pd").val(isPDl);
          $form.find(".right-pd").val(isPDr);
        } else {
          isPDl = $form.find(".left-pd").val();
          isPDr = $form.find(".right-pd").val();
        }
  
        var serializedData = $form.serialize();
  
        var presPD = "Manual";
        if (isPDl !== "" && isPDr !== "" && isPDl != null && isPDr != null) {
          presPD = "";
        }
  
        try {
          $.ajax({
            type: "POST",
            url: "https://api.blenderseyewear.com/addRx",
            data: serializedData,
            success: function (data) {
              jQuery.getJSON("/cart.js", function (cart) {
                var itemsToUpdate = Array();
                cart.items.forEach((item, index) => {
                  if (item.sku.includes("RX")) {
                    itemsToUpdate.push({
                      id: item.key,
                      properties: {
                        __prescriptionFile: referenceName,
                        __prescriptionType: "Self",
                      },
                    });
                  }
                });
                addPropertiesToLine(itemsToUpdate);
              });
            },
            error: function (e) {
              $(this).prop("disabled", false);
              $(this).css("cursor", "");
              $form.append(
                '<p class="error">Unfortunately, an error has occurred while processing your request. Please try again later or contact support if the problem persists.</p>'
              );
            },
          });
        } catch (error) {
          $(this).prop("disabled", false);
          $(this).css("cursor", "");
          $form.append(
            '<p class="error">Unfortunately, an error has occurred while processing your request. Please try again later or contact support if the problem persists.</p>'
          );
        }
      }

    } else {
      const submitForms = $(".your-prescription-wrap[data-prescription-type='multiple'] form.edit-validation-form");
      let processedCount = 0;
      let successCount = 0;
      const totalForms = submitForms.length;
  
      for (const form of submitForms) {
        processedCount++;

        const $form = $(form);
        if ($form.attr("data-removed") == 'true') {
          successCount++;
          continue;
        }
        const cartItemId = $form.attr("data-cart-item-id");
  
        // console.log("cartItemId", cartItemId);
  
        var referenceName = "TY-" + makeid(9);
        $form.find(".reference-name-rx").val(referenceName);
  
        const pdToggleButton = $form.find(".pd-toggle-btn");
        let isPDl, isPDr;
        if (pdToggleButton.hasClass("toggled")) {
          var addOnePD = $form.find(".pd-combined__self").val();
          isPDl = (Math.round((addOnePD * 100.0) / 2) / 100).toString();
          isPDr = (Math.round((addOnePD * 100.0) / 2) / 100).toString();
          $form.find(".left-pd").val(isPDl);
          $form.find(".right-pd").val(isPDr);
        } else {
          isPDl = $form.find(".left-pd").val();
          isPDr = $form.find(".right-pd").val();
        }
  
        var serializedData = $form.serialize();
  
        var presPD = "Manual";
        if (isPDl !== "" && isPDr !== "" && isPDl != null && isPDr != null) {
          presPD = "";
        }
        try {
          // First API call - Add Rx
          await $.ajax({
            type: "POST",
            url: "https://api.blenderseyewear.com/addRx",
            data: serializedData,
          });
  
          // Get cart data
          const cart = await $.getJSON("/cart.js");
          
          // Check if cart and cart.items exist
          if (!cart || !cart.items || !Array.isArray(cart.items)) {
            console.error("Cart data is invalid or missing");
            $form.append(
                '<p class="error">Unable to retrieve cart information. Please try again.</p>'
            );
            continue; // Skip to next form
          }
  
          // Find the matching cart item
          const matchingItem = cart.items.find(item => cartItemId == item.id);
          if (matchingItem) {
            // console.log('Found matching item:', matchingItem);
            
            const element = {
              id: matchingItem.key,
              properties: {
                __prescriptionFile: referenceName,
                __prescriptionType: "Self",
              }
            };
  
            try {
              // Update cart
              const updatedCart = await $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: element,
                dataType: "json",
              });
              
              // console.log("Cart updated successfully:", updatedCart);
              successCount++;
            } catch (cartError) {
              console.error("Cart update failed:", cartError);
              $form.append(
                '<p class="error">Failed to update cart with prescription. Please try again.</p>'
              );
              
              // Call Shopify error handler if it exists
              if (typeof Shopify !== 'undefined' && Shopify.api && Shopify.api.onError) {
                Shopify.api.onError(cartError.responseText, cartError.statusText);
              }
            }
          } else {
            console.error("Cart item not found:", cartItemId);
            $form.append(
              '<p class="error">Cart item not found. Please refresh the page and try again.</p>'
            );
          }
        } catch (error) {
          $form.append(
            '<p class="error">Unfortunately, an error has occurred while processing your request. Please try again later or contact support if the problem persists.</p>'
          );
        }
      };
      
      // Check if this is the last form to be processed
      if (processedCount === totalForms) {
        if (successCount > 0) {
          window.location.href = "/checkout";
        } else {
          $(this).prop("disabled", false);
          $(this).css("cursor", "");
          console.error("All forms failed to process");
        }
      }
    }

  });

  $("#validation-form").on("submit", function (e) {
    e.preventDefault();
    $("#validate").prop("disabled", true);
    var theResponse = validateRX();
    $(".method-typein-option .error").remove();
    if (theResponse == "success") {
      var referenceName = "TY-" + makeid(9);
      $("#reference-name").val(referenceName);

      var addOnePD = $(".pd-combined__self").val();

      if (addOnePD != null) {
        var isPDl = (Math.round((addOnePD * 100.0) / 2) / 100).toString();
        var isPDr = (Math.round((addOnePD * 100.0) / 2) / 100).toString();
        $("#left-pd").val(isPDl);
        $("#right-pd").val(isPDr);
      } else {
        var isPDl = $("#left-pd").val();
        var isPDr = $("#right-pd").val();
      }

      var serializedData = $(this).serialize();

      // console.log('addOnePD' + addOnePD);
      // console.log('isPDl' + isPDl);
      // console.log('isPDr' + isPDr)

      var presPD = "Manual";
      if (isPDl != null && isPDr != null) {
        presPD = "";
      }
      try {
        $.ajax({
          type: "POST",
          url: "https://api.blenderseyewear.com/addRx",
          data: serializedData,
          success: function (data) {
            jQuery.getJSON("/cart.js", function (cart) {
              var itemsToUpdate = Array();
              cart.items.forEach((item, index) => {
                if (item.sku.includes("RX")) {
                  itemsToUpdate.push({
                    id: item.key,
                    properties: {
                      __prescriptionFile: referenceName,
                      __prescriptionType: "Self",
                    },
                  });
                }
              });
              addPropertiesToLine(itemsToUpdate);
            });
          },
          error: function (e) {
            $("#validate").prop("disabled", false);
            $("#validation-form").append(
              '<p class="error">Unfortunately, an error has occurred while processing your request. Please try again later or contact support if the problem persists.</p>'
            );
          },
        });
      } catch (error) {
        $("#validate").prop("disabled", false);
        $("#validation-form").append(
          '<p class="error">Unfortunately, an error has occurred while processing your request. Please try again later or contact support if the problem persists.</p>'
        );
      }
    } else {
      $("#validate").prop("disabled", false);
      $("#validation-form").append(
        '<p class="error">Unfortunately we are unable to fulfill your prescription at this time. Please visit our <a target="_blank" href="/pages/frequentlyaskedquestions">FAQ Page</a> for more information.</p>'
      );
    }
  });
});

function addPropertiesToLine(data) {
  const element = data.shift();
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: element,
    dataType: "json",
    success: function (cart) {
      if (data.length) {
        addPropertiesToLine(data);
      } else {
        window.location.href = "/checkout";
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      $("#validation-form").append(
        '<p class="error">Unfortunately, an error has occurred while processing your request. Please try again later or contact support if the problem persists.</p>'
      );
      Shopify.api.onError(XMLHttpRequest, textStatus);
    },
  });
}

function clearActive(ccList, ccClass) {
  var x;
  for (x = 0; x < ccList.length; x++) {
    ccList[x].classList.remove(ccClass);
  }
}

function resetAccordions(accordionList, accordionClass) {
  var x;
  for (x = 0; x < accordionList.length; x++) {
    accordionList[x].classList.remove(accordionClass);
    var panel = accordionList[x].nextElementSibling;
    panel.style.maxHeight = null;
  }
}


/* Announcement Bar Slider */
var notificationBarSilderInstance = new Swiper(".notification-bar__slider", {
  slidesPerView: 1,
  slidesPerGroup: 1,
  loop: true,
  autoplay: {
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".new-announcement-next",
    prevEl: ".new-announcement-prev",
  },
});

if (window.location.search == "?customer_posted=true") {
  let heroEmbeddedForm = document.querySelector(".hero-embedded-form");
  heroEmbeddedForm.classList.add("hidden");
}

// Announcement Bar Countdown
$(document).ready(function () {
  let countdownBars = document.querySelectorAll(".announcement-bar__countdown");

  [].forEach.call(countdownBars, function (countdownBar) {
    let countDownYear = countdownBar.dataset.countdownYear;
    let countDownMonth = countdownBar.dataset.countdownMonth;
    let countDownDate = countdownBar.dataset.countdownDate;
    let countDownHour = countdownBar.dataset.countdownHour;
    let countDownMinute = countdownBar.dataset.countdownMinute;
    let countDownExpired = countdownBar.dataset.countdownExpired;

    let countDownParts = (
      countDownYear +
      "-" +
      countDownMonth +
      "-" +
      countDownDate +
      "-" +
      countDownHour +
      "-" +
      countDownMinute
    ).split("-");

    let countDownFullDate = new Date(
      countDownParts[0],
      countDownParts[1] - 1,
      countDownParts[2],
      countDownParts[3],
      countDownParts[4]
    ).getTime();

    let x = setInterval(function () {
      let now = new Date().getTime();
      let distance = countDownFullDate - now;

      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      countdownBar.innerHTML =
        days + "days " + hours + "hrs " + minutes + "min " + seconds + "sec ";
      if (distance < 0) {
        clearInterval(x);
        countdownBar.innerHTML = countDownExpired;

        let announcementBarTexts = document.querySelectorAll(
          ".announcement-bar__countdown-text"
        );
        [].forEach.call(announcementBarTexts, function (announcementBarText) {
          announcementBarText.style.display = "none";
        });
      }
    }, 1000);
  });
});

// Header Nav
$(document).ready(function () {
  const default_links = document.querySelectorAll(".prevent-def");
  default_links.forEach((link) => {
    link.addEventListener("click", (e) => e.preventDefault());
  });

// Start Old Nav-bar function - DISABLED (now handled in header-v2.liquid)
  // const burger = document.getElementById("burger-button");
  // burger.addEventListener("click", (e) => {
  //   e.preventDefault();
  //   document.body.classList.toggle("nav-open");
  //   document.body.classList.remove("subnav-open");
  //   burger.classList.toggle("open");
  //   const mb_opened = document.querySelector(".header-v2 .nav-sm__link.open");
  //   if (mb_opened) {
  //     mb_opened.classList.remove("open");
  //     document.querySelectorAll(".header-v2 .ul-def li").forEach((e) => {
  //       e.removeEventListener("click");
  //     });
  //     document.querySelectorAll(".header-v2 .nav-sm__content").forEach((e) => {
  //       e.removeEventListener("touchstart");
  //       e.removeEventListener("touchend");
  //     });
  //   } else {
  //     // change content on nav click
  //     document.querySelectorAll(".header-v2 .ul-def li").forEach((e) => {
  //       e.addEventListener("click", (e) => {
  //         const href = e.currentTarget.getAttribute('data-href');
  //         if (href) {
  //           window.location.href = href;
  //           return;
  //         }
  //         e.preventDefault();
  //         document.querySelectorAll(".header-v2 .ul-def li").forEach((link) => {
  //           link.classList.remove("active");
  //         });
  //         e.currentTarget.classList.add("active");
  //         document
  //           .querySelectorAll(".header-v2 .nav-sm .nav-sm__content")
  //           .forEach((content) => {
  //             if (content.id === e.currentTarget.dataset.id)
  //               content.classList.remove("hidden");
  //             else content.classList.add("hidden");
  //           });
  //       });
  //     });
  //     // change content on swipe
  //     let touchstartX = 0;
  //     let touchendX = 0;
  //     function checkDirection() {
  //       let currentIndex = document.querySelector(
  //         ".header-v2 .ul-def .nav-sm__link.active"
  //       ).dataset.index;
  //       // swipe left
  //       if (touchendX - touchstartX < -100 && touchendX < touchstartX) {
  //         if (Number(currentIndex) !== 4)
  //           document
  //             .querySelector(
  //               '.header-v2 .ul-def .nav-sm__link[data-index="' +
  //                 (Number(currentIndex) + 1) +
  //                 '"]'
  //             )
  //             .click();
  //       }
  //       // swipe right
  //       if (touchendX - touchstartX > 100 && touchendX > touchstartX) {
  //         if (Number(currentIndex) !== 1)
  //           document
  //             .querySelector(
  //               '.header-v2 .ul-def .nav-sm__link[data-index="' +
  //                 (Number(currentIndex) - 1) +
  //                 '"]'
  //             )
  //             .click();
  //       }
  //     }
  //     document.querySelectorAll(".header-v2 .nav-sm__content").forEach((e) => {
  //       e.addEventListener("touchstart", (e) => {
  //         touchstartX = e.changedTouches[0].screenX;
  //       });
  //       e.addEventListener("touchend", (e) => {
  //         touchendX = e.changedTouches[0].screenX;
  //         checkDirection();
  //       });
  //     });
  //   }
  // });
// End Old Nav-bar function

// Start New Nav-bar function
  // const burger = $("#burger-button");
  // const mobileNavBarContainer = $("#mobile-nav-container");
  // const mobileNavBarLevel_1 = $("#mobile-nav-bar-level-1");
  // burger.on("click", function (e) {
  //   e.preventDefault();
  //   burger.toggleClass("open");
  //   if (burger.hasClass("open")) {
  //     mobileNavBarContainer.removeClass("hidden").addClass("block");
  //     setTimeout(() => {
  //       mobileNavBarLevel_1.removeClass("left-[-100vw]").addClass("left-0");
  //     }, 0);
  //   } else {
  //     mobileNavBarLevel_1.removeClass("left-0").addClass("left-[-100vw]");
  //     $("[data-sub-menu-id]").removeClass("left-0").addClass("left-[100vw]");
  //     setTimeout(() => {
  //       mobileNavBarContainer.removeClass("block").addClass("hidden");
  //     }, 500);
  //   }
  // });

  // $("[data-main-menu-id]").click(function () {
  //   const mainMenuId = $(this).attr("data-main-menu-id");
  //   mobileNavBarLevel_1.removeClass("left-0").addClass("left-[-100vw]")
  //   $(`[data-sub-menu-id="${mainMenuId}"]`).removeClass("left-[100vw]").addClass("left-0")
  // })

  // $(".close-sub-menu").click(function () {
  //   mobileNavBarLevel_1.removeClass("left-[-100vw]").addClass("left-0");
  //   $(this).parent().parent().removeClass("left-0").addClass("left-[100vw]")
  // })
// End New Nab-bar function

  const mb_links = document.querySelectorAll(".nav-sm__link");
  const mb_close_btns = document.querySelectorAll(
    ".submenu-mb__header-close-btn"
  );

  mb_links.forEach((link) => {
    link.addEventListener("click", (e) => {
      link.classList.toggle("open");
      document.body.classList.toggle("subnav-open");
    });
  });

  mb_close_btns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      const mb_opened = document.querySelector(".nav-sm__link.open");
      mb_opened.classList.remove("open");
      document.body.classList.remove("subnav-open");
    });
  });

  const subnav_openers = document.querySelectorAll(".submenu-mb__item-opener");
  subnav_openers.forEach((opener) => {
    opener.addEventListener("click", (e) => {
      opener.classList.toggle("active");
      const subnav_panel = opener.nextElementSibling;
      if (subnav_panel.style.maxHeight) {
        resetAccordions(subnav_openers, "active");
      } else {
        resetAccordions(subnav_openers, "active");
        opener.classList.add("active");
        subnav_panel.style.maxHeight = subnav_panel.scrollHeight + "px";
      }
    });
  });
});

/* Rewards hero banner welcome message + points show */
$(document).on("swell:setup", function () {
  var customerDetails = swellAPI.getCustomerDetails();

  var today = new Date();
  var time = today.getHours();
  if ($("#time-of-day").length > 0) {
    var dollarTotalTxt = 0;

    if (customerDetails.pointsBalance > 400) {
      dollarTotalTxt = 60;
    } else {
      var dollarTotal = Math.floor((customerDetails.pointsBalance / 100) * 15);
      var dollarTotalTxt = dollarTotal.toString().slice(0, -1) + "0";
    }

    if (time > 1 && time < 12) {
      $("#time-of-day").text("morning");
    } else if (time >= 12 && time <= 15) {
      $("#time-of-day").text("afternoon");
    } else {
      $("#time-of-day").text("evening");
    }

    $("#user-rewards-points").text("$" + dollarTotalTxt);
  }
});

function addABTestSlide(abTestId) {
  let slide = document.querySelector(`[data-ab-test-id="${abTestId}"]`);
  if (slide) {
    slide.classList.add("swiper-slide");
    slide.classList.remove("ab-test-slide");
    swiper.update();
    swiper.pagination.destroy(); // Destroy old pagination
    swiper.pagination.init(); // Re-initialize pagination
    swiper.pagination.update(); // Force pagination to update
    swiper.slideTo(0);
  }
}

var heroSwiperInstance = new Swiper(".hero-swiper", {
  slidesPerView: 1,
  autoplay: {
    disableOnInteraction: false,
  },
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  on: {
    init: function () {
      document
        .querySelector(".hero-swiper")
        .setAttribute("data-swiper-ready", "true");
    },
  },
});

var heroSwiperInstance = new Swiper(".hero-swiper-v3", {
  slidesPerView: 'auto',
  spaceBetween: 4,
  centeredSlides: true,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

var simpleSmoothSliderInstance = new Swiper(".simple-smooth-slider", {
  slidesPerView: "auto",
  spaceBetween: 8,
});

var featuredCollectionSliderInstance = new Swiper(
  ".featured-collection-slider",
  {
    slidesPerView: "auto",
    spaceBetween: 12,
    scrollbar: {
      el: ".swiper-list-pagination-featured-collection",
      draggable: true,
    },
    navigation: {
      nextEl: ".featured-collection-swiper-button-next",
      prevEl: ".featured-collection-swiper-button-prev",
    }
  }
);

var featuredCollectionSliderMobileInstance = new Swiper(
  ".featured-collection-slider-mobile",
  {
    slidesPerView: "auto",
    slidesPerGroup: 1,
    spaceBetween: 5
  }
);

let brandedMessageSwiperInstance;

function brandedMessageToggleSwiper() {
  const brandedMessageSwiper = document.querySelector(
    ".branded-message-slider"
  );
  if (!brandedMessageSwiper) return;

  if (window.innerWidth < 769) {
    if (!brandedMessageSwiperInstance) {
      brandedMessageSwiperInstance = new Swiper(".branded-message-slider", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
      });
    }
    $("[data-toggle-branded-messaging]").click(function () {
      if ($(this).find(">:first-child").hasClass("active")) {
        brandedMessageSwiperInstance.autoplay.stop();
        $("[data-toggle-branded-messaging] .button-play").addClass("active");
        $("[data-toggle-branded-messaging] .button-pause").removeClass(
          "active"
        );
      } else {
        brandedMessageSwiperInstance.autoplay.start();
        $("[data-toggle-branded-messaging] .button-pause").addClass("active");
        $("[data-toggle-branded-messaging] .button-play").removeClass("active");
      }
    });
  } else {
    if (brandedMessageSwiperInstance) {
      brandedMessageSwiperInstance.destroy(true, true);
      brandedMessageSwiperInstance = null;
    }
  }
}

// Initial check
brandedMessageToggleSwiper();

// Re-check on window resize
window.addEventListener("resize", brandedMessageToggleSwiper);

let quickLinkSwiperInstance;

function quickLinkToggleSwiper() {
  const quickLinkSwiper = document.querySelector(".quick-link-slider");
  if (!quickLinkSwiper) return;

  if (window.innerWidth < 769) {
    if (!quickLinkSwiperInstance) {
      quickLinkSwiperInstance = new Swiper(".quick-link-slider", {
        spaceBetween: 15,
        slidesPerView: 3,
        slidesPerGroup: 1,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    }
  } else {
    if (quickLinkSwiperInstance) {
      quickLinkSwiperInstance.destroy(true, true);
      quickLinkSwiperInstance = null;
    }
  }
}

// Initial check
quickLinkToggleSwiper();

// Re-check on window resize
window.addEventListener("resize", quickLinkToggleSwiper);

// REDO + Remove comments
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    // this.updatePickupAvailability();
    // this.removeErrorMessage();

    if (!this.currentVariant) {
      // this.toggleAddButton(true, '', true);
      // this.setUnavailable();
    } else {
      // this.updateMedia();
      this.updateProductHighlights();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      // this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  // updateMedia() {
  //   if (!this.currentVariant) return;
  //   if (!this.currentVariant.featured_media) return;

  //   const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
  //   mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

  //   const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
  //   if (!modalContent) return;
  //   const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
  //   modalContent.prepend(newMediaModal);
  // }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  // updateShareUrl() {
  //   const shareButton = document.getElementById(`Share-${this.dataset.section}`);
  //   if (!shareButton || !shareButton.updateUrl) return;
  //   shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  // }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
      // const lensMaterial = productForm.querySelector('input#lens_material');
      // if (lensMaterial) {
      // 	lensMaterial.name = 'properties['+this.currentVariant.title+']';
      // 	lensMaterial.dispatchEvent(new Event('change', { bubbles: true }));
      // }
    });
  }

  updateProductHighlights() {
    const iconsWrap = document.querySelector(".sunglasses-icons__wrap");
    const lensTypesBtns = document.querySelectorAll(".lens-type_select");

    if (iconsWrap && lensTypesBtns) {
      lensTypesBtns.forEach((btn) => {
        btn.checked
          ? iconsWrap.classList.add(
              "option_selected--" + this.currentVariant.title.toLowerCase()
            )
          : iconsWrap.classList.remove(
              "option_selected--" + btn.value.toLowerCase()
            );
      });
    }
  }

  // updatePickupAvailability() {
  //   const pickUpAvailability = document.querySelector('pickup-availability');
  //   if (!pickUpAvailability) return;

  //   if (this.currentVariant && this.currentVariant.available) {
  //     pickUpAvailability.fetchAvailability(this.currentVariant.id);
  //   } else {
  //     pickUpAvailability.removeAttribute('available');
  //     pickUpAvailability.innerHTML = '';
  //   }
  // }

  // removeErrorMessage() {
  //   const section = this.closest('section');
  //   if (!section) return;

  //   const productForm = section.querySelector('product-form');
  //   if (productForm) productForm.handleErrorMessage();
  // }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;
        const badgeSaleWrap = document.querySelector(".product-badge--sale");
        if (badgeSaleWrap) {
          if (this.currentVariant.compare_at_price) {
            badgeSaleWrap.classList.remove("hidden");
          } else {
            badgeSaleWrap.classList.add("hidden");
          }
        }
        // const price = document.getElementById(`price-${this.dataset.section}`);

        // if (price) price.classList.remove('visibility-hidden');
        // this.toggleAddButton(!this.currentVariant.available, '');
      })
      .then(() => {
        Flow.variants.localize();
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const notifyMeButton = document.getElementById("BISC_trigger");
    const shopifyPayment = productForm.querySelector(
      '[data-shopify="payment-button"]'
    );

    if (!addButton) return;

    if (!this.currentVariant.available) {
      notifyMeButton.style.display = "block";
      notifyMeButton.classList.remove("hidden");
      addButton.classList.add("hidden");
      if (shopifyPayment) {
        shopifyPayment.style.display = "none";
      }
    } else {
      notifyMeButton.style.display = "none";
      notifyMeButton.classList.add("hidden");
      addButton.classList.remove("hidden");
      if (shopifyPayment) {
        shopifyPayment.style.display = "block";
      }
    }

    if (!modifyClass) return;
  }

  // setUnavailable() {
  //   const button = document.getElementById(`product-form-${this.dataset.section}`);
  //   const addButton = button.querySelector('[name="add"]');
  //   const addButtonText = button.querySelector('[name="add"] > span');
  //   const price = document.getElementById(`price-${this.dataset.section}`);
  //   if (!addButton) return;
  //   addButtonText.textContent = window.variantStrings.unavailable;
  //   if (price) price.classList.add('visibility-hidden');
  // }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

//const hoverItems = document.querySelectorAll('.cc-collection-item.item-hover .featured-container');
//if (hoverItems) {
//	hoverItems.forEach(item => {
//		item.addEventListener('touchstart', (e) => {
//			item.classList.add('on-touch');
//			item.addEventListener('click', (event) => {
//				event.preventDefault();
//				window.location.replace(item.getAttribute('href'));
//			});
//		});
//		item.addEventListener('touchend', (e) => {
//			item.classList.remove('on-touch');
//		})
//	})
//}

//Attentive form submit
const attentiveForms = document.querySelectorAll("#attentiveForm");
const attentiveInputs = document.querySelectorAll(
  ".footer__email-submit-wrap input"
);
if (attentiveInputs.length > 0) {
  attentiveInputs.forEach((input) => {
    input.addEventListener("click", (e) => {
      e.preventDefault();
      input.parentElement.classList.add("active");
      const html = document.querySelector("html");
      html.addEventListener("click", function (e) {
        if (e.target !== input && !input.value)
          input.parentElement.classList.remove("active");
      });
    });
  });
}
if (attentiveForms) {
  attentiveForms.forEach((form) => {
    const zapierPath = form.dataset.zapierPath;
    const zapierID = form.dataset.zapierId;
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const formData = new FormData(form);
      fetch(
        "https://hooks.zapier.com/hooks/catch/" +
          zapierPath +
          "/" +
          zapierID +
          "/",
        {
          method: "post",
          body: formData,
        }
      )
        .then((response) => response.json())
        .then((text) => form.classList.add("form-submitted"))
        .catch((error) => console.error(error));
    });
  });
}

const targetNode = document.querySelector("#country-picker");
if (targetNode) {
  let flowDatasetModified = false;
  // Options for the observer (which mutations to observe)
  const config = { attributes: true, childList: true, subtree: true };
  // Callback function to execute when mutations are observed
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "attributes") {
        const flowDataNZSelector = document.querySelector(
          '[data-value="NLD_EUR"]'
        );
        if (flowDataNZSelector) {
          flowDataNZSelector.dataset.value = "unlink_flow";
          flowDataNZSelector.href =
            "https:" +
            "//" +
            "blenderseyewear.co.nz" +
            window.location.pathname;
        }
        flowDatasetModified = true;
      }
    }
  };
  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);
  // Start observing
  observer.observe(targetNode, config);
  // Stop observing
  if (flowDatasetModified) {
    observer.disconnect();
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // Function to get the current country from Shopify Geolocation app
  function getCountry() {
    return new Promise((resolve, reject) => {
      if (
        typeof Shopify !== "undefined" &&
        Shopify.Geolocation &&
        Shopify.Geolocation.country
      ) {
        resolve(Shopify.Geolocation.country);
      } else {
        reject("Country not found");
      }
    });
  }

  // Redirect based on country
  getCountry()
    .then((currentCountry) => {
      if (currentCountry === "NZ") {
        let newURL = "https://blenderseyewear.co.nz" + window.location.pathname;
        window.location.replace(newURL);
      }
    })
    .catch((error) => {
      console.log(error);
    });
});

function rebuyMiniCartWidgetShowVariantModal(flag, productId, e) {
  $(".rebuy-product-options").hide();
  flag == 1
    ? $(
        `.rebuy-product-options[data-bundle-product-id='${productId}']`
      ).fadeIn()
    : $(
        `.rebuy-product-options[data-accessories-product-id='${productId}']`
      ).fadeIn();
  $(".rebuy-cart__flyout__background").fadeIn();
  e.stopPropagation();
}

function rebuyMiniCartWidgetHideVariantModal() {
  $(".rebuy-product-options").fadeOut();
  $(".rebuy-cart__flyout__background").fadeOut();
}

const mediaSwiper = (widgetNumber) => {
  const sliderList = document.querySelectorAll(
    `.products-list-swiper-${widgetNumber} .rebuy-product-media`
  );
  sliderList.forEach((slider, index, sliders) => {
    new Swiper(slider, {
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  });
};

function productListSwiper(widgetNumber) {
  const swiperSelector = `.products-list-swiper-${widgetNumber}`;
  const paginationSelector = `.swiper-list-pagination-${widgetNumber}`;

  new Swiper(swiperSelector, {
    slidesPerView: "auto",
    slidesPerGroup: 1,
    spaceBetween: 8,
    scrollbar: {
      el: paginationSelector,
      draggable: true,
    },
    navigation: {
      nextEl: `.next-button-${widgetNumber}`,
      prevEl: `.prev-button-${widgetNumber}`,
    },
    breakpoints: {
      768: {
        spaceBetween: 12,
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
    },
  });
}

var homeDoubleCtaSliderInstance = new Swiper(".home-double-cta-slider", {
  slidesPerView: "auto",
  slidesPerGroup: 1,
  spaceBetween: 5
});

document.querySelectorAll(".home-collection-swiper-container").forEach(container => {
  const sectionId = container.getAttribute("data-section-id");
  const mobileLayout = container.getAttribute("data-mobile-layout");
  const swiperEl = container.querySelector(`.home-collection-swiper-${sectionId}`);
  if (swiperEl) {
    if (mobileLayout == 'slider') {
      new Swiper(`.home-collection-swiper-${sectionId}`, {
        slidesPerView: "auto",
        slidesPerGroup: 1,
        spaceBetween: 8,
        navigation: {
          nextEl: container.querySelector(`.home-collection-button-next-${sectionId}`),
          prevEl: container.querySelector(`.home-collection-button-prev-${sectionId}`),
        },
        breakpoints: {
          768: {
            spaceBetween: 12,
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        },
      });
    } else {
      new Swiper(`.home-collection-swiper-${sectionId}`, {
        enabled: false,
        breakpoints: {
          768: {
            enabled: true,
            spaceBetween: 12,
            slidesPerView: 6,
            slidesPerGroup: 6,
            navigation: {
              nextEl: container.querySelector(`.home-collection-button-next-${sectionId}`),
              prevEl: container.querySelector(`.home-collection-button-prev-${sectionId}`),
            },
          },
        },
      });
    }
  }
});

new Swiper(".product-image-swiper", {
  slidesPerView: 1,
  pagination: {
    el: ".product-image-swiper-pagination",
    clickable: true,
  },
});

$(document).on('click', '[data-color-product-id]', function () {
  const productId = $(this).attr('data-color-product-id');
  const mainProduct = $(`[data-product-id-on-collection="${productId}"]`);
  mainProduct.removeClass('hidden').addClass('block').siblings().removeClass('block').addClass('hidden');
  const productInfo = $(`[data-product-id-for-detail-info="${productId}"]`);
  productInfo.removeClass('hidden').addClass('block').siblings().removeClass('block').addClass('hidden');
  $(this)
    .addClass('ring-2 ring-black ring-offset-2 shadow-[0_0_8px_2px_rgba(0,0,0,0.25)]')
    .siblings()
    .removeClass('ring-2 ring-black ring-offset-2 shadow-[0_0_8px_2px_rgba(0,0,0,0.25)]');
});